const mock_recipient_episodes_of_care = {
  resourceType: "Bundle",
  type: "searchset",
  total: 1,
  link: [
    {
      relation: "self",
      url: "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare?patient=TK8ubh9iKIhZtIpBirKZfEAL7xP-B04MxP3vZoYfrrnwB&type=urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130%7C4&status=active",
    },
  ],
  entry: [
    {
      link: [
        {
          relation: "self",
          url: "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/exqtC8q0VjpjgnwtPxSBdtQ3",
        },
      ],
      fullUrl:
        "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/exqtC8q0VjpjgnwtPxSBdtQ3",
      resource: {
        resourceType: "EpisodeOfCare",
        id: "exqtC8q0VjpjgnwtPxSBdtQ3",
        extension: [
          {
            valueString: "Kidney Transplant Referral - 9/5/2024",
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name",
          },
          {
            valueCodeableConcept: {
              coding: [
                {
                  system: "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                  code: "2",
                  display: "Recipient",
                },
              ],
              text: "Recipient",
            },
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient",
          },
          {
            extension: [
              {
                valueCodeableConcept: {
                  coding: [
                    {
                      system:
                        "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                      code: "16",
                      display: "Kidney",
                    },
                  ],
                  text: "Kidney",
                },
                url: "organ-class",
              },
              {
                valueReference: {
                  reference:
                    "Practitioner/egdmEZfQprtaIOyol25BVo1XR9ugRfm1-UQXvsO0oQ-43",
                  type: "Practitioner",
                  display: "Jennifer Velupillai, RN",
                },
                url: "coordinator",
              },
            ],
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator",
          },
          {
            extension: [
              {
                valueCodeableConcept: {
                  coding: [
                    {
                      system:
                        "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                      code: "10",
                      display: "Referral",
                    },
                  ],
                  text: "Referral",
                },
                url: "phase",
              },
              {
                valueString: "Active",
                url: "status",
              },
              {
                valueString: "Accepted",
                url: "reason",
              },
              {
                valueDate: "2024-05-09",
                url: "effective",
              },
            ],
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status",
          },
          {
            valueDate: "2024-05-09",
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date",
          },
          {
            valueString: "St. Joseph's Healthcare Hamilton (Hamilton, ON)",
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center",
          },
        ],
        status: "active",
        type: [
          {
            coding: [
              {
                system: "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
                code: "49",
                display: "Transplant",
              },
              {
                system: "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
                code: "4",
                display: "Transplant",
              },
            ],
            text: "Transplant",
          },
        ],
        patient: {
          reference: "Patient/ee32WyakHGVPqiGDtEgFRqg3",
          type: "Patient",
          display: "TestOne, VirologyOneWaitlist Kingthree",
        },
        period: {
          start: "2024-05-09",
        },
        team: [
          {
            reference: "CareTeam/e.Uj.9UaIvgjfhnHkIf1K1nxo8DU0GDJzERZ8AJKabBQ3",
            type: "CareTeam",
          },
        ],
      },
      search: {
        mode: "match",
      },
    },
    {
      link: [
        {
          relation: "self",
          url: "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/exqtC8q0VjpjgnwtPxSBdtQ3",
        },
      ],
      fullUrl:
        "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/exqtC8q0VjpjgnwtPxSBdtQ3",
      resource: {
        resourceType: "EpisodeOfCare",
        id: "ffffffffffffffffff",
        extension: [
          {
            valueString: "Kidney Transplant Referral - 8/1/2024",
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name",
          },
          {
            valueCodeableConcept: {
              coding: [
                {
                  system: "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                  code: "2",
                  display: "Recipient",
                },
              ],
              text: "Recipient",
            },
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient",
          },
          {
            extension: [
              {
                valueCodeableConcept: {
                  coding: [
                    {
                      system:
                        "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                      code: "16",
                      display: "Kidney",
                    },
                  ],
                  text: "Kidney",
                },
                url: "organ-class",
              },
              {
                valueReference: {
                  reference:
                    "Practitioner/egdmEZfQprtaIOyol25BVo1XR9ugRfm1-UQXvsO0oQ-43",
                  type: "Practitioner",
                  display: "Jennifer Velupillai, RN",
                },
                url: "coordinator",
              },
            ],
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator",
          },
          {
            extension: [
              {
                valueCodeableConcept: {
                  coding: [
                    {
                      system:
                        "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                      code: "10",
                      display: "Referral",
                    },
                  ],
                  text: "Referral",
                },
                url: "phase",
              },
              {
                valueString: "Active",
                url: "status",
              },
              {
                valueString: "Accepted",
                url: "reason",
              },
              {
                valueDate: "2024-05-09",
                url: "effective",
              },
            ],
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status",
          },
          {
            valueDate: "2024-05-09",
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date",
          },
          {
            valueString: "St. Joseph's Healthcare Hamilton (Hamilton, ON)",
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center",
          },
        ],
        status: "active",
        type: [
          {
            coding: [
              {
                system: "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
                code: "49",
                display: "Transplant",
              },
              {
                system: "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
                code: "4",
                display: "Transplant",
              },
            ],
            text: "Transplant",
          },
        ],
        patient: {
          reference: "Patient/ee32WyakHGVPqiGDtEgFRqg3",
          type: "Patient",
          display: "TestOne, VirologyOneWaitlist Kingthree",
        },
        period: {
          start: "2024-05-09",
        },
        team: [
          {
            reference: "CareTeam/e.Uj.9UaIvgjfhnHkIf1K1nxo8DU0GDJzERZ8AJKabBQ3",
            type: "CareTeam",
          },
        ],
      },
      search: {
        mode: "match",
      },
    },
  ],
};

const mock_donor_episodes_of_care = {
  resourceType: "Bundle",
  type: "searchset",
  total: 1,
  link: [
    {
      relation: "self",
      url: "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare?patient=TPOUFHrnSp1nyB54DoKJbJrSU7Kgfi0YnF1oqHAIeEfgB&type=urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130|4",
    },
  ],
  entry: [
    {
      link: [
        {
          relation: "self",
          url: "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/eHoAunDtjEHdrQcuQhNgA-Q3",
        },
      ],
      fullUrl:
        "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/eHoAunDtjEHdrQcuQhNgA-Q3",
      resource: {
        resourceType: "EpisodeOfCare",
        id: "eHoAunDtjEHdrQcuQhNgA-Q3",
        extension: [
          {
            valueString: "Kidney Donor Referral - 13/9/2024",
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name",
          },
          {
            valueCodeableConcept: {
              coding: [
                {
                  system: "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                  code: "1",
                  display: "Donor",
                },
              ],
              text: "Donor",
            },
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient",
          },
          {
            extension: [
              {
                valueCodeableConcept: {
                  coding: [
                    {
                      system:
                        "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                      code: "16",
                      display: "Kidney",
                    },
                  ],
                  text: "Kidney",
                },
                url: "organ-class",
              },
              {
                valueReference: {
                  reference:
                    "Practitioner/eLEavf4IPOCgFXBunI-92x3jMbMB4H30c4MkrjP3IraI3",
                  type: "Practitioner",
                  display: "Michelle Richter",
                },
                url: "coordinator",
              },
            ],
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator",
          },
          {
            extension: [
              {
                valueCodeableConcept: {
                  coding: [
                    {
                      system:
                        "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                      code: "10",
                      display: "Referral",
                    },
                  ],
                  text: "Referral",
                },
                url: "phase",
              },
              {
                valueString: "Active",
                url: "status",
              },
              {
                valueDate: "2024-09-13",
                url: "effective",
              },
            ],
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status",
          },
          {
            valueDate: "2024-09-13",
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date",
          },
          {
            valueString: "St. Joseph's Healthcare Hamilton (Hamilton, ON)",
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center",
          },
        ],
        status: "active",
        type: [
          {
            coding: [
              {
                system: "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
                code: "49",
                display: "Transplant",
              },
              {
                system: "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
                code: "4",
                display: "Transplant",
              },
            ],
            text: "Transplant",
          },
        ],
        patient: {
          reference: "Patient/e6n18sZacMpSAByfiE8Ph-Q3",
          type: "Patient",
          display: "OneOATS, DonorEpic",
        },
        period: {
          start: "2024-09-15",
        },
        team: [
          {
            reference: "CareTeam/eeDu6CGEUzDdeaRHRE8r0N50YMgww0LDk126pbIBfjZ43",
            type: "CareTeam",
          },
        ],
      },
      search: {
        mode: "match",
      },
    },
  ],
};
const mock_donor_and_recipient_EOC = {
  "resourceType": "Bundle",
  "type": "searchset",
  "total": 11,
  "link": [
    {
      "relation": "self",
      "url": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare?patient=TcNLDD43.rRgWdRGcqBsh5Qto5aRBxhoyrZADHldKBmUB&type=urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130|4"
    }
  ],
  "entry": [
    // {
    //   "link": [
    //     {
    //       "relation": "self",
    //       "url": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/eJBgn.R9kvGSFAJLxeHZRpA3"
    //     }
    //   ],
    //   "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/eJBgn.R9kvGSFAJLxeHZRpA3",
    //   "resource": {
    //     "resourceType": "EpisodeOfCare",
    //     "id": "eJBgn.R9kvGSFAJLxeHZRpA3",
    //     "extension": [
    //       {
    //         "valueString": "Kidney Transplant - 7/8/2024 - Not Followed  (#1)",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
    //       },
    //       {
    //         "valueCodeableConcept": {
    //           "coding": [
    //             {
    //               "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
    //               "code": "2",
    //               "display": "Recipient"
    //             }
    //           ],
    //           "text": "Recipient"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
    //                   "code": "16",
    //                   "display": "Kidney"
    //                 }
    //               ],
    //               "text": "Kidney"
    //             },
    //             "url": "organ-class"
    //           },
    //           {
    //             "valueReference": {
    //               "reference": "Practitioner/egdmEZfQprtaIOyol25BVo1XR9ugRfm1-UQXvsO0oQ-43",
    //               "type": "Practitioner",
    //               "display": "Jennifer Velupillai, RN"
    //             },
    //             "url": "coordinator"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
    //                   "code": "50",
    //                   "display": "Transplanted"
    //                 }
    //               ],
    //               "text": "Transplanted"
    //             },
    //             "url": "phase"
    //           },
    //           {
    //             "valueString": "Not Followed",
    //             "url": "status"
    //           },
    //           {
    //             "valueString": "Patient Died",
    //             "url": "reason"
    //           },
    //           {
    //             "valueDate": "2024-08-08",
    //             "url": "effective"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
    //       },
    //       {
    //         "valueDate": "2024-08-01",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
    //       },
    //       {
    //         "valuePeriod": {
    //           "start": "2024-08-02",
    //           "end": "2024-08-03"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-evaluation"
    //       },
    //       {
    //         "valueDate": "2024-08-03",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-center-waitlist-date"
    //       },
    //       {
    //         "valueDate": "2024-08-03",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-waitlist-date"
    //       },
    //       {
    //         "valueDate": "2024-08-07",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-transplanted-date"
    //       },
    //       {
    //         "valueString": "St. Joseph's Healthcare Hamilton (Hamilton, ON)",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
    //       },
    //       {
    //         "valueReference": {
    //           "reference": "BodyStructure/efZZmZ3ZD28PoDcjdCpPVMjue-lEypIrY63lv5uGMrsBbvacP0sKOCgnGVoAw2-Ed3",
    //           "type": "BodyStructure",
    //           "display": "Right Kidney"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ"
    //       }
    //     ],
    //     "status": "finished",
    //     "type": [
    //       {
    //         "coding": [
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
    //             "code": "49",
    //             "display": "Transplant"
    //           },
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
    //             "code": "4",
    //             "display": "Transplant"
    //           }
    //         ],
    //         "text": "Transplant"
    //       }
    //     ],
    //     "patient": {
    //       "reference": "Patient/euIfIDVBfPh845vh4p482Ig3",
    //       "type": "Patient",
    //       "display": "Phxtst, Hyperdrive"
    //     },
    //     "period": {
    //       "start": "2024-09-08",
    //       "end": "2024-09-08"
    //     },
    //     "team": [
    //       {
    //         "reference": "CareTeam/eDUEQVefZY4noM2gKQRAoWL0iVqzOshzUiMZCS6tOM8I3",
    //         "type": "CareTeam"
    //       }
    //     ]
    //   },
    //   "search": {
    //     "mode": "match"
    //   }
    // },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/e1ZS.CP.TTP-eKsTwXxumUQ3"
        }
      ],
      "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/e1ZS.CP.TTP-eKsTwXxumUQ3",
      "resource": {
        "resourceType": "EpisodeOfCare",
        "id": "e1ZS.CP.TTP-eKsTwXxumUQ3",
        "extension": [
          {
            "valueString": "Kidney Donor Referral - 24/7/2024",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
          },
          {
            "valueCodeableConcept": {
              "coding": [
                {
                  "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                  "code": "1",
                  "display": "Donor"
                }
              ],
              "text": "Donor"
            },
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                      "code": "16",
                      "display": "Kidney"
                    }
                  ],
                  "text": "Kidney"
                },
                "url": "organ-class"
              },
              {
                "valueReference": {
                  "reference": "Practitioner/eTZruHD5aMHHy3hOfPmQbbw3",
                  "type": "Practitioner",
                  "display": "Coordinator Phoenix, RN"
                },
                "url": "coordinator"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                      "code": "10",
                      "display": "Referral"
                    }
                  ],
                  "text": "Referral"
                },
                "url": "phase"
              },
              {
                "valueString": "Active",
                "url": "status"
              },
              {
                "valueDate": "2024-07-24",
                "url": "effective"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
          },
          {
            "valueDate": "2024-07-24",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
          },
          {
            "valueString": "St. Joseph's Healthcare Hamilton (Hamilton, ON)",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
          }
        ],
        "status": "active",
        "type": [
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
                "code": "49",
                "display": "Transplant"
              },
              {
                "system": "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
                "code": "4",
                "display": "Transplant"
              }
            ],
            "text": "Transplant"
          }
        ],
        "patient": {
          "reference": "Patient/euIfIDVBfPh845vh4p482Ig3",
          "type": "Patient",
          "display": "Phxtst, Hyperdrive"
        },
        "period": {
          "start": "2024-07-24"
        },
        "team": [
          {
            "reference": "CareTeam/eDUEQVefZY4noM2gKQRAoWIAec9e9Kp9NYqLlyt9.nM43",
            "type": "CareTeam"
          }
        ]
      },
      "search": {
        "mode": "match"
      }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/etfWDFBSL7oJSuf.ZunY4ig3"
        }
      ],
      "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/etfWDFBSL7oJSuf.ZunY4ig3",
      "resource": {
        "resourceType": "EpisodeOfCare",
        "id": "etfWDFBSL7oJSuf.ZunY4ig3",
        "extension": [
          {
            "valueString": "Kidney Transplant Referral - 10/7/2024",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
          },
          {
            "valueCodeableConcept": {
              "coding": [
                {
                  "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                  "code": "2",
                  "display": "Recipient"
                }
              ],
              "text": "Recipient"
            },
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                      "code": "16",
                      "display": "Kidney"
                    }
                  ],
                  "text": "Kidney"
                },
                "url": "organ-class"
              },
              {
                "valueReference": {
                  "reference": "Practitioner/eTZruHD5aMHHy3hOfPmQbbw3",
                  "type": "Practitioner",
                  "display": "Coordinator Phoenix, RN"
                },
                "url": "coordinator"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                      "code": "10",
                      "display": "Referral"
                    }
                  ],
                  "text": "Referral"
                },
                "url": "phase"
              },
              {
                "valueString": "Active",
                "url": "status"
              },
              {
                "valueDate": "2024-08-13",
                "url": "effective"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
          },
          {
            "valueDate": "2024-07-10",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
          },
          {
            "valueString": "St. Joseph's Healthcare Hamilton (Hamilton, ON)",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
          }
        ],
        "status": "active",
        "type": [
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
                "code": "49",
                "display": "Transplant"
              },
              {
                "system": "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
                "code": "4",
                "display": "Transplant"
              }
            ],
            "text": "Transplant"
          }
        ],
        "diagnosis": [
          {
            "condition": {
              "reference": "Condition/eQ7Nr28rYNpIBYMvaD1Lwcw3",
              "type": "Condition",
              "display": "CKD (chronic kidney disease)"
            }
          }
        ],
        "patient": {
          "reference": "Patient/euIfIDVBfPh845vh4p482Ig3",
          "type": "Patient",
          "display": "Phxtst, Hyperdrive"
        },
        "period": {
          "start": "2024-07-10"
        },
        "team": [
          {
            "reference": "CareTeam/eDUEQVefZY4noM2gKQRAoWNzGjo9cAO26fG1ehCe1MjU3",
            "type": "CareTeam"
          }
        ]
      },
      "search": {
        "mode": "match"
      }
    },
    // {
    //   "link": [
    //     {
    //       "relation": "self",
    //       "url": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/e7U4kq8myhJpJRF-RmoFxvg3"
    //     }
    //   ],
    //   "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/e7U4kq8myhJpJRF-RmoFxvg3",
    //   "resource": {
    //     "resourceType": "EpisodeOfCare",
    //     "id": "e7U4kq8myhJpJRF-RmoFxvg3",
    //     "extension": [
    //       {
    //         "valueString": "Kidney Transplant Referral - 10/7/2024",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
    //       },
    //       {
    //         "valueCodeableConcept": {
    //           "coding": [
    //             {
    //               "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
    //               "code": "2",
    //               "display": "Recipient"
    //             }
    //           ],
    //           "text": "Recipient"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
    //                   "code": "16",
    //                   "display": "Kidney"
    //                 }
    //               ],
    //               "text": "Kidney"
    //             },
    //             "url": "organ-class"
    //           },
    //           {
    //             "valueReference": {
    //               "reference": "Practitioner/eizqfOoqat9nXDsTJWcT-ZLrXKoZRf-SbW6DZPJCr1Lw3",
    //               "type": "Practitioner",
    //               "display": "Jackie Gamble, RPN"
    //             },
    //             "url": "coordinator"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
    //                   "code": "10",
    //                   "display": "Referral"
    //                 }
    //               ],
    //               "text": "Referral"
    //             },
    //             "url": "phase"
    //           },
    //           {
    //             "valueString": "Active",
    //             "url": "status"
    //           },
    //           {
    //             "valueDate": "2024-07-10",
    //             "url": "effective"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
    //       },
    //       {
    //         "valueDate": "2024-07-10",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
    //       },
    //       {
    //         "valueString": "St. Joseph's Healthcare Hamilton (Hamilton, ON)",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
    //       }
    //     ],
    //     "status": "cancelled",
    //     "type": [
    //       {
    //         "coding": [
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
    //             "code": "49",
    //             "display": "Transplant"
    //           },
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
    //             "code": "4",
    //             "display": "Transplant"
    //           }
    //         ],
    //         "text": "Transplant"
    //       }
    //     ],
    //     "patient": {
    //       "reference": "Patient/euIfIDVBfPh845vh4p482Ig3",
    //       "type": "Patient",
    //       "display": "Phxtst, Hyperdrive"
    //     },
    //     "period": {
    //       "start": "2024-07-10"
    //     },
    //     "team": [
    //       {
    //         "reference": "CareTeam/eDUEQVefZY4noM2gKQRAoWG1yRaxdiP.6jCBbfCT9s7A3",
    //         "type": "CareTeam"
    //       }
    //     ]
    //   },
    //   "search": {
    //     "mode": "match"
    //   }
    // },
    // {
    //   "link": [
    //     {
    //       "relation": "self",
    //       "url": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/ebSLpyLqDE92opoNBDhZ48A3"
    //     }
    //   ],
    //   "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/ebSLpyLqDE92opoNBDhZ48A3",
    //   "resource": {
    //     "resourceType": "EpisodeOfCare",
    //     "id": "ebSLpyLqDE92opoNBDhZ48A3",
    //     "extension": [
    //       {
    //         "valueString": "Kidney Donor Referral - 21/6/2024",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
    //       },
    //       {
    //         "valueCodeableConcept": {
    //           "coding": [
    //             {
    //               "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
    //               "code": "1",
    //               "display": "Donor"
    //             }
    //           ],
    //           "text": "Donor"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
    //                   "code": "16",
    //                   "display": "Kidney"
    //                 }
    //               ],
    //               "text": "Kidney"
    //             },
    //             "url": "organ-class"
    //           },
    //           {
    //             "valueReference": {
    //               "reference": "Practitioner/eLEavf4IPOCgFXBunI-92x3jMbMB4H30c4MkrjP3IraI3",
    //               "type": "Practitioner",
    //               "display": "Michelle Richter"
    //             },
    //             "url": "coordinator"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
    //                   "code": "10",
    //                   "display": "Referral"
    //                 }
    //               ],
    //               "text": "Referral"
    //             },
    //             "url": "phase"
    //           },
    //           {
    //             "valueString": "Active",
    //             "url": "status"
    //           },
    //           {
    //             "valueDate": "2024-06-21",
    //             "url": "effective"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
    //       },
    //       {
    //         "valueDate": "2024-06-21",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
    //       },
    //       {
    //         "valueString": "St. Joseph's Healthcare Hamilton (Hamilton, ON)",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
    //       }
    //     ],
    //     "status": "cancelled",
    //     "type": [
    //       {
    //         "coding": [
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
    //             "code": "49",
    //             "display": "Transplant"
    //           },
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
    //             "code": "4",
    //             "display": "Transplant"
    //           }
    //         ],
    //         "text": "Transplant"
    //       }
    //     ],
    //     "patient": {
    //       "reference": "Patient/euIfIDVBfPh845vh4p482Ig3",
    //       "type": "Patient",
    //       "display": "Phxtst, Hyperdrive"
    //     },
    //     "period": {
    //       "start": "2024-06-21"
    //     },
    //     "team": [
    //       {
    //         "reference": "CareTeam/eDUEQVefZY4noM2gKQRAoWCqEd65QD5HrE.y9-UI-Np83",
    //         "type": "CareTeam"
    //       }
    //     ]
    //   },
    //   "search": {
    //     "mode": "match"
    //   }
    // },
    // {
    //   "link": [
    //     {
    //       "relation": "self",
    //       "url": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/eQNAhWxmPZqWTn0QyKMsXag3"
    //     }
    //   ],
    //   "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/eQNAhWxmPZqWTn0QyKMsXag3",
    //   "resource": {
    //     "resourceType": "EpisodeOfCare",
    //     "id": "eQNAhWxmPZqWTn0QyKMsXag3",
    //     "extension": [
    //       {
    //         "valueString": "Kidney Transplant Referral - 10/6/2024",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
    //       },
    //       {
    //         "valueCodeableConcept": {
    //           "coding": [
    //             {
    //               "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
    //               "code": "2",
    //               "display": "Recipient"
    //             }
    //           ],
    //           "text": "Recipient"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
    //                   "code": "16",
    //                   "display": "Kidney"
    //                 }
    //               ],
    //               "text": "Kidney"
    //             },
    //             "url": "organ-class"
    //           },
    //           {
    //             "valueReference": {
    //               "reference": "Practitioner/e6zs7QnhOHCa9Td08H6Y8MF4G-UvFNh0wg85S4XIH0Vc3",
    //               "type": "Practitioner",
    //               "display": "Jennifer Donnelly"
    //             },
    //             "url": "coordinator"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
    //                   "code": "10",
    //                   "display": "Referral"
    //                 }
    //               ],
    //               "text": "Referral"
    //             },
    //             "url": "phase"
    //           },
    //           {
    //             "valueString": "Active",
    //             "url": "status"
    //           },
    //           {
    //             "valueDate": "2024-06-10",
    //             "url": "effective"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
    //       },
    //       {
    //         "valueDate": "2024-06-10",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
    //       },
    //       {
    //         "valueString": "St. Joseph's Healthcare Hamilton (Hamilton, ON)",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
    //       }
    //     ],
    //     "status": "cancelled",
    //     "type": [
    //       {
    //         "coding": [
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
    //             "code": "49",
    //             "display": "Transplant"
    //           },
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
    //             "code": "4",
    //             "display": "Transplant"
    //           }
    //         ],
    //         "text": "Transplant"
    //       }
    //     ],
    //     "patient": {
    //       "reference": "Patient/euIfIDVBfPh845vh4p482Ig3",
    //       "type": "Patient",
    //       "display": "Phxtst, Hyperdrive"
    //     },
    //     "period": {
    //       "start": "2024-06-10"
    //     },
    //     "team": [
    //       {
    //         "reference": "CareTeam/eDUEQVefZY4noM2gKQRAoWCmd89vK9u0G56rO2MGaKpk3",
    //         "type": "CareTeam"
    //       }
    //     ]
    //   },
    //   "search": {
    //     "mode": "match"
    //   }
    // },
    // {
    //   "link": [
    //     {
    //       "relation": "self",
    //       "url": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/es5uJ7KxuvCos-dW7ljgmAA3"
    //     }
    //   ],
    //   "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/es5uJ7KxuvCos-dW7ljgmAA3",
    //   "resource": {
    //     "resourceType": "EpisodeOfCare",
    //     "id": "es5uJ7KxuvCos-dW7ljgmAA3",
    //     "extension": [
    //       {
    //         "valueString": "Kidney Transplant Referral - 6/6/2024",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
    //       },
    //       {
    //         "valueCodeableConcept": {
    //           "coding": [
    //             {
    //               "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
    //               "code": "2",
    //               "display": "Recipient"
    //             }
    //           ],
    //           "text": "Recipient"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
    //                   "code": "16",
    //                   "display": "Kidney"
    //                 }
    //               ],
    //               "text": "Kidney"
    //             },
    //             "url": "organ-class"
    //           },
    //           {
    //             "valueReference": {
    //               "reference": "Practitioner/e6zs7QnhOHCa9Td08H6Y8MF4G-UvFNh0wg85S4XIH0Vc3",
    //               "type": "Practitioner",
    //               "display": "Jennifer Donnelly"
    //             },
    //             "url": "coordinator"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
    //                   "code": "10",
    //                   "display": "Referral"
    //                 }
    //               ],
    //               "text": "Referral"
    //             },
    //             "url": "phase"
    //           },
    //           {
    //             "valueString": "Active",
    //             "url": "status"
    //           },
    //           {
    //             "valueDate": "2024-06-06",
    //             "url": "effective"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
    //       },
    //       {
    //         "valueDate": "2024-06-06",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
    //       },
    //       {
    //         "valueString": "St. Joseph's Healthcare Hamilton (Hamilton, ON)",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
    //       }
    //     ],
    //     "status": "cancelled",
    //     "type": [
    //       {
    //         "coding": [
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
    //             "code": "49",
    //             "display": "Transplant"
    //           },
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
    //             "code": "4",
    //             "display": "Transplant"
    //           }
    //         ],
    //         "text": "Transplant"
    //       }
    //     ],
    //     "patient": {
    //       "reference": "Patient/euIfIDVBfPh845vh4p482Ig3",
    //       "type": "Patient",
    //       "display": "Phxtst, Hyperdrive"
    //     },
    //     "period": {
    //       "start": "2024-06-06"
    //     },
    //     "team": [
    //       {
    //         "reference": "CareTeam/eDUEQVefZY4noM2gKQRAoWJj9CmyERLcTGvY.NXaYcR03",
    //         "type": "CareTeam"
    //       }
    //     ]
    //   },
    //   "search": {
    //     "mode": "match"
    //   }
    // },
    // {
    //   "link": [
    //     {
    //       "relation": "self",
    //       "url": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/e18eozRQE7LTWg4WdpdMGHw3"
    //     }
    //   ],
    //   "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/e18eozRQE7LTWg4WdpdMGHw3",
    //   "resource": {
    //     "resourceType": "EpisodeOfCare",
    //     "id": "e18eozRQE7LTWg4WdpdMGHw3",
    //     "extension": [
    //       {
    //         "valueString": "Kidney Transplant Evaluation - 10/6/2024",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
    //       },
    //       {
    //         "valueCodeableConcept": {
    //           "coding": [
    //             {
    //               "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
    //               "code": "2",
    //               "display": "Recipient"
    //             }
    //           ],
    //           "text": "Recipient"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
    //                   "code": "16",
    //                   "display": "Kidney"
    //                 }
    //               ],
    //               "text": "Kidney"
    //             },
    //             "url": "organ-class"
    //           },
    //           {
    //             "valueReference": {
    //               "reference": "Practitioner/e6zs7QnhOHCa9Td08H6Y8MF4G-UvFNh0wg85S4XIH0Vc3",
    //               "type": "Practitioner",
    //               "display": "Jennifer Donnelly"
    //             },
    //             "url": "coordinator"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
    //                   "code": "20",
    //                   "display": "Evaluation"
    //                 }
    //               ],
    //               "text": "Evaluation"
    //             },
    //             "url": "phase"
    //           },
    //           {
    //             "valueString": "Active",
    //             "url": "status"
    //           },
    //           {
    //             "valueDate": "2024-06-10",
    //             "url": "effective"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
    //       },
    //       {
    //         "valueDate": "2024-06-05",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
    //       },
    //       {
    //         "valuePeriod": {
    //           "start": "2024-06-10"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-evaluation"
    //       },
    //       {
    //         "valueString": "St. Joseph's Healthcare Hamilton (Hamilton, ON)",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
    //       },
    //       {
    //         "valueReference": {
    //           "reference": "BodyStructure/eJEABpnipUW9RepJgiXDpwtwbqYbCh8yYk1DNf3WW9mWnU9sTuSZzqDEe.0eu8cVb3",
    //           "type": "BodyStructure",
    //           "display": "Right Kidney"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ"
    //       }
    //     ],
    //     "status": "cancelled",
    //     "type": [
    //       {
    //         "coding": [
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
    //             "code": "49",
    //             "display": "Transplant"
    //           },
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
    //             "code": "4",
    //             "display": "Transplant"
    //           }
    //         ],
    //         "text": "Transplant"
    //       }
    //     ],
    //     "patient": {
    //       "reference": "Patient/euIfIDVBfPh845vh4p482Ig3",
    //       "type": "Patient",
    //       "display": "Phxtst, Hyperdrive"
    //     },
    //     "period": {
    //       "start": "2024-06-05"
    //     },
    //     "team": [
    //       {
    //         "reference": "CareTeam/eDUEQVefZY4noM2gKQRAoWIBqKa29eQDW2UyD8cntYBk3",
    //         "type": "CareTeam"
    //       }
    //     ]
    //   },
    //   "search": {
    //     "mode": "match"
    //   }
    // },
    // {
    //   "link": [
    //     {
    //       "relation": "self",
    //       "url": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/ejc-OPcOxAbvKwm6CFMnxTw3"
    //     }
    //   ],
    //   "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/ejc-OPcOxAbvKwm6CFMnxTw3",
    //   "resource": {
    //     "resourceType": "EpisodeOfCare",
    //     "id": "ejc-OPcOxAbvKwm6CFMnxTw3",
    //     "extension": [
    //       {
    //         "valueString": "Kidney Transplant Referral - 4/6/2024",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
    //       },
    //       {
    //         "valueCodeableConcept": {
    //           "coding": [
    //             {
    //               "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
    //               "code": "2",
    //               "display": "Recipient"
    //             }
    //           ],
    //           "text": "Recipient"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
    //                   "code": "16",
    //                   "display": "Kidney"
    //                 }
    //               ],
    //               "text": "Kidney"
    //             },
    //             "url": "organ-class"
    //           },
    //           {
    //             "valueReference": {
    //               "reference": "Practitioner/e6zs7QnhOHCa9Td08H6Y8MF4G-UvFNh0wg85S4XIH0Vc3",
    //               "type": "Practitioner",
    //               "display": "Jennifer Donnelly"
    //             },
    //             "url": "coordinator"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
    //                   "code": "10",
    //                   "display": "Referral"
    //                 }
    //               ],
    //               "text": "Referral"
    //             },
    //             "url": "phase"
    //           },
    //           {
    //             "valueString": "Active",
    //             "url": "status"
    //           },
    //           {
    //             "valueDate": "2024-06-04",
    //             "url": "effective"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
    //       },
    //       {
    //         "valueDate": "2024-06-04",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
    //       },
    //       {
    //         "valueString": "St. Joseph's Healthcare Hamilton (Hamilton, ON)",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
    //       }
    //     ],
    //     "status": "cancelled",
    //     "type": [
    //       {
    //         "coding": [
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
    //             "code": "49",
    //             "display": "Transplant"
    //           },
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
    //             "code": "4",
    //             "display": "Transplant"
    //           }
    //         ],
    //         "text": "Transplant"
    //       }
    //     ],
    //     "patient": {
    //       "reference": "Patient/euIfIDVBfPh845vh4p482Ig3",
    //       "type": "Patient",
    //       "display": "Phxtst, Hyperdrive"
    //     },
    //     "period": {
    //       "start": "2024-06-04"
    //     },
    //     "team": [
    //       {
    //         "reference": "CareTeam/eDUEQVefZY4noM2gKQRAoWE26EZfBqJvPiocTDko2b2o3",
    //         "type": "CareTeam"
    //       }
    //     ]
    //   },
    //   "search": {
    //     "mode": "match"
    //   }
    // },
    // {
    //   "link": [
    //     {
    //       "relation": "self",
    //       "url": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/efDch2meyM59p8HHBt2X8uA3"
    //     }
    //   ],
    //   "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/efDch2meyM59p8HHBt2X8uA3",
    //   "resource": {
    //     "resourceType": "EpisodeOfCare",
    //     "id": "efDch2meyM59p8HHBt2X8uA3",
    //     "extension": [
    //       {
    //         "valueString": "Kidney Transplant Referral - 4/6/2024",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
    //       },
    //       {
    //         "valueCodeableConcept": {
    //           "coding": [
    //             {
    //               "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
    //               "code": "2",
    //               "display": "Recipient"
    //             }
    //           ],
    //           "text": "Recipient"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
    //                   "code": "16",
    //                   "display": "Kidney"
    //                 }
    //               ],
    //               "text": "Kidney"
    //             },
    //             "url": "organ-class"
    //           },
    //           {
    //             "valueReference": {
    //               "reference": "Practitioner/e6zs7QnhOHCa9Td08H6Y8MF4G-UvFNh0wg85S4XIH0Vc3",
    //               "type": "Practitioner",
    //               "display": "Jennifer Donnelly"
    //             },
    //             "url": "coordinator"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
    //                   "code": "10",
    //                   "display": "Referral"
    //                 }
    //               ],
    //               "text": "Referral"
    //             },
    //             "url": "phase"
    //           },
    //           {
    //             "valueString": "Active",
    //             "url": "status"
    //           },
    //           {
    //             "valueDate": "2024-06-04",
    //             "url": "effective"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
    //       },
    //       {
    //         "valueDate": "2024-06-04",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
    //       },
    //       {
    //         "valueString": "St. Joseph's Healthcare Hamilton (Hamilton, ON)",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
    //       }
    //     ],
    //     "status": "cancelled",
    //     "type": [
    //       {
    //         "coding": [
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
    //             "code": "49",
    //             "display": "Transplant"
    //           },
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
    //             "code": "4",
    //             "display": "Transplant"
    //           }
    //         ],
    //         "text": "Transplant"
    //       }
    //     ],
    //     "patient": {
    //       "reference": "Patient/euIfIDVBfPh845vh4p482Ig3",
    //       "type": "Patient",
    //       "display": "Phxtst, Hyperdrive"
    //     },
    //     "period": {
    //       "start": "2024-06-04"
    //     },
    //     "team": [
    //       {
    //         "reference": "CareTeam/eDUEQVefZY4noM2gKQRAoWECRcw7Ikyj9Vms-JvNNNqg3",
    //         "type": "CareTeam"
    //       }
    //     ]
    //   },
    //   "search": {
    //     "mode": "match"
    //   }
    // },
    // {
    //   "link": [
    //     {
    //       "relation": "self",
    //       "url": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/eYiwQ74F8j2vobqxY4PFG8A3"
    //     }
    //   ],
    //   "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/eYiwQ74F8j2vobqxY4PFG8A3",
    //   "resource": {
    //     "resourceType": "EpisodeOfCare",
    //     "id": "eYiwQ74F8j2vobqxY4PFG8A3",
    //     "extension": [
    //       {
    //         "valueString": "Kidney Transplant - 27/2/2024  (#1)",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
    //       },
    //       {
    //         "valueCodeableConcept": {
    //           "coding": [
    //             {
    //               "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
    //               "code": "2",
    //               "display": "Recipient"
    //             }
    //           ],
    //           "text": "Recipient"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
    //                   "code": "16",
    //                   "display": "Kidney"
    //                 }
    //               ],
    //               "text": "Kidney"
    //             },
    //             "url": "organ-class"
    //           },
    //           {
    //             "valueReference": {
    //               "reference": "Practitioner/egdmEZfQprtaIOyol25BVo1XR9ugRfm1-UQXvsO0oQ-43",
    //               "type": "Practitioner",
    //               "display": "Jennifer Velupillai, RN"
    //             },
    //             "url": "coordinator"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
    //                   "code": "50",
    //                   "display": "Transplanted"
    //                 }
    //               ],
    //               "text": "Transplanted"
    //             },
    //             "url": "phase"
    //           },
    //           {
    //             "valueString": "Active Follow-up",
    //             "url": "status"
    //           },
    //           {
    //             "valueDate": "2024-02-27",
    //             "url": "effective"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
    //       },
    //       {
    //         "valueDate": "2024-01-27",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
    //       },
    //       {
    //         "valuePeriod": {
    //           "start": "2024-02-06",
    //           "end": "2024-02-13"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-evaluation"
    //       },
    //       {
    //         "valueDate": "2024-02-13",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-center-waitlist-date"
    //       },
    //       {
    //         "valueDate": "2024-02-13",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-waitlist-date"
    //       },
    //       {
    //         "valueDate": "2024-02-27",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-transplanted-date"
    //       },
    //       {
    //         "valueString": "St. Joseph's Healthcare Hamilton (Hamilton, ON)",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
    //       },
    //       {
    //         "valueReference": {
    //           "reference": "BodyStructure/eShUHVELuRWdGcm.lmksNyeh2Pl2Z.DpR9jGBurrIRERQ7pCwGVEs-3n2jippQz.D3",
    //           "type": "BodyStructure",
    //           "display": "Left Kidney"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ"
    //       }
    //     ],
    //     "status": "cancelled",
    //     "type": [
    //       {
    //         "coding": [
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
    //             "code": "49",
    //             "display": "Transplant"
    //           },
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
    //             "code": "4",
    //             "display": "Transplant"
    //           }
    //         ],
    //         "text": "Transplant"
    //       }
    //     ],
    //     "patient": {
    //       "reference": "Patient/euIfIDVBfPh845vh4p482Ig3",
    //       "type": "Patient",
    //       "display": "Phxtst, Hyperdrive"
    //     },
    //     "period": {
    //       "start": "2024-02-27"
    //     },
    //     "team": [
    //       {
    //         "reference": "CareTeam/eDUEQVefZY4noM2gKQRAoWG-ObqyeiDgzHYXOoy3JlXg3",
    //         "type": "CareTeam"
    //       }
    //     ]
    //   },
    //   "search": {
    //     "mode": "match"
    //   }
    // }
  ]
}
const mock_patient = {
  resourceType: "Patient",
  id: "eOPSKZbz6YIgoilQprzPy0Q3",
  extension: [
    {
      valueCodeableConcept: {
        coding: [
          {
            system:
              "urn:oid:1.2.840.114350.1.13.0.1.7.10.698084.130.657370.19999000",
            code: "female",
            display: "female",
          },
        ],
      },
      url: "http://open.epic.com/FHIR/StructureDefinition/extension/legal-sex",
    },
    {
      valueCodeableConcept: {
        coding: [
          {
            system:
              "urn:oid:1.2.840.114350.1.13.0.1.7.10.698084.130.657370.19999000",
            code: "female",
            display: "female",
          },
        ],
      },
      url: "http://open.epic.com/FHIR/StructureDefinition/extension/sex-for-clinical-use",
    },
    {
      extension: [
        {
          valueCoding: {
            system: "urn:oid:2.16.840.1.113883.6.238",
            code: "2131-1",
            display: "Other Race",
          },
          url: "ombCategory",
        },
        { valueString: "Other", url: "text" },
      ],
      url: "http://hl7.org/fhir/us/core/StructureDefinition/us-core-race",
    },
    {
      extension: [ { valueString: "Unknown", url: "text" } ],
      url: "http://hl7.org/fhir/us/core/StructureDefinition/us-core-ethnicity",
    },
    {
      valueCode: "248152002",
      url: "http://hl7.org/fhir/us/core/StructureDefinition/us-core-sex",
    },
    {
      valueCodeableConcept: {
        coding: [
          {
            system: "http://loinc.org",
            code: "LA29519-8",
            display: "she/her/her/hers/herself",
          },
        ],
      },
      url: "http://open.epic.com/FHIR/StructureDefinition/extension/calculated-pronouns-to-use-for-text",
    },
  ],
  identifier: [
    {
      use: "usual",
      type: { text: "CEID" },
      system: "urn:oid:1.2.840.114350.1.13.0.1.7.3.688884.100",
      value: "FHR6VKV43W653Q4",
    },
    {
      use: "usual",
      type: { text: "EPIC" },
      system: "urn:oid:1.2.840.114350.1.13.0.1.7.5.737384.0",
      value: "E2651",
    },
    {
      use: "usual",
      type: { text: "EXTERNAL" },
      system: "urn:oid:1.2.840.114350.1.13.0.1.7.2.698084",
      value: "Z4529",
    },
    {
      use: "usual",
      type: { text: "FHIR" },
      system:
        "http://open.epic.com/FHIR/StructureDefinition/patient-dstu2-fhir-id",
      value: "T1wI5bk8n1YVgvWk9D05BmRV0Pi3ECImNSK8DKyKltsMB",
    },
    {
      use: "usual",
      type: { text: "FHIR STU3" },
      system: "http://open.epic.com/FHIR/StructureDefinition/patient-fhir-id",
      value: "eOPSKZbz6YIgoilQprzPy0Q3",
    },
    {
      use: "usual",
      type: { text: "INTERNAL" },
      system: "urn:oid:1.2.840.114350.1.13.0.1.7.2.698084",
      value: " Z4529",
    },
    {
      use: "usual",
      type: { text: "EPI" },
      system: "urn:oid:1.2.840.114350.1.13.0.1.7.5.737384.14",
      value: "202417",
    },
    {
      use: "usual",
      type: { text: "MYCHARTLOGIN" },
      system: "urn:oid:1.2.840.114350.1.13.0.1.7.3.878082.110",
      value: "CADENCEANNA",
    },
    {
      use: "usual",
      type: { text: "WPRINTERNAL" },
      system: "urn:oid:1.2.840.114350.1.13.0.1.7.2.878082",
      value: "84",
    },
    {
      use: "usual",
      system: "https://open.epic.com/FHIR/StructureDefinition/PayerMemberId",
      value: "123455589",
    },
  ],
  active: true,
  name: [
    {
      use: "official",
      text: "Anna Cadence",
      family: "Cadence",
      given: [ "Anna" ],
    },
    { use: "usual", text: "Anna Cadence", family: "Cadence", given: [ "Anna" ] },
  ],
  telecom: [
    { system: "phone", value: "608-271-9000", use: "home" },
    { system: "email", value: "sleeplessinseattle@ymail.com", rank: 1 },
  ],
  gender: "female",
  birthDate: "1983-09-09",
  deceasedBoolean: false,
  address: [
    {
      use: "home",
      line: [ "8799 1st Street" ],
      city: "VERONA",
      district: "DANE",
      state: "WI",
      postalCode: "53593",
      country: "US",
    },
    {
      use: "old",
      line: [ "8799 1st Street" ],
      city: "VERONA",
      district: "DANE",
      state: "WI",
      postalCode: "53593",
      country: "US",
    },
  ],
  maritalStatus: { text: "Single" },
  contact: [
    {
      name: { use: "usual", text: "Smith, John" },
      telecom: [ { system: "phone", value: "608-271-9000", use: "home" } ],
      address: {
        use: "home",
        line: [ "8799 1st Street" ],
        city: "VERONA",
        district: "DANE",
        state: "WI",
        postalCode: "53593",
        country: "US",
      },
    },
    {
      relationship: [
        {
          coding: [
            {
              system: "http://terminology.hl7.org/CodeSystem/v2-0131",
              code: "E",
              display: "Employer",
            },
          ],
        },
      ],
      telecom: [ { system: "phone", value: "608-271-9000", use: "work" } ],
      address: {
        use: "work",
        line: [ "1979 MILKY WAY" ],
        city: "VERONA",
        district: "DANE",
        state: "WI",
        postalCode: "53593",
        country: "US",
      },
      organization: { display: "Ehs Generic Employer" },
    },
  ],
  communication: [
    {
      language: {
        coding: [ { system: "urn:ietf:bcp:47", code: "en", display: "English" } ],
        text: "English",
      },
      preferred: true,
    },
  ],
  generalPractitioner: [
    {
      reference: "Practitioner/eM5CWtq15N0WJeuCet5bJlQ3",
      type: "Practitioner",
      display: "Physician Family Medicine, MD",
    },
  ],
  managingOrganization: {
    reference: "Organization/enRyWnSP963FYDpoks4NHOA3",
    display: "Epic Hospital System",
  },
};

const mock_patient_bundle = {
  "patient": {
      "resourceType": "Patient",
      "id": "eTBYY2m2lofBOygbq9ebQjg3",
      "meta": {
          "versionId": "1",
          "lastUpdated": "2025-05-20T18:16:04.926+00:00",
          "source": "#Eqx1XeZT3CpWyRGJ"
      },
      "text": {
          "status": "generated",
          "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><div class=\"hapiHeaderText\">Ram_Update <b>KUMAR </b></div><table class=\"hapiPropertyTable\"><tbody><tr><td>Identifier</td><td>SJT2S3Q1XVZ9NXP</td></tr><tr><td>Address</td><td><span>abc street </span><br/><span>Oshawa </span><span>ON </span><span>CA </span></td></tr><tr><td>Date of birth</td><td><span>11 October 1967</span></td></tr></tbody></table></div>"
      },
      "extension": [
          {
              "url": "http://open.epic.com/FHIR/StructureDefinition/extension/legal-sex",
              "valueCodeableConcept": {
                  "coding": [
                      {
                          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.698084.130.657370.25811",
                          "code": "male",
                          "display": "male"
                      }
                  ]
              }
          },
          {
              "url": "http://open.epic.com/FHIR/StructureDefinition/extension/sex-for-clinical-use",
              "valueCodeableConcept": {
                  "coding": [
                      {
                          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.698084.130.657370.25811",
                          "code": "male",
                          "display": "male"
                      }
                  ]
              }
          },
          {
              "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-race",
              "extension": [
                  {
                      "url": "ombCategory",
                      "valueCoding": {
                          "system": "http://terminology.hl7.org/CodeSystem/v3-NullFlavor",
                          "code": "UNK",
                          "display": "Unknown"
                      }
                  },
                  {
                      "url": "text",
                      "valueString": "Unknown"
                  }
              ]
          },
          {
              "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-ethnicity",
              "extension": [
                  {
                      "url": "text",
                      "valueString": "Unknown"
                  }
              ]
          },
          {
              "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-sex",
              "valueCode": "248153007"
          },
          {
              "url": "http://open.epic.com/FHIR/StructureDefinition/extension/calculated-pronouns-to-use-for-text",
              "valueCodeableConcept": {
                  "coding": [
                      {
                          "system": "http://loinc.org",
                          "code": "LA29518-0",
                          "display": "he/him/his/his/himself"
                      }
                  ]
              }
          }
      ],
      "identifier": [
          {
              "use": "usual",
              "type": {
                  "text": "CEID"
              },
              "system": "urn:oid:1.2.840.114350.1.13.403.3.7.3.688884.100",
              "value": "SJT2S3Q1XVZ9NXP"
          },
          {
              "use": "usual",
              "type": {
                  "text": "EPIC"
              },
              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.0",
              "value": "E17286"
          },
          {
              "use": "usual",
              "type": {
                  "text": "EXTERNAL"
              },
              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.698084",
              "value": "Z18990"
          },
          {
              "use": "usual",
              "type": {
                  "text": "FHIR"
              },
              "system": "http://open.epic.com/FHIR/StructureDefinition/patient-dstu2-fhir-id",
              "value": "Tl8fLgaHMq9pzzlLW2910c9FHa3PHNPtk.L.ai-wcq9oB"
          },
          {
              "use": "usual",
              "type": {
                  "text": "FHIR STU3"
              },
              "system": "http://open.epic.com/FHIR/StructureDefinition/patient-fhir-id",
              "value": "eTBYY2m2lofBOygbq9ebQjg3"
          },
          {
              "use": "usual",
              "type": {
                  "text": "INTERNAL"
              },
              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.698084",
              "value": "    Z18990"
          },
          {
              "use": "usual",
              "type": {
                  "text": "EPI"
              },
              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.14",
              "value": "J0002009634"
          },
          {
              "use": "usual",
              "type": {
                  "text": "TGLNRecipient"
              },
              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.1650000001",
              "value": "650913"
          }
      ],
      "active": true,
      "name": [
          {
              "use": "official",
              "text": "Ram_Update Kumar",
              "family": "Kumar",
              "given": [
                  "Ram_Update"
              ]
          },
          {
              "use": "usual",
              "text": "Ram_Update Kumar",
              "family": "Kumar",
              "given": [
                  "Ram_Update"
              ]
          },
          {
              "use": "old",
              "text": "KUMAR,RAM",
              "family": "Kumar",
              "given": [
                  "Ram"
              ]
          }
      ],
      "telecom": [
          {
              "system": "phone",
              "value": "416-989-8583",
              "use": "home",
              "rank": 2
          },
          {
              "system": "phone",
              "value": "226-989-8585",
              "use": "work",
              "rank": 3
          },
          {
              "system": "phone",
              "value": "905-522-1155",
              "use": "mobile"
          },
          {
              "system": "other",
              "value": "519-787-8964",
              "rank": 1
          },
          {
              "system": "fax",
              "value": "519-502-1122",
              "use": "home"
          },
          {
              "system": "other",
              "value": "705-522-1122"
          },
          {
              "system": "email",
              "value": "5687@hotmail.com",
              "rank": 1
          }
      ],
      "gender": "male",
      "birthDate": "1967-10-11",
      "deceasedBoolean": true,
      "address": [
          {
              "use": "home",
              "line": [
                  "abc street"
              ],
              "city": "Oshawa",
              "state": "ON",
              "postalCode": "L1J 0V4",
              "country": "CA",
              "period": {
                  "start": "2024-06-13"
              }
          },
          {
              "use": "old",
              "line": [
                  "abc street"
              ],
              "city": "City of Colorado",
              "postalCode": "C1C 2C8",
              "country": "CA"
          },
          {
              "use": "old",
              "line": [
                  "abc street"
              ],
              "city": "Oshawa",
              "state": "ON",
              "postalCode": "L1J 0V4",
              "country": "CA"
          }
      ],
      "managingOrganization": {
          "reference": "Organization/eoC57gcpft1DFUAEXm4.fXg3",
          "display": "St. Joseph's Healthcare Hamilton"
      }
  },
  "entries": [
      [
          {
              "fullUrl": "http://localhost:4004/hapi-fhir-jpaserver/fhir/Coverage/eWjFRu63344",
              "resource": {
                  "resourceType": "Coverage",
                  "id": "eWjFRu63344",
                  "meta": {
                      "versionId": "1",
                      "lastUpdated": "2025-05-20T18:48:39.468+00:00",
                      "source": "#XctM8wyo9Nqk17B7"
                  },
                  "contained": [
                      {
                          "resourceType": "Organization",
                          "id": "org1",
                          "type": [
                              {
                                  "coding": [
                                      {
                                          "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.678671.120",
                                          "code": "3",
                                          "display": "Insurance Plan"
                                      }
                                  ],
                                  "text": "Insurance Plan"
                              }
                          ],
                          "contact": [
                              {
                                  "purpose": {
                                      "coding": [
                                          {
                                              "system": "http://terminology.hl7.org/CodeSystem/contactentity-type",
                                              "code": "BILL",
                                              "display": "Billing"
                                          }
                                      ]
                                  },
                                  "address": {
                                      "use": "billing",
                                      "state": "PE",
                                      "country": "CA"
                                  }
                              }
                          ]
                      }
                  ],
                  "extension": [
                      {
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/billing-organization",
                          "valueReference": {
                              "reference": "#org1"
                          }
                      }
                  ],
                  "identifier": [
                      {
                          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.678671",
                          "value": "8613"
                      }
                  ],
                  "status": "active",
                  "subscriber": {
                      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                      "display": "Davidfour, Chantwo Kingthree"
                  },
                  "beneficiary": {
                      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                      "display": "Davidfour, Chantwo Kingthree"
                  },
                  "relationship": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.678671.305",
                              "code": "01",
                              "display": "Self"
                          },
                          {
                              "system": "http://terminology.hl7.org/CodeSystem/subscriber-relationship",
                              "code": "self",
                              "display": "Self"
                          }
                      ],
                      "text": "Self"
                  },
                  "payor": [
                      {
                          "reference": "Organization/er-pZJXa05FxXHp6DEOzH5w3",
                          "identifier": {
                              "use": "official",
                              "system": "http://open.epic.com/FHIR/StructureDefinition/payer-id",
                              "value": "237"
                          },
                          "display": "OUT OF PROVINCE"
                      }
                  ],
                  "class": [
                      {
                          "extension": [
                              {
                                  "url": "http://open.epic.com/FHIR/StructureDefinition/extension/epic-id",
                                  "valueIdentifier": {
                                      "use": "secondary",
                                      "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.698080",
                                      "value": "23704"
                                  }
                              }
                          ],
                          "type": {
                              "coding": [
                                  {
                                      "system": "http://terminology.hl7.org/CodeSystem/coverage-class",
                                      "code": "plan",
                                      "display": "Plan"
                                  }
                              ]
                          },
                          "value": "23704",
                          "name": "OTHER PROVINCE - PRINCE EDWARD ISLAND"
                      }
                  ],
                  "order": 1
              },
              "search": {
                  "mode": "match"
              }
          }
      ],
      [
        {
 
          "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fVa7HPlh3k0YA6oXG2sxD-A4",
          "resource": {
            "resourceType": "Observation",
            "id": "fVa7HPlh3k0YA6oXG2sxD-A4",
            "status": "unknown",
            "category": [
              {
                "coding": [
                  {
                    "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                    "code": "smartdata",
                    "display": "SmartData"
                  }
                ],
                "text": "SmartData"
              }
            ],
            "code": {
              "coding": [
                {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                  "code": "TXP#320",
                  "display": "OATS - DEMOGRAPHICS GENDER VS SEX"
                }
              ],
              "text": "OATS - DEMOGRAPHICS GENDER VS SEX"
            },
            "subject": {
              "reference": "Patient/eg4w2uavogNXkl9HAAw2Pzg3",
              "display": "SMHTwo, RecipientTwo EMRTwo"
            },
            "focus": [
              {
                "reference": "EpisodeOfCare/esuoTAkQrfuGmIj5rwXaW9w3"
              }
            ],
            "issued": "2025-08-06T03:07:18Z",
            "performer": [
              {
                "reference": "Practitioner/enQJjyYC0qHEF4yABThitOQ3",
                "display": "CHUNG, SARAH"
              }
            ],
            "component": [
              {
                "code": {
                  "text": "Line 1"
                },
                "valueBoolean": true
              }
            ]
          },
          "search": {
            "mode": "match"
          }
        },
        {
         
          "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fBaDfWywYerbMp95JTS6C8g4",
          "resource": {
            "resourceType": "Observation",
            "id": "fBaDfWywYerbMp95JTS6C8g4",
            "status": "unknown",
            "category": [
              {
                "coding": [
                  {
                    "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                    "code": "smartdata",
                    "display": "SmartData"
                  }
                ],
                "text": "SmartData"
              }
            ],
            "code": {
              "coding": [
                {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                  "code": "TXP#263",
                  "display": "OATS INTEGRATION - OTHER ETHNICITY"
                }
              ],
              "text": "OATS INTEGRATION - OTHER ETHNICITY"
            },
            "subject": {
              "reference": "Patient/eg4w2uavogNXkl9HAAw2Pzg3",
              "display": "SMHTwo, RecipientTwo EMRTwo"
            },
            "focus": [
              {
                "reference": "Patient/eg4w2uavogNXkl9HAAw2Pzg3",
                "display": "SMHTwo, RecipientTwo EMRTwo"
              }
            ],
            "issued": "2025-08-21T17:33:27Z",
            "performer": [
              {
                "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                "display": "PHOENIX, COORDINATOR"
              }
            ],
            "component": [
              {
                "code": {
                  "text": "Line 1"
                },
                "valueString": "testing"
              }
            ]
          },
          "search": {
            "mode": "match"
          }
        },
          {
              "fullUrl": "http://localhost:4004/hapi-fhir-jpaserver/fhir/Observation/eWjFRu63334",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eWjFRu63334",
                  "meta": {
                      "versionId": "1",
                      "lastUpdated": "2025-05-20T18:41:46.653+00:00",
                      "source": "#McMVQ8KWpCXXEbf2"
                  },
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                              "code": "TXP#262",
                              "display": "OATS INTEGRATION - ETHNICITY"
                          }
                      ],
                      "text": "OATS INTEGRATION - ETHNICITY"
                  },
                  "subject": {
                      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                      "display": "Oatsintegrationreferral Phoenix"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                          "display": "Oatsintegrationreferral Phoenix"
                      }
                  ],
                  "issued": "2024-05-09T15:03:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Indian Sub-Continent"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "fullUrl": "http://localhost:4004/hapi-fhir-jpaserver/fhir/Observation/eWjFRu63335",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eWjFRu63335",
                  "meta": {
                      "versionId": "1",
                      "lastUpdated": "2025-05-20T18:45:49.602+00:00",
                      "source": "#iNSWo9pGwp9VeJxM"
                  },
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                              "code": "TXP#332",
                              "display": "OATS ABO BLOOD TYPE"
                          }
                      ],
                      "text": "OATS ABO BLOOD TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                      "display": "Oatsintegrationreferral Phoenix"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                          "display": "Oatsintegrationreferral Phoenix"
                      }
                  ],
                  "issued": "2024-05-09T15:03:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "B"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "fullUrl": "http://localhost:4004/hapi-fhir-jpaserver/fhir/Observation/eWjFRu63336",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eWjFRu63336",
                  "meta": {
                      "versionId": "1",
                      "lastUpdated": "2025-05-20T18:46:35.019+00:00",
                      "source": "#HP28ZbUCMopbV5gH"
                  },
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                              "code": "TXP#333",
                              "display": "OATS ABO RH FACTOR"
                          }
                      ],
                      "text": "OATS ABO RH FACTOR"
                  },
                  "subject": {
                      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                      "display": "Oatsintegrationreferral Phoenix"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                          "display": "Oatsintegrationreferral Phoenix"
                      }
                  ],
                  "issued": "2024-05-09T15:03:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Negative"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "fullUrl": "http://localhost:4004/hapi-fhir-jpaserver/fhir/Observation/eWjFRu63337",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eWjFRu63337",
                  "meta": {
                      "versionId": "1",
                      "lastUpdated": "2025-05-20T18:47:13.826+00:00",
                      "source": "#tYSqnyxVGDg6MoLP"
                  },
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                              "code": "TXP#359",
                              "display": "OATS BLOOD TYPE VERIFIED"
                          }
                      ],
                      "text": "OATS BLOOD TYPE VERIFIED"
                  },
                  "subject": {
                      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                      "display": "Oatsintegrationreferral Phoenix"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                          "display": "Oatsintegrationreferral Phoenix"
                      }
                  ],
                  "issued": "2024-05-09T15:03:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "fullUrl": "http://localhost:4004/hapi-fhir-jpaserver/fhir/Observation/eWjFRu63343",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eWjFRu63343",
                  "meta": {
                      "versionId": "1",
                      "lastUpdated": "2025-05-20T18:47:58.544+00:00",
                      "source": "#ymQ8VXbrEBnhqJeZ"
                  },
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                              "code": "TXP#393",
                              "display": "OATS RECIPIENT DEATH DATA - COMMENTS"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                      "display": "Oatsintegrationreferral Phoenix"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                          "display": "Oatsintegrationreferral Phoenix"
                      }
                  ],
                  "issued": "2024-05-09T15:03:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Patient passed away in motor vehicle accident."
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "fullUrl": "http://localhost:4004/hapi-fhir-jpaserver/fhir/Observation/eWjFRu63338",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eWjFRu63338",
                  "meta": {
                      "versionId": "4",
                      "lastUpdated": "2025-05-14T18:09:28.345+00:00",
                      "source": "#333Dyw7UhdtIlMvi"
                  },
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                              "code": "TXP#390",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH CATEGORY"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH CATEGORY"
                  },
                  "subject": {
                      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                      "display": "Oatsintegrationreferral Phoenix"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                          "display": "Oatsintegrationreferral Phoenix"
                      }
                  ],
                  "issued": "2024-05-09T15:03:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "ACCIDENT"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "fullUrl": "http://localhost:4004/hapi-fhir-jpaserver/fhir/Observation/eWjFRu63339",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eWjFRu63339",
                  "meta": {
                      "versionId": "1",
                      "lastUpdated": "2025-05-14T17:55:41.677+00:00",
                      "source": "#NiGpSsqIxdRWwEtJ"
                  },
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                              "code": "TXP#391",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                      "display": "Oatsintegrationreferral Phoenix"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                          "display": "Oatsintegrationreferral Phoenix"
                      }
                  ],
                  "issued": "2024-05-09T15:03:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "ACCIDENT UNRELATED TO TREATMENT"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "fullUrl": "http://localhost:4004/hapi-fhir-jpaserver/fhir/Observation/eWjFRu63340",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eWjFRu63340",
                  "meta": {
                      "versionId": "1",
                      "lastUpdated": "2025-05-14T18:21:13.971+00:00",
                      "source": "#Bv3vNOXFtwaz4Kcb"
                  },
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                              "code": "TXP#392",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE OTHER"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE OTHER"
                  },
                  "subject": {
                      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                      "display": "Oatsintegrationreferral Phoenix"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                          "display": "Oatsintegrationreferral Phoenix"
                      }
                  ],
                  "issued": "2024-05-09T15:03:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Other death type field"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "fullUrl": "http://localhost:4004/hapi-fhir-jpaserver/fhir/Observation/eWjFRu63341",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eWjFRu63341",
                  "meta": {
                      "versionId": "1",
                      "lastUpdated": "2025-05-14T18:31:40.908+00:00",
                      "source": "#f8rOTsi4uhZH9XWC"
                  },
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                              "code": "TXP#388",
                              "display": "OATS RECIPIENT DEATH DATA - DEATH DATE"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - DEATH DATE"
                  },
                  "subject": {
                      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                      "display": "Oatsintegrationreferral Phoenix"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                          "display": "Oatsintegrationreferral Phoenix"
                      }
                  ],
                  "issued": "2024-05-09T15:03:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-02-03"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "fullUrl": "http://localhost:4004/hapi-fhir-jpaserver/fhir/Observation/eWjFRu63342",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eWjFRu63342",
                  "meta": {
                      "versionId": "1",
                      "lastUpdated": "2025-05-14T18:40:02.076+00:00",
                      "source": "#k0hnj2EPSF6cwThf"
                  },
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                              "code": "TXP#389",
                              "display": "OATS RECIPIENT DEATH DATA - DEATH DATE ESTIMATED"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - DEATH DATE ESTIMATED"
                  },
                  "subject": {
                      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                      "display": "Oatsintegrationreferral Phoenix"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                          "display": "Oatsintegrationreferral Phoenix"
                      }
                  ],
                  "issued": "2024-05-09T15:03:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "fullUrl": "http://localhost:4004/hapi-fhir-jpaserver/fhir/Observation/eWjFRu63343",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eWjFRu63343",
                  "meta": {
                      "versionId": "1",
                      "lastUpdated": "2025-05-14T18:41:54.840+00:00",
                      "source": "#Cr7l8tzMsHo1LyfJ"
                  },
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                              "code": "TXP#393",
                              "display": "OATS RECIPIENT DEATH DATA - COMMENTS"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                      "display": "Oatsintegrationreferral Phoenix"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                          "display": "Oatsintegrationreferral Phoenix"
                      }
                  ],
                  "issued": "2024-05-09T15:03:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Patient passed away in motor vehicle accident."
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
     "fullUrl": "",
    "resource": {
      "resourceType": "Observation",
      "id": "elDV8pUwep.uUDSQiGb7LIjX0QS2s9DOScMkYy9vZ5OIvYt1M08DH0MoWgBpfGndqXUY9U04ipAf2rENc2Po5Cw3",
      "status": "unknown",
      "category": [
        {
          "coding": [
            {
              "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
              "code": "smartdata",
              "display": "SmartData"
            }
          ],
          "text": "SmartData"
        }
      ],
      "code": {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
            "code": "TXP#135",
            "display": "TXP - CURRENT CPRA"
          }
        ],
        "text": "TXP - CURRENT CPRA"
      },
      "subject": {
        "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
        "display": "Oats, Recipient"
      },
      "focus": [
        {
          "reference": "EpisodeOfCare/eSD.IDoT7Y0NTRaGGZqXH3w3"
        }
      ],
      "issued": "2024-04-16T18:31:09Z",
      "performer": [
        {
          "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
          "display": "PHOENIX, COORDINATOR"
        }
      ],
      "component": [
        {
          "code": {
            "text": "Line 1"
          },
          "valueString": "0"
        }
      ]
    },
    "search": {
      "mode": "match"
    }
  },
  {
"fullUrl": "",
"resource": {
  "resourceType": "Observation",
  "id": "eCLG8ZQ7wkG2.Jh7eVZiUT2GKQZMsQaPE7LT5W0-tdRDMwutDtMWvOxuqIzW4UYrF5pv1MQDz9MZJ7m4RcLx.7w3",
  "status": "unknown",
  "category": [
    {
      "coding": [
        {
          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
          "code": "smartdata",
          "display": "SmartData"
        }
      ],
      "text": "SmartData"
    }
  ],
  "code": {
    "coding": [
      {
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
        "code": "TXP#348",
        "display": "OATS DONOR CRITERIA HEP B CORE AB+"
      }
    ],
    "text": "OATS DONOR CRITERIA HEP B CORE AB+"
  },
  "subject": {
    "reference": "Patient/ez7bORHxLJcCMUFzc3ajq0g3",
    "display": "MayUpgradeTwoFour, ScriptEightySevenR"
  },
  "focus": [
    {
      "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
    }
  ],
  "issued": "2024-11-06T21:14:44Z",
  "performer": [
    {
      "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
      "display": "GONZALES, ALVIN"
    }
  ],
  "component": [
    {
      "code": {
        "text": "Line 1"
      },
      "valueBoolean": true
    }
  ]
},
"search": {
  "mode": "match"
}
},
{

"fullUrl": "",
"resource": {
 "resourceType": "Observation",
 "id": "ebQGdW9z4ZDLSGWt98EWpnTBO1J9p1-.YOtU750bIxWDkzOR3w6wol032ZSBZ-SCb-DmdDTcW28JnRyZPG-wFcA3",
 "status": "unknown",
 "category": [
   {
     "coding": [
       {
         "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
         "code": "smartdata",
         "display": "SmartData"
       }
     ],
     "text": "SmartData"
   }
 ],
 "code": {
   "coding": [
     {
       "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
       "code": "TXP#377",
       "display": "OATS RECIPIENT STATUS"
     }
   ],
   "text": "OATS RECIPIENT STATUS"
 },
 "subject": {
   "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
   "display": "Death, Recipient"
 },
 "focus": [
   {
     "reference": "EpisodeOfCare/etJ4tHBnqDhnf3X3UfaYw9A3"
   }
 ],
 "issued": "2024-12-06T16:49:22Z",
 "performer": [
   {
     "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
     "display": "PHOENIX, COORDINATOR"
   }
 ],
 "component": [
   {
     "code": {
       "text": "Line 1"
     },
     "valueString": "Recipient death"
   }
 ]
},
},
{

"fullUrl": "",
"resource": {
 "resourceType": "Observation",
 "id": "e5V9-uWOdKU5GlzUfPVBKdvQD8W5pGfssjyga4B56IBxGNOQ5rweqexxYGpzZJwyI33Z6pr3L6K2lo2m7II2j.g3",
 "status": "unknown",
 "category": [
   {
     "coding": [
       {
         "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
         "code": "smartdata",
         "display": "SmartData"
       }
     ],
     "text": "SmartData"
   }
 ],
 "code": {
   "coding": [
     {
       "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
       "code": "TXP#309",
       "display": "OATS FOLLOWUP SOURCE INFORMATION"
     }
   ],
   "text": "OATS FOLLOWUP SOURCE INFORMATION"
 },
 "subject": {
   "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
   "display": "MayUpgradeTwoFour, ScriptEightySevenR"
 },
 "focus": [
   {
     "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
   }
 ],
 "issued": "2024-11-08T21:19:17Z",
 "performer": [
   {
     "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
     "display": "PHOENIX, COORDINATOR"
   }
 ],
 "component": [
   {
     "code": {
       "text": "Line 1"
     },
     "valueString": "Transplant Program"
   }
 ]
},
"search": {
 "mode": "match"
}
},
{
"fullUrl": "",
"resource": {
"resourceType": "Observation",
"id": "exi7B6CeCkkHs7d0XnM4CvSCKvwbOAdgeGhzzuHucxZxcv6zu3K.il5rCiW7t7jTctmc5UGYSoE8Al20ab2MORA3",
"status": "unknown",
"category": [
  {
    "coding": [
      {
        "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
        "code": "smartdata",
        "display": "SmartData"
      }
    ],
    "text": "SmartData"
  }
],
"code": {
  "coding": [
    {
      "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
      "code": "TXP#315",
      "display": "OATS FOLLOWUP SOURCE INFORMATION OTHER"
    }
  ],
  "text": "OATS FOLLOWUP SOURCE INFORMATION OTHER"
},
"subject": {
  "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
  "display": "MayUpgradeTwoFour, ScriptEightySevenR"
},
"focus": [
  {
    "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
  }
],
"issued": "2024-11-08T21:19:17Z",
"performer": [
  {
    "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
    "display": "PHOENIX, COORDINATOR"
  }
],
"component": [
  {
    "code": {
      "text": "Line 1"
    },
    "valueString": "This is the source of information other field."
  }
]
},
"search": {
"mode": "match"
}
},
{

"fullUrl": "",
"resource": {
  "resourceType": "Observation",
  "id": "e0ENcoXUz67.czWbGVq0cXT0IS4dekEq2DcW2mjANd3kppI9v8yx6V41P7axFpTvbN53SLYJGg8TU5UM5UMmmbQ3",
  "status": "unknown",
  "category": [
    {
      "coding": [
        {
          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
          "code": "smartdata",
          "display": "SmartData"
        }
      ],
      "text": "SmartData"
    }
  ],
  "code": {
    "coding": [
      {
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
        "code": "TXP#314",
        "display": "OATS FOLLOWUP CLINIC VISIT DATE"
      }
    ],
    "text": "OATS FOLLOWUP CLINIC VISIT DATE"
  },
  "subject": {
    "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
    "display": "MayUpgradeTwoFour, ScriptEightySevenR"
  },
  "focus": [
    {
      "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
    }
  ],
  "issued": "2024-11-08T21:19:17Z",
  "performer": [
    {
      "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
      "display": "PHOENIX, COORDINATOR"
    }
  ],
  "component": [
    {
      "code": {
        "text": "Line 1"
      },
      "valueDateTime": "2024-11-08"
    }
  ]
},
"search": {
  "mode": "match"
}
},
{

"fullUrl": "",
"resource": {
 "resourceType": "Observation",
 "id": "eH8l4RHRdXjOvIfktWvusH5rhsHuYww6isZkpOw.oa-SX5ithn20igDTeIRcj7NbRK.jX68SX-LLBRM8a5wbNLA3",
 "status": "unknown",
 "category": [
   {
     "coding": [
       {
         "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
         "code": "smartdata",
         "display": "SmartData"
       }
     ],
     "text": "SmartData"
   }
 ],
 "code": {
   "coding": [
     {
       "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
       "code": "TXP#328",
       "display": "OATS FOLLOWUP COMMENTS"
     }
   ],
   "text": "OATS FOLLOWUP COMMENTS"
 },
 "subject": {
   "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
   "display": "Death, Recipient"
 },
 "focus": [
   {
     "reference": "EpisodeOfCare/etJ4tHBnqDhnf3X3UfaYw9A3"
   }
 ],
 "issued": "2024-12-06T16:49:22Z",
 "performer": [
   {
     "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
     "display": "PHOENIX, COORDINATOR"
   }
 ],
 "component": [
   {
     "code": {
       "text": "Line 1"
     },
     "valueString": "Follow up comments for recipient death"
   }
 ]
},
"search": {
 "mode": "match"
}
},
{

"fullUrl": "",
"resource": {
  "resourceType": "Observation",
  "id": "e6bOIHnvwv89RlaTap-U0Kt1ltG4QDvSpfOg4z1CWknak5aOyINUZc7ytIAvNs6WB0baqoKP8.Qa6jBmj8YO.tg3",
  "status": "unknown",
  "category": [
    {
      "coding": [
        {
          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
          "code": "smartdata",
          "display": "SmartData"
        }
      ],
      "text": "SmartData"
    }
  ],
  "code": {
    "coding": [
      {
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
        "code": "TXP#329",
        "display": "OATS FOLLOWUP - CREATININE UNKNOWN"
      }
    ],
    "text": "OATS FOLLOWUP - CREATININE UNKNOWN"
  },
  "subject": {
    "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
    "display": "MayUpgradeTwoFour, ScriptEightySevenR"
  },
  "focus": [
    {
      "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
    }
  ],
  "issued": "2024-11-08T21:19:17Z",
  "performer": [
    {
      "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
      "display": "PHOENIX, COORDINATOR"
    }
  ],
  "component": [
    {
      "code": {
        "text": "Line 1"
      },
      "valueBoolean": true
    }
  ]
},
"search": {
  "mode": "match"
}
},
{

"fullUrl": "",
"resource": {
  "resourceType": "Observation",
  "id": "eMbCHo5tmM34A0-4OrVi5-A8gLaAE6Po61Lg.i9glHSGK0nejY2hgyNYfPUCMmXWCjC0Vi-gat9HAiAXk-24OxA3",
  "status": "unknown",
  "category": [
    {
      "coding": [
        {
          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
          "code": "smartdata",
          "display": "SmartData"
        }
      ],
      "text": "SmartData"
    }
  ],
  "code": {
    "coding": [
      {
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
        "code": "TXP#316",
        "display": "OATS RETURN TO DIALYSIS"
      }
    ],
    "text": "OATS RETURN TO DIALYSIS"
  },
  "subject": {
    "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
    "display": "MayUpgradeTwoFour, ScriptEightySevenR"
  },
  "focus": [
    {
      "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
    }
  ],
  "issued": "2024-11-08T21:19:17Z",
  "performer": [
    {
      "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
      "display": "PHOENIX, COORDINATOR"
    }
  ],
  "component": [
    {
      "code": {
        "text": "Line 1"
      },
      "valueBoolean": true
    }
  ]
},
"search": {
  "mode": "match"
}
},
{

"fullUrl": "",
"resource": {
"resourceType": "Observation",
"id": "eG2BMebkdPQZVHScdueqmN5E6yaOCcaQmfURqxMwMc7dK87elYkBuRsUdGfYzTOxHnG8bVUfPp1u1VqClE79O3Q3",
"status": "unknown",
"category": [
  {
    "coding": [
      {
        "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
        "code": "smartdata",
        "display": "SmartData"
      }
    ],
    "text": "SmartData"
  }
],
"code": {
  "coding": [
    {
      "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
      "code": "TXP#317",
      "display": "OATS RETURN TO DIALYSIS DATE"
    }
  ],
  "text": "OATS RETURN TO DIALYSIS DATE"
},
"subject": {
  "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
  "display": "MayUpgradeTwoFour, ScriptEightySevenR"
},
"focus": [
  {
    "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
  }
],
"issued": "2024-11-08T21:19:17Z",
"performer": [
  {
    "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
    "display": "PHOENIX, COORDINATOR"
  }
],
"component": [
  {
    "code": {
      "text": "Line 1"
    },
    "valueDateTime": "2024-11-08"
  }
]
},
"search": {
"mode": "match"
}
},
{

"fullUrl": "",
"resource": {
  "resourceType": "Observation",
  "id": "eNieCs.vBcfC1YK7xvcM-U6nmJMQcVr5ecp5IyVLWwyNzMQSkIfxy29tdy0wh7e6WQNGJCc9.u2e3uXmW-BZZ3Q3",
  "status": "unknown",
  "category": [
    {
      "coding": [
        {
          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
          "code": "smartdata",
          "display": "SmartData"
        }
      ],
      "text": "SmartData"
    }
  ],
  "code": {
    "coding": [
      {
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
        "code": "TXP#378",
        "display": "OATS FAILURE DATE"
      }
    ],
    "text": "OATS FAILURE DATE"
  },
  "subject": {
    "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
    "display": "Failure, Graft"
  },
  "focus": [
    {
      "reference": "EpisodeOfCare/efztqfGU03Gqvo01NlU5tOw3"
    }
  ],
  "issued": "2024-12-06T16:45:25Z",
  "performer": [
    {
      "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
      "display": "PHOENIX, COORDINATOR"
    }
  ],
  "component": [
    {
      "code": {
        "text": "Line 1"
      },
      "valueDateTime": "2024-12-06"
    }
  ]
},
"search": {
  "mode": "match"
}
},
{

  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eyoMRUjclNBbwhXQ598UPLZ3LV6i5b-cxDxTsW6XCjynyrM5vrJTTrKfDCY34GKyLw2O8Rn4ywxXs-Tu5.vnRxw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#379",
          "display": "OATS FAILURE CAUSE"
        }
      ],
      "text": "OATS FAILURE CAUSE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Failure, Graft"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/efztqfGU03Gqvo01NlU5tOw3"
      }
    ],
    "issued": "2024-12-06T16:45:25Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "OTHER"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e4Os5bxLCrJBuTAJhZvHElMtw0eqchzU7F5W4M9DFjhkUpOjNoG6P2mYULKub5Osyjsfz2GH9HKM2JZ.D-YOyrQ3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#380",
          "display": "OATS FAILURE CAUSE OTHER"
        }
      ],
      "text": "OATS FAILURE CAUSE OTHER"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Failure, Graft"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/efztqfGU03Gqvo01NlU5tOw3"
      }
    ],
    "issued": "2024-12-06T16:45:25Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "other field for failure cause"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "ektMsJVoHAKz-yVgTshgnMHZtQAbFYXSYKWSoRk9fAh3-zgRLvWeLzkfRuPXLgRJT3Ql9p6h7pkozVYrqRJsxfw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#319",
          "display": "OATS LOST TO FOLLOWUP REASON"
        }
      ],
      "text": "OATS LOST TO FOLLOWUP REASON"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-08T21:19:17Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Recipient refused ongoing follow-up care"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eVW-.gWTdJaUpgDzd9mD2GmlibjYEUK3E3aXGhBA-BDiMGnO0Ps9Wlf-ovphpwueCG-yu0savaSsrs5rj.K2CeA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#381",
          "display": "OATS DEATH DATE (EPISODE)"
        }
      ],
      "text": "OATS DEATH DATE (EPISODE)"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Death, Recipient"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/etJ4tHBnqDhnf3X3UfaYw9A3"
      }
    ],
    "issued": "2024-12-06T16:49:22Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2024-12-06"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eLWnVolSwv1z-90Pk-Dw-Bq.tYqNYsxSJinbotG.0.dA5kdc8fMC9ouTHVi4Zvu-1D3T2g5AfI0ny8.kJEBIVfA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#325",
          "display": "OATS DEATH DATE ESTIMATED (EPISODE)"
        }
      ],
      "text": "OATS DEATH DATE ESTIMATED (EPISODE)"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Death, Recipient"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/etJ4tHBnqDhnf3X3UfaYw9A3"
      }
    ],
    "issued": "2024-12-06T16:49:22Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueBoolean": true
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eJsgNAx.8b56PBP3jMTkQ8y2UOeijfdzpHuKsyL0lLSu271W.K6t0-LrdcNnQPIxkMt6yhqyCM8oK1ctd.gRFiA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#383",
          "display": "OATS CAUSE OF DEATH CATEGORY (EPISODE)"
        }
      ],
      "text": "OATS CAUSE OF DEATH CATEGORY (EPISODE)"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Death, Recipient"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/etJ4tHBnqDhnf3X3UfaYw9A3"
      }
    ],
    "issued": "2024-12-06T16:49:22Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "INFECTION"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eOOEifZPVH0rCHaX2aO7rz7PL-XD7mkSSfdKzwS5jdh1HRUY8vpmzLrsIyXb0gnBrOYrjNqPlXjpH04RHTpSh3g3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#384",
          "display": "OATS CAUSE OF DEATH TYPE (EPISODE)"
        }
      ],
      "text": "OATS CAUSE OF DEATH TYPE (EPISODE)"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Death, Recipient"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/etJ4tHBnqDhnf3X3UfaYw9A3"
      }
    ],
    "issued": "2024-12-06T16:49:22Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "SEPSIS"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eOOEifZPVH0rCHaX2aO7rz7PL-XD7mkSSfdKzwS5jdh1HRUY8vpmzLrsIyXb0gnBrOYrjNqPlXjpH04RHTpSh3g3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#351",
          "display": "OATS CONSULTATION TRANSPLANT PHYSICIAN"
        }
      ],
      "text": "OATS CONSULTATION TRANSPLANT PHYSICIAN"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Death, Recipient"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/etJ4tHBnqDhnf3X3UfaYw9A3"
      }
    ],
    "issued": "2024-12-06T16:49:22Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Seychelle Yohanna [SEYCHELLE.YOHANNA@ONEID.ON.CA]"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eOOEifZPVH0rCHaX2aO7rz7PL-XD7mkSSfdKzwS5jdh1HRUY8vpmzLrsIyXb0gnBrOYrjNqPlXjpH04RHTpSh3g3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#386",
          "display": "OATS CAUSE OF DEATH TYPE (EPISODE)"
        }
      ],
      "text": "OATS CAUSE OF DEATH TYPE (EPISODE)"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Death, Recipient"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/etJ4tHBnqDhnf3X3UfaYw9A3"
      }
    ],
    "issued": "2024-12-06T16:49:22Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "SEPSIS"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eFiDAIk49KTHa3p45E0h5zgV1P30p.jLp97s8KuNpxYFsk91.Qom0O8a-56qv.J3Gmi66jJvuZbK-Cl1CE73J5A3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#326",
          "display": "OATS GRAFT FUNCTION AT DEATH"
        }
      ],
      "text": "OATS GRAFT FUNCTION AT DEATH"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Death, Recipient"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/etJ4tHBnqDhnf3X3UfaYw9A3"
      }
    ],
    "issued": "2024-12-06T16:49:22Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "No"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e.-2N0XaROEk8DkDGB3..olEG5CkJtyCSw6VMeRLR-Ipfz6eYba.o0VSRcZ-Ff4rBTg6.4SeIOwGYl-yW1DbW3g3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#296",
          "display": "OATS - STAGED KIDNEY"
        }
      ],
      "text": "OATS - STAGED KIDNEY"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueBoolean": true
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eKxNEM342PwGAoOGbndKO88Ewx4Q3jV7EIM4z-sYYiilv.-0NEdpcHExeY4nC8lsEIP.fcR6WW1kUD5OO9Sd-CQ3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#192",
          "display": "TXP RISK PROFILE - MEDICAL RISK REASON"
        }
      ],
      "text": "TXP RISK PROFILE - MEDICAL RISK REASON"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "NoLabs, OATS GroupOneTwoThree"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/ezDgWeaSRNV7wlsepclJ7ZA3"
      }
    ],
    "issued": "2024-11-01T19:07:06Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Kidney Specific Details general comments are entered here."
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},

{

  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "ejCHnJtKqKqHD0toR-JxapraSqUAiwdTD6XXNWCo8J5rSvak0za9yvMz2nbgM5EAFOSTttnGotsxknygVGdiTTw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#297",
          "display": "OATS - KPD PATIENT"
        }
      ],
      "text": "OATS - KPD PATIENT"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueBoolean": true
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e5Cibpo12EUcnMQm0-M2zhHzpLDTYAQcGGnwsMgt0PHlYggcGe-62A8ZgepFOMUmBhzWFm69i11OfWWCI5gitjA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#299",
          "display": "OATS - LIST EXCHANGE PATIENT"
        }
      ],
      "text": "OATS - LIST EXCHANGE PATIENT"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueBoolean": true
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{

  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e8PcFV46.9qaiA9C7FL5AnyDHboRIjvtRU8meUdjU9EqlgMSdOIIVbVJ8WGwjV.hNt3QH3GCIFcL4dFrPOtNe2A3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#300",
          "display": "OATS - LIST EXCHANGE DATE"
        }
      ],
      "text": "OATS - LIST EXCHANGE DATE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2024-11-06"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eAkOqE43Nr9Q8Mx8VQ-8p3.Daov8yjZUbBDlVM2Xva4eePHVDvWq.JJkFzZSJrr9mHqbDdz7NDB6TtDUnkEI2YA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#301",
          "display": "OATS - PREVIOUS LIVING DONOR"
        }
      ],
      "text": "OATS - PREVIOUS LIVING DONOR"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "TestOne, VirologyOneWaitlist Kingthree"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/exqtC8q0VjpjgnwtPxSBdtQ3"
      }
    ],
    "issued": "2024-09-04T18:16:31Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueBoolean": false
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{

  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eJjHVizenxuIfUDPODIHdOp.APmtIhOgyZBhiPxoIJN5boW0jO8TdQrY-yZiQ3T4jhpYWc0bKw6QTkQGEvy9caw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#303",
          "display": "OATS - PREVIOUS DONATION DATE"
        }
      ],
      "text": "OATS - PREVIOUS DONATION DATE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "TestOne, VirologyOneWaitlist Kingthree"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/exqtC8q0VjpjgnwtPxSBdtQ3"
      }
    ],
    "issued": "2024-09-04T18:16:31Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2024-09-04"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eOxUlziSC9i6X9w.h5L8tvfVC4-piYAJljG2xzX9xrV8N0IItwO7LZZK1Dsn9aT7FztMFKzFbtqsL06o4GOUqZg3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#184",
          "display": "TXP DIALYSIS - PRE-EMPTIVE"
        }
      ],
      "text": "TXP DIALYSIS - PRE-EMPTIVE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "NoLabs, OATS GroupOneTwoThree"
    },
    "focus": [
      {
        "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
        "display": "NoLabs, OATS GroupOneTwoThree"
      }
    ],
    "issued": "2024-11-01T19:24:03Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueBoolean": true
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "ezQyHkgeitIjgCmRY7LkbjTamKWFjE.Cc.US-.Ad.767lPmKWnvRFS1.f3rllVv4J3",
    "basedOn": [
      {
        "reference": "ServiceRequest/eJLc0cVYCXn0hRIuqJ8tZbcnQKb7f2flHZa-mbil4jzs3",
        "display": "Creatinine"
      }
    ],
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "laboratory",
            "display": "Laboratory"
          }
        ],
        "text": "Laboratory"
      },
      {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
            "code": "Lab",
            "display": "Lab"
          }
        ],
        "text": "Lab"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "http://loinc.org",
          "code": "14682-9",
          "display": "Creatinine [Moles/volume] in Serum or Plasma"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30467",
          "code": "CRV"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
          "code": "1526296"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
          "code": "1526296",
          "display": "Creatinine"
        }
      ],
      "text": "Creatinine"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "TestOne, VirologyOneWaitlist Kingthree"
    },
    "encounter": {
      "reference": "Encounter/eyfjhroUuSoubei8mEnpfsg3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200239102"
      },
      "display": "Appointment"
    },
    "effectiveDateTime": "2024-09-16T20:15:00Z",
    "issued": "2024-09-18T13:56:28Z",
    "valueQuantity": {
      "value": 50,
      "unit": "umol/L",
      "system": "http://unitsofmeasure.org",
      "code": "umol/L"
    },
    "specimen": {
      "reference": "Specimen/eVQxcpxJaoMOFEje2nfWh7nijLv7T8Mf9FtpSbcazIY83",
      "display": "Specimen 24SJC-260Y0005"
    },
    "referenceRange": [
      {
        "low": {
          "value": 49,
          "unit": "umol/L",
          "system": "http://unitsofmeasure.org",
          "code": "umol/L"
        },
        "high": {
          "value": 90,
          "unit": "umol/L",
          "system": "http://unitsofmeasure.org",
          "code": "umol/L"
        },
        "text": "49 - 90 umol/L"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "ezQyHkgeitIjgCmRY7LkbjaiNoUsRGo5irZGmu6zIkpbZmZmXHFhWTvJMg41lIIi-3",
    "basedOn": [
      {
        "reference": "ServiceRequest/eJLc0cVYCXn0hRIuqJ8tZbcnQKb7f2flHZa-mbil4jzs3",
        "display": "Creatinine"
      }
    ],
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "laboratory",
            "display": "Laboratory"
          }
        ],
        "text": "Laboratory"
      },
      {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
            "code": "Lab",
            "display": "Lab"
          }
        ],
        "text": "Lab"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "http://loinc.org",
          "code": "62238-1",
          "display": "Glomerular filtration rate/1.73 sq M.predicted [Volume Rate/Area] in Serum or Plasma by Creatinine-based formula (MDRD)"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30467",
          "code": "EGFRV"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
          "code": "1740200"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
          "code": "1740200",
          "display": "Estimated Glomerular Filtration Rate (eGFR)"
        }
      ],
      "text": "Estimated Glomerular Filtration Rate (eGFR)"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "TestOne, VirologyOneWaitlist Kingthree"
    },
    "encounter": {
      "reference": "Encounter/eyfjhroUuSoubei8mEnpfsg3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200239102"
      },
      "display": "Appointment"
    },
    "effectiveDateTime": "2024-09-16T20:15:00Z",
    "issued": "2024-09-18T13:56:28Z",
    "valueQuantity": {
      "value": 109,
      "unit": "ml/min/1.73m2"
    },
    "note": [
      {
        "text": "UNITS: mL/min/1.73m2\r\n\r\nInvalid for drug dosing, pregnancy, extremes of muscle mass, and pediatric patients.\r\neGFR is calculated using the CKD-EPI 2021 equation which does not use a race-based adjustment.\r\n"
      }
    ],
    "specimen": {
      "reference": "Specimen/eVQxcpxJaoMOFEje2nfWh7nijLv7T8Mf9FtpSbcazIY83",
      "display": "Specimen 24SJC-260Y0005"
    },
    "referenceRange": [
      {
        "text": ">60"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "epkN.mAgi7tBGZQGFjHQ-LJB12oWAZzi9lYYN1h66SDU-3wjVtEkh0MlTVwO88tbAhSIDSX69CGI9ML1XEedSEQ3",
    "basedOn": [
      {
        "reference": "ServiceRequest/eaU5ek1w-hf-d68JhamE3OrofVPT9iSW-wxieR5zrY7I3",
        "display": "HbA1c"
      }
    ],
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "laboratory",
            "display": "Laboratory"
          }
        ],
        "text": "Laboratory"
      },
      {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
            "code": "Lab",
            "display": "Lab"
          }
        ],
        "text": "Lab"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "http://loinc.org",
          "code": "4548-4",
          "display": "Hemoglobin A1c/Hemoglobin.total in Blood"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30467",
          "code": "HBA1CP"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
          "code": "1231986"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
          "code": "210100689",
          "display": "HBA1C (%)"
        }
      ],
      "text": "HBA1C (%)"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "TestOne, VirologyOneWaitlist Kingthree"
    },
    "encounter": {
      "reference": "Encounter/eyfjhroUuSoubei8mEnpfsg3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200239102"
      },
      "display": "Appointment"
    },
    "effectiveDateTime": "2024-09-16T20:15:00Z",
    "issued": "2024-09-18T14:08:07Z",
    "valueQuantity": {
      "value": 4.9,
      "unit": "%",
      "system": "http://unitsofmeasure.org",
      "code": "%"
    },
    "specimen": {
      "reference": "Specimen/eUwvxkmfjIiyIHL3VVCaaeox1ZITQQCRFLaqBO4-1pPc3",
      "display": "Specimen 24HGH-260R0001"
    },
    "referenceRange": [
      {
        "low": {
          "value": 4,
          "unit": "%",
          "system": "http://unitsofmeasure.org",
          "code": "%"
        },
        "high": {
          "value": 6,
          "unit": "%",
          "system": "http://unitsofmeasure.org",
          "code": "%"
        },
        "text": "4.0 - 6.0 %"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e92LEJ2G3Ac2.pYH3Uk0EuaZsRS-Ht617BSSPmIuhu4C5iG9tnc7K--GRMAkuTSo5PmB60Dt35.yFEvZdtcVF6A3",
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "vital-signs",
            "display": "Vital Signs"
          }
        ],
        "text": "Vital Signs"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.707679",
          "code": "11",
          "display": "Height"
        },
        {
          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-flowsheet-id",
          "code": "tteYX0mvKJRZuX-Q9jdhkdg0",
          "display": "Height"
        },
        {
          "system": "urn:oid:1.2.246.537.6.96",
          "code": "8302-2"
        },
        {
          "system": "http://loinc.org",
          "code": "8302-2",
          "display": "Body height"
        },
        {
          "system": "http://loinc.org",
          "code": "8716-3",
          "display": "Vital signs"
        }
      ],
      "text": "Height"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "NoVirology, OATSTwo GroupSix"
    },
    "encounter": {
      "reference": "Encounter/evFU8gsEXGlB8Xkh80XeuOQ3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200237542"
      },
      "display": "Documentation"
    },
    "effectiveDateTime": "2024-07-02T19:00:00Z",
    "issued": "2024-05-02T19:25:57Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "Coordinator Phoenix, RN"
      }
    ],
    "valueQuantity": {
      "value": 110,
      "unit": "cm",
      "system": "http://unitsofmeasure.org",
      "code": "cm"
    }
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e92LEJ2G3Ac2.pYH3Uk0EuQwBd6I2aOYUcjfs9i.1ovWzY0wioOV0-bb5uSvN553UywPesCpo3dYNFL740wSkoQ3",
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "vital-signs",
            "display": "Vital Signs"
          }
        ],
        "text": "Vital Signs"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.707679",
          "code": "14",
          "display": "Weight"
        },
        {
          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-flowsheet-id",
          "code": "tPU0I.Sg9hES99nfwfWDhhg0",
          "display": "Weight"
        },
        {
          "system": "urn:oid:1.2.246.537.6.96",
          "code": "29463-7"
        },
        {
          "system": "http://loinc.org",
          "code": "29463-7",
          "display": "Body weight"
        },
        {
          "system": "http://loinc.org",
          "code": "3141-9",
          "display": "Body weight Measured"
        },
        {
          "system": "http://loinc.org",
          "code": "8716-3",
          "display": "Vital signs"
        }
      ],
      "text": "Weight"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "NoVirology, OATSTwo GroupSix"
    },
    "encounter": {
      "reference": "Encounter/evFU8gsEXGlB8Xkh80XeuOQ3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200237542"
      },
      "display": "Documentation"
    },
    "effectiveDateTime": "2024-07-02T19:00:00Z",
    "issued": "2024-05-02T19:25:57Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "Coordinator Phoenix, RN"
      }
    ],
    "valueQuantity": {
      "value": 52,
      "unit": "kg",
      "system": "http://unitsofmeasure.org",
      "code": "kg"
    }
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e92LEJ2G3Ac2.pYH3Uk0EuaZsRS-Ht617BSSPmIuhu4C5iG9tnc7K--GRMAkuTSo5PmB60Dt35.yFEvZdtcVF6A3",
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "vital-signs",
            "display": "Vital Signs"
          }
        ],
        "text": "Vital Signs"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.707679",
          "code": "11",
          "display": "Height"
        },
        {
          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-flowsheet-id",
          "code": "tteYX0mvKJRZuX-Q9jdhkdg0",
          "display": "Height"
        },
        {
          "system": "urn:oid:1.2.246.537.6.96",
          "code": "8302-2"
        },
        {
          "system": "http://loinc.org",
          "code": "8302-2",
          "display": "Body height"
        },
        {
          "system": "http://loinc.org",
          "code": "8716-3",
          "display": "Vital signs"
        }
      ],
      "text": "Height"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "NoVirology, OATSTwo GroupSix"
    },
    "encounter": {
      "reference": "Encounter/evFU8gsEXGlB8Xkh80XeuOQ3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200237542"
      },
      "display": "Documentation"
    },
    "effectiveDateTime": "2025-05-02T19:00:00Z",
    "issued": "2024-05-02T19:25:57Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "Coordinator Phoenix, RN"
      }
    ],
    "valueQuantity": {
      "value": 110,
      "unit": "cm",
      "system": "http://unitsofmeasure.org",
      "code": "cm"
    }
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e92LEJ2G3Ac2.pYH3Uk0EuQwBd6I2aOYUcjfs9i.1ovWzY0wioOV0-bb5uSvN553UywPesCpo3dYNFL740wSkoQ3",
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "vital-signs",
            "display": "Vital Signs"
          }
        ],
        "text": "Vital Signs"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.707679",
          "code": "14",
          "display": "Weight"
        },
        {
          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-flowsheet-id",
          "code": "tPU0I.Sg9hES99nfwfWDhhg0",
          "display": "Weight"
        },
        {
          "system": "urn:oid:1.2.246.537.6.96",
          "code": "29463-7"
        },
        {
          "system": "http://loinc.org",
          "code": "29463-7",
          "display": "Body weight"
        },
        {
          "system": "http://loinc.org",
          "code": "3141-9",
          "display": "Body weight Measured"
        },
        {
          "system": "http://loinc.org",
          "code": "8716-3",
          "display": "Vital signs"
        }
      ],
      "text": "Weight"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "NoVirology, OATSTwo GroupSix"
    },
    "encounter": {
      "reference": "Encounter/evFU8gsEXGlB8Xkh80XeuOQ3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200237542"
      },
      "display": "Documentation"
    },
    "effectiveDateTime": "2025-05-02T19:00:00Z",
    "issued": "2024-05-02T19:25:57Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "Coordinator Phoenix, RN"
      }
    ],
    "valueQuantity": {
      "value": 51,
      "unit": "kg",
      "system": "http://unitsofmeasure.org",
      "code": "kg"
    }
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eO4hmfldYRw9IZDzc3f6lIrM3fSTmwME1Bd.zNN.F0.LOxyDIftqMNbP453AgEjlJmvgsyR2P04-R-meTOlmsUg3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#177",
          "display": "TXP DIALYSIS - DIALYSIS TYPE"
        }
      ],
      "text": "TXP DIALYSIS - DIALYSIS TYPE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
        "display": "Kumar, Ram_Update"
      }
    ],
    "issued": "2024-06-14T12:42:16Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Other/Unknown"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "efqiEDA563rIrvWJI7aQorCOL3fWbHJbsFK4Gblpp2Pw0QAVVZh0iN8.lwM6YdcTXqF5E3TUbP7-KH7EtIbmXjA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#178",
          "display": "TXP DIALYSIS - DIALYSIS ACCESS MODE"
        }
      ],
      "text": "TXP DIALYSIS - DIALYSIS ACCESS MODE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
        "display": "Kumar, Ram_Update"
      }
    ],
    "issued": "2024-06-14T12:42:16Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Other"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
"fullUrl": "",
"resource": {
  "resourceType": "Observation",
  "id": "eh2MSMvpcDBtB1A09.VwEJ5EAEKesi229s.QfY9N8oN80YbojhpxN3e5.TiBhfQBcjGxWpmySUsxjekJ-5WR06g3",
  "status": "unknown",
  "category": [
    {
      "coding": [
        {
          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
          "code": "smartdata",
          "display": "SmartData"
        }
      ],
      "text": "SmartData"
    }
  ],
  "code": {
    "coding": [
      {
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
        "code": "TXP#179",
        "display": "TXP DIALYSIS - DIALYSIS LOCATION"
      }
    ],
    "text": "TXP DIALYSIS - DIALYSIS LOCATION"
  },
  "subject": {
    "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
    "display": "Kumar, Ram_Update"
  },
  "focus": [
    {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    }
  ],
  "issued": "2024-06-14T12:42:16Z",
  "performer": [
    {
      "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
      "display": "PHOENIX, COORDINATOR"
    }
  ],
  "component": [
    {
      "code": {
        "text": "Line 1"
      },
      "valueString": "Other"
    }
  ]
},
"search": {
  "mode": "match"
}
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "ekm1ui3nRYm.rTvLyFSlmtrnxf3XnTnF0H1geKA4WVRsak3HsK-Y4MeNkXHoVrnt.vfSnNU7aWhfqlSM2EMhvjg3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#180",
          "display": "TXP DIALYSIS - OTHER DIALYSIS LOCATION"
        }
      ],
      "text": "TXP DIALYSIS - OTHER DIALYSIS LOCATION"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
        "display": "Kumar, Ram_Update"
      }
    ],
    "issued": "2024-06-14T12:42:16Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Anything"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{

  "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/Observation/eWI7FHG3cmasHW6vTNExcuDktd8jm1LQAys2Sfvy.iMw.KGgV5WcvvSZnmZEShreFUGj.EHQ255.4GtKbDKkYHw3",
  "resource": {
    "resourceType": "Observation",
    "id": "eWI7FHG3cmasHW6vTNExcuDktd8jm1LQAys2Sfvy.iMw.KGgV5WcvvSZnmZEShreFUGj.EHQ255.4GtKbDKkYHw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#207",
          "display": "TXP DIALYSIS - DIALYSIS CENTRE"
        }
      ],
      "text": "TXP DIALYSIS - DIALYSIS CENTRE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
        "display": "Kumar, Ram_Update"
      }
    ],
    "issued": "2024-06-14T12:41:48Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Carveth Care Centre"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/Observation/e2GaclBwAC5LSBO0rIgqjIusK-OOp9bt34ovsftU3fyIonZwQNk92GBMhj9QjA6ld37tK0DRD-8FfuIlbHSBuKA3",
  "resource": {
    "resourceType": "Observation",
    "id": "e2GaclBwAC5LSBO0rIgqjIusK-OOp9bt34ovsftU3fyIonZwQNk92GBMhj9QjA6ld37tK0DRD-8FfuIlbHSBuKA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#330",
          "display": "TXP DIALYSIS - DIALYSIS START DATE"
        }
      ],
      "text": "TXP DIALYSIS - DIALYSIS START DATE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
        "display": "Kumar, Ram_Update"
      }
    ],
    "issued": "2024-06-14T12:41:48Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2023-05-05"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{

  "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/Observation/eAxF9aR7.7CpyftAgV566hpXf7yxSBtezDSi28eUr98yeLc4nMXQCxS7uL5ZTwcV7-Hx1vOkbGM2Plcg-a2QhGw3",
  "resource": {
    "resourceType": "Observation",
    "id": "eAxF9aR7.7CpyftAgV566hpXf7yxSBtezDSi28eUr98yeLc4nMXQCxS7uL5ZTwcV7-Hx1vOkbGM2Plcg-a2QhGw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#331",
          "display": "TXP DIALYSIS - DIALYSIS END DATE"
        }
      ],
      "text": "TXP DIALYSIS - DIALYSIS END DATE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
        "display": "Kumar, Ram_Update"
      }
    ],
    "issued": "2024-06-14T12:40:26Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2024-06-01"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "ePXk3HH14ej51QhJXDsxPanX531PflmPWjE0Rynm3v8u01GDTo6pQSm2PXFnR6Dh3KlAeDTsiV-3fBmbCD0OORA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#335",
          "display": "OATS REFERRAL DECISION DATE"
        }
      ],
      "text": "OATS REFERRAL DECISION DATE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2024-11-29T20:14:59Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2024-11-29"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eAYrDuiWL1SE3hK70aR0mjfHC6Sgp4PE.3dQBJmzcSRl34yGNv.ejk6bDPmJxuaCtrEBg5P7C2e5GlbFmIzNivw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#337",
          "display": "REFERRAL PRIMARY DIAGNOSIS"
        }
      ],
      "text": "REFERRAL PRIMARY DIAGNOSIS"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2024-11-29T20:14:59Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "AMYLOID"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e05qLf9drtWf2J3ltR.oQ3nWQ65U2RlQM.X.NOPU5AF-Pe96zY672n6CcAQ6izZiKzQECGP4pZfkev8a1t91cww3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#338",
          "display": "REFERRAL PRIMARY DIAGNOSIS DATE"
        }
      ],
      "text": "REFERRAL PRIMARY DIAGNOSIS DATE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2024-11-29T20:14:59Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2024-11-29"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eDLLQzbUkAfBD9MDcaSPV4i6RTowwJ349pfT3BOYJM-NWfOJ8xbobLh4poIJ9TjnyVXKLZOnriaIiRfnW-THu9g3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#276",
          "display": "OATS - REFERRING ORGANIZATION NAME"
        }
      ],
      "text": "OATS - REFERRING ORGANIZATION NAME"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2024-11-29T20:14:59Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "OrgSeven"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{

  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eDjuIlsL6fRWeEpQH6Qms4nYfUPazMDYP-k9Tf-QeGJGOqZ9qnGR7U.doA3Y6uSTvvDeV5DZ9kJL14lrkg518KA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#277",
          "display": "OATS REFERRING ORGANIZATION TYPE"
        }
      ],
      "text": "OATS REFERRING ORGANIZATION TYPE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2024-11-29T20:14:59Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Dialysis Centre"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eClGKjjJ5cxXT--tfB4edcOPR5qeHjyighQDdcvIUkpMAxVFCjkyA9ucwBYVkG4xGbFrHP2vrJjXSD0VSn-F8Gg3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#278",
          "display": "OATS - REFERRING ORGANIZATION TYPE OTHER"
        }
      ],
      "text": "OATS - REFERRING ORGANIZATION TYPE OTHER"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "This is other organization type text field."
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "etfjRnM-ARg7Duntwi-EeFcYINvYHpNl4mmpLq3L6.CAnA84YZWhJjK31RsPegB8llRd7DXbbL-AExfXe5Npz8Q3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#340",
          "display": "OATS REFERRING PROVIDER TYPE"
        }
      ],
      "text": "OATS REFERRING PROVIDER TYPE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2024-11-29T20:14:59Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "NEPHROLOGIST"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e0zkLwVTHny4KyvnIT.6WF0w8TBB1AbfawijqPUJg-nse5ibGK0KPw-G9qCbn-fLkcjgSKmGW.akCbUmJdrPNGQ3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#334",
          "display": "OATS REFERRAL DECISION"
        }
      ],
      "text": "OATS REFERRAL DECISION"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2024-11-29T20:14:59Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Referral Accepted"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{

  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e.tbAOZJmbbXw8RBT-6BQms59ZtYhiRYfDTwVH95dybl3gQUyeMXTs5zTRIknx9QCHAbsjmEkEAO48YEoTCRviw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#323",
          "display": "OATS - REFERRAL DETAILS - COMMENTS"
        }
      ],
      "text": "OATS - REFERRAL DETAILS - COMMENTS"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:05:22Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "This is for referral decision comment."
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eMH6uq0kBfkKupgSLVnpZe8yhs0F95.ikdDi14sQZoX5YWtJMnPjQ3B1ErhJ.PHcWyiVBqNl-VdYZDxBV02zfqw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#279",
          "display": "OATS - CONSULTATION DATE"
        }
      ],
      "text": "OATS - CONSULTATION DATE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2024-11-06"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e5Q8Vq2FhBQyAVLWDFnh1urOtifF6e9Zlo5EdwOR9wdyCFxTTwAVWqhOXrc1kw3ID9GgtThBeInAH93fu-yqpng3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#273",
          "display": "OATS - CONSULTATION DECISION"
        }
      ],
      "text": "OATS - CONSULTATION DECISION"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Consult Completed"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eqrUbOmMl50OK0xMChDVxVTIPMCYXo8oAKb0khQe4CakfYNVlbSSQAi8S5irmlFHuezf20bUJ-mEQ0GFaT1xN1A3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#274",
          "display": "OATS - CONSULTATION CANCELLED REASONS"
        }
      ],
      "text": "OATS - CONSULTATION CANCELLED REASONS"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Patient Death Related to Organ Failure"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{

  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e02ESnz9T23Q1GU-2RcKybQ.1f1Clz2eYe-6z98PIXEbjH3R6oJF3dylyQdj-Rop2bD8CcOZh6WWvMHM-ocBzcA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#275",
          "display": "OATS - CONSULTATION DEFERRED REASON"
        }
      ],
      "text": "OATS - CONSULTATION DEFERRED REASON"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Abstinence from Substance"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/Observation/eWg3JhB-KqjIeXeJEUvFp3l3toZtuC-giMFccaguGNELDJ5wff7IOL.AEdb.F1F5GnTnqEYSy5EXZhVBXFjyOCA3",
  "resource": {
    "resourceType": "Observation",
    "id": "eWg3JhB-KqjIeXeJEUvFp3l3toZtuC-giMFccaguGNELDJ5wff7IOL.AEdb.F1F5GnTnqEYSy5EXZhVBXFjyOCA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#282",
          "display": "OATS - DELAY START DATE"
        }
      ],
      "text": "OATS - DELAY START DATE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2024-11-05"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eAveF-aMGBJcv7OH3nC3SgXg7VbM2er2OVDw.Q33Q-wiWjjHNfppYpzVs0327-IpjcZH0qNrVMXFF.IDJSD0tKg3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#283",
          "display": "OATS - DELAY END DATE"
        }
      ],
      "text": "OATS - DELAY END DATE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2024-11-06"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "ellTrL1p2WI8QjNMYjelLtRcwEnOSOe6OTUT8fhAD3b3l-ub7BxwFr23kVJLuDsXxWGBfLvAUqMIOXu3b0-LRiw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#284",
          "display": "OATS - CONSULTATION COMMENTS"
        }
      ],
      "text": "OATS - CONSULTATION COMMENTS"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "This is for consultation comments."
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{

  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eqDZDhRamxPgJrPSFP9uBcayqx.ozGsy-YpnNJZj8.MuimH4ALyxQB-QAmI7kCor3fpNEToYJua2xF3uhA2MM.Q3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#285",
          "display": "OATS - MEDICAL ASSESSMENT DATE"
        }
      ],
      "text": "OATS - MEDICAL ASSESSMENT DATE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2024-11-29T20:21:50Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2024-11-29"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "edZmwB9HHQxh9.i3hSLY8tBXFYuyE6tOsTsTGQPQfsdKArbsuK3z23zgTdYF4z1j4DA6NEr9o1ge7HdvHSeH9Vw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#287",
          "display": "OATS - MEDICAL ASSESSMENT DECISION"
        }
      ],
      "text": "OATS - MEDICAL ASSESSMENT DECISION"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2024-11-29T20:21:50Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Recipient Not Eligible for Transplant"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eEY6QUFLjk.6utt6AMxpFeHPwE8Bx4J1IwK9S86MwFKM5u.OBqzcgpMSlWBS2BXsuuQJifS53BWrPMVUr-OBgNg3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#288",
          "display": "OATS - MEDICAL ASSESSMENT CANCELLED"
        }
      ],
      "text": "OATS - MEDICAL ASSESSMENT CANCELLED"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Recipient Death Related to Organ Failure"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "ezOI4wA1544vR-YyamuQlmnpGwDvcz4MCrMNwby-sCnsDQkUu4odZTTqT3anAZLKH913VsMaE1HHqNokgis.fAQ3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#289",
          "display": "OATS - MEDICAL ASSESSMENT NOT ELIGIBLE"
        }
      ],
      "text": "OATS - MEDICAL ASSESSMENT NOT ELIGIBLE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2024-11-29T20:21:50Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Recipient does not meet listing criteria"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e3zPGgVwXGU9ZJmm32I24--RP5WAZuhtlxig4bc1CmG.qrUoScgpcfp6d22OgQ.KEfxSpNN4bNRchRsQO6Hy0VQ3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#290",
          "display": "OATS - MEDICAL ASSESSMENT FURTHER TESTING"
        }
      ],
      "text": "OATS - MEDICAL ASSESSMENT FURTHER TESTING"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Down staging for HCC"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e58WVNM0jb629nEMoRQLKgz0zLIo-u6pNIPq6t5dqF5.tU8JjuTdwkXoCmZ089TPENJmYfO7lxv1bdRS7zi9kkg3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#327",
          "display": "OATS - FURTHER TESTING REQUIRED OTHER"
        }
      ],
      "text": "OATS - FURTHER TESTING REQUIRED OTHER"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "This is an other field for medical assessment decision reason."
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "edB41AO1moSG0eIEmOJPz0DFWaiAOOyOApcHvu5C7DPKgv.Y2jz2vgAdBWXwhGee0NNphXS2CvaWnTO83IOa8jA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#291",
          "display": "OATS - MEDICAL ASSESSMENT ABS CONTRAINDICATIONS"
        }
      ],
      "text": "OATS - MEDICAL ASSESSMENT ABS CONTRAINDICATIONS"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2024-11-29T20:21:50Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Comorbidities"
      },
      {
        "code": {
          "text": "Line 2"
        },
        "valueString": "Consent"
      },
      {
        "code": {
          "text": "Line 3"
        },
        "valueString": "Post-Transplant Care"
      },
      {
        "code": {
          "text": "Line 4"
        },
        "valueString": "Psychosocial Considerations"
      },
      {
        "code": {
          "text": "Line 5"
        },
        "valueString": "Malignancy"
      },
      {
        "code": {
          "text": "Line 6"
        },
        "valueString": "Pulmoary Disease"
      },
      {
        "code": {
          "text": "Line 7"
        },
        "valueString": "Cardiac Disease"
      },
      {
        "code": {
          "text": "Line 8"
        },
        "valueString": "Peripheral Vascular Disease"
      },
      {
        "code": {
          "text": "Line 9"
        },
        "valueString": "Gastrointestinal Disease"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{

  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e512AOvSC3zGPs1dz1bxr2D3aBjBi9iR2.x2OwWmIGEu-akVsVkB0rp9s2mhOqZUakc9mxb2O8EZfhTrNZdBzTA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#292",
          "display": "OATS - MEDICAL ASSESSMENT REL CONTRAINDICATIONS"
        }
      ],
      "text": "OATS - MEDICAL ASSESSMENT REL CONTRAINDICATIONS"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2024-11-29T20:21:50Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Age and functional capacity"
      },
      {
        "code": {
          "text": "Line 2"
        },
        "valueString": "Cause of Kidney Disease"
      },
      {
        "code": {
          "text": "Line 3"
        },
        "valueString": "Psychosocial Considerations"
      },
      {
        "code": {
          "text": "Line 4"
        },
        "valueString": "Obesity"
      },
      {
        "code": {
          "text": "Line 5"
        },
        "valueString": "Systemic Diseases"
      },
      {
        "code": {
          "text": "Line 6"
        },
        "valueString": "Infections"
      },
      {
        "code": {
          "text": "Line 7"
        },
        "valueString": "Pulmonary Disease"
      },
      {
        "code": {
          "text": "Line 8"
        },
        "valueString": "Cardiac Disease"
      },
      {
        "code": {
          "text": "Line 9"
        },
        "valueString": "Cerebral Vascular Disease"
      },
      {
        "code": {
          "text": "Line 10"
        },
        "valueString": "Peripheral Vascular Disease"
      },
      {
        "code": {
          "text": "Line 11"
        },
        "valueString": "Gastrointestinal Disease"
      },
      {
        "code": {
          "text": "Line 12"
        },
        "valueString": "Liver Disease"
      },
      {
        "code": {
          "text": "Line 13"
        },
        "valueString": "Genitourinary Disease"
      },
      {
        "code": {
          "text": "Line 14"
        },
        "valueString": "Hematologic Disorders"
      },
      {
        "code": {
          "text": "Line 15"
        },
        "valueString": "Hyperparathyroidism"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eYMv.VXCa1cortPkJbBnfFnWSHdFDk7ZurHmVM2onD8XtdafA2w2-XDnrJ65fVd-uv5w-mxNMy-FJGSBAPY8TaA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#293",
          "display": "OATS - MEDICAL ASSESSMENT COMMENTS"
        }
      ],
      "text": "OATS - MEDICAL ASSESSMENT COMMENTS"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "This is medical assessment comments."
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eLdguideZV8-3c3oMdw420ZzrSKWm0000ppv9zyyedeJfjXIGjgoktCWqGitsSuAqfV9ikeoSvsw6VAz.CxBzLA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#395",
          "display": "OATS TRANSPLANT TYPE"
        }
      ],
      "text": "OATS TRANSPLANT TYPE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2025-01-27T17:26:04Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "LEFT KIDNEY"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{

  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "ePY2Ysj4f3oC6wdLvPGVlNDLuUo1BDP2c0Tm8thU-sIVeX8xa8YcROrt6PO8Tks9mN0AnzaeAGQHzUgCyztVytfoS29Uw1kdivKr-9mJmRz83cXuoirhRT4eVFZEbNaMY3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#16533",
          "display": "TRANSPLANT START TIME"
        }
      ],
      "text": "TRANSPLANT START TIME"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "BodyStructure/etcItSK6S-VNvvdoYPSAegTOkTI3pkr-ywEFGTX8QdFASQ58bwrFipL5299Fb3bzT3",
        "display": "LEFT KIDNEY"
      }
    ],
    "issued": "2025-01-27T17:26:29Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2025-01-27T17:26:25Z"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eF.9zCb7Yor34baCiakOleVyDQ12t5Jljosk6woV9V7RHrKUcIbyiaZetOCi5CNNNVNFojazey03BDmXXugjHUw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#396",
          "display": "OATS REMOVED FROM COLD"
        }
      ],
      "text": "OATS REMOVED FROM COLD"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2025-01-27T17:26:04Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2025-01-27T17:26:00Z"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "ey1IkMl.TcO0ESxthi2wcm-fqbg9NLCcBFywkYwIEn8.8e7.SJ6Q36V.veOoRFwJtOmPD5CWTKnm8KAfahJc5pg3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#397",
          "display": "OATS CLAMP REMOVAL"
        }
      ],
      "text": "OATS CLAMP REMOVAL"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2025-01-27T17:26:08Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2025-01-27T17:26:07Z"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e653H0el5RdbIq5pMpfS38zVDMuOvCY9ftUoUQOVwEPZ.yp2DVNfQCiAj6SEd2zL6-iQu51Q1h-U6tmlMJp7N-KJWYuiN0eXczcCgVieVP6p.Kkm4m1s4GaFtf2pqjimA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#123",
          "display": "SURGICAL TXP - WIT 2"
        }
      ],
      "text": "SURGICAL TXP - WIT 2"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "BodyStructure/etcItSK6S-VNvvdoYPSAegTOkTI3pkr-ywEFGTX8QdFASQ58bwrFipL5299Fb3bzT3",
        "display": "LEFT KIDNEY"
      }
    ],
    "issued": "2025-01-27T17:26:29Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "0.0166666666666667"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eIIjl6j8WzxHG7IxgAVf0-79ZQFYXZp4d6tc-piPs4DmjcIh5v.tHVb.cQ5sRo0bUQnlRI4K.XdpODAF7x09rBM8qOSOJNRMmfRdPtyFeBzWQhpurIfWfEdaVY79ZVfNX3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#121",
          "display": "SURGICAL TXP - CIT"
        }
      ],
      "text": "SURGICAL TXP - CIT"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "BodyStructure/e5079wnZFwMKK1LMi.BaZ5Njmt163zL8pcEkSHIdnW7r638nYJjq.nM9lp3kUyiIe3",
        "display": "RIGHT KIDNEY_102924"
      }
    ],
    "issued": "2024-10-16T15:08:54Z",
    "performer": [
      {
        "reference": "Practitioner/e-yoIPAqwXr6xcRnkjh7bqA3",
        "display": "INTRA-OP, NURSE"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "512"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{

  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "ea2AFR3odH01ZbvP-5B41JbA2zjr9GurRjkBbpah0ufOJU58IzqKdLTg4YRuXKD4xUkA7S4OJc7YvewADYGFxREEsTBf9VU.dZzyfOtQTcgoZ1x5GrpHX0RIZsf4z950o3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#126",
          "display": "RECIPIENT VESSELS USED"
        }
      ],
      "text": "RECIPIENT VESSELS USED"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "BodyStructure/etcItSK6S-VNvvdoYPSAegTOkTI3pkr-ywEFGTX8QdFASQ58bwrFipL5299Fb3bzT3",
        "display": "LEFT KIDNEY"
      }
    ],
    "issued": "2025-01-27T17:26:29Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueBoolean": true
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eEJw6qX7IvWPqo2WFHhfOaT.wBAhZGy4ovFb9LIrIoiOZB.H11aJ2.c432qiUIyYXCnyV-OWsb9VcP3kt3RwCUQ3",
    "basedOn": [
      {
        "reference": "ServiceRequest/ezwx7BZ2e0kUyUmv48J-em2aOq-BdoYryoDP3ZZrIb3s3",
        "display": "Cytomegalovirus immunity, serology"
      }
    ],
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "laboratory",
            "display": "Laboratory"
          }
        ],
        "text": "Laboratory"
      },
      {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
            "code": "Microbiology",
            "display": "Microbiology"
          }
        ],
        "text": "Microbiology"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "http://loinc.org",
          "code": "22244-8",
          "display": "Cytomegalovirus IgG Ab [Presence] in Serum or Plasma"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30467",
          "code": "SCMVII"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
          "code": "1612379"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
          "code": "210102689",
          "display": "CMV IgG Ab"
        }
      ],
      "text": "CMV IgG Ab"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "OneOATS, DonorEpic"
    },
    "encounter": {
      "reference": "Encounter/eKWbRphjYOxUbO9hhwFkdQg3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200239141"
      },
      "display": "Appointment"
    },
    "effectiveDateTime": "2024-09-18T14:21:00Z",
    "issued": "2024-09-18T14:24:51Z",
    "valueString": "Reactive",
    "note": [
      {
        "text": "Considered IMMUNE to Cytomegalovirus.\r\n\r\nTesting performed on the Abbott architect.\r\n\r\nVirology comment 1\r\n"
      }
    ],
    "specimen": {
      "reference": "Specimen/e-1A5mqMjdLukfmdJxpT1vU2EX1EPdPqMCucEVNQjnbY3",
      "display": "Specimen 24SJC-261V0001"
    }
  },
  "search": {
    "mode": "match"
  }
},
{
  "link": [
    {
      "relation": "self",
      "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/eDIt2N3wFe5abF2J8QW9xxVbmPHlSUeznNFPiZgLtLT8.K3wAPbH1zFzpNNrPXL4N3"
    }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/eDIt2N3wFe5abF2J8QW9xxVbmPHlSUeznNFPiZgLtLT8.K3wAPbH1zFzpNNrPXL4N3",
  "resource": {
    "resourceType": "Observation",
    "id": "eDIt2N3wFe5abF2J8QW9xxVbmPHlSUeznNFPiZgLtLT8.K3wAPbH1zFzpNNrPXL4N3",
    "basedOn": [
      {
        "reference": "ServiceRequest/ewg.SQoTDaIplJv-4B5y4ba.Xsc8d4wW83Z6LRk3nksI3",
        "display": "Varicella-Zoster Virus (VZV), Diagnostic Serology"
      }
    ],
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "laboratory",
            "display": "Laboratory"
          }
        ],
        "text": "Laboratory"
      },
      {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
            "code": "Microbiology",
            "display": "Microbiology"
          }
        ],
        "text": "Microbiology"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.165",
          "code": "21594-7"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
          "code": "12822",
          "display": "Varicella-zoster virus antibody OLIS"
        }
      ],
      "text": "Varicella-zoster virus antibody OLIS"
    },
    "subject": {
      "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
      "display": "SITSix, SITSix SITMIDDLESIX"
    },
    "encounter": {
      "reference": "Encounter/eaIzbITSKPAVKHOe8sOT1Net2NHD3VpZmA-0HYKR27yQ3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
        "value": "10000112148"
      },
      "display": "Orders Only"
    },
    "effectiveDateTime": "2025-10-21T01:41:00Z",
    "issued": "2025-10-21T01:46:43Z",
    "valueString": "Nonreactive",
    "specimen": {
      "reference": "Specimen/eErTiRuXFLOYu-PFkedf-ViVIZM5sFzHLSyIq24ySAwU3",
      "display": "Specimen"
    }
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eKZbfGb8MqhGV7VxIPXU4v5EKBEcftuwRKzxkSrIyrEVMq0unAnAGmSRQAfSKSL3FT3AS.G7BfhYP6vwTOpDumA3",
    "basedOn": [
      {
        "reference": "ServiceRequest/evmY-v7iva.4Oy1G5BT27r2JxS07EwdPS7Dl6CqZRjHY3",
        "display": "Cytomegalovirus diagnosis, serology"
      }
    ],
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "laboratory",
            "display": "Laboratory"
          }
        ],
        "text": "Laboratory"
      },
      {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
            "code": "Microbiology",
            "display": "Microbiology"
          }
        ],
        "text": "Microbiology"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "http://loinc.org",
          "code": "30325-5",
          "display": "Cytomegalovirus IgM Ab [Presence] in Serum or Plasma"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30467",
          "code": "SCMVDI"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
          "code": "1510340"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
          "code": "210102688",
          "display": "CMV IgM Ab"
        }
      ],
      "text": "CMV IgM Ab"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "OneOATS, DonorEpic"
    },
    "encounter": {
      "reference": "Encounter/eKWbRphjYOxUbO9hhwFkdQg3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200239141"
      },
      "display": "Appointment"
    },
    "effectiveDateTime": "2024-09-18T14:21:00Z",
    "issued": "2024-09-18T14:25:27Z",
    "valueString": "Non-reactive",
    "note": [
      {
        "text": "No evidence of acute CMV infection.\r\n\r\nTesting performed on the Abbott architect.\r\n"
      }
    ],
    "specimen": {
      "reference": "Specimen/el13P0T0VLCe2WSDJydgY5CTOqjsUf1PJ50f7WL3BNl03",
      "display": "Specimen 24SJC-261V0001"
    }
  },
  "search": {
    "mode": "match"
  }
},
{

  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e09RfQxyQJiNg4GOH1Bu7b4JFT93noWxPQdshnSzWTjbZAwB3r89CpLiDImaJRTnuncbWvSNls6jHuIhfIbp5Gg3",
    "basedOn": [
      {
        "reference": "ServiceRequest/eh-1VqnmU37VMELURRk6b3fCw7qule94A1vqU.8nvJIo3",
        "display": "Hepatitis B surface antigen, serology"
      }
    ],
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "laboratory",
            "display": "Laboratory"
          }
        ],
        "text": "Laboratory"
      },
      {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
            "code": "Microbiology",
            "display": "Microbiology"
          }
        ],
        "text": "Microbiology"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "http://loinc.org",
          "code": "5195-3",
          "display": "Hepatitis B virus surface Ag [Presence] in Serum"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30467",
          "code": "SHBSAGI"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
          "code": "1232903"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
          "code": "210102718",
          "display": "HBsAg Screen"
        }
      ],
      "text": "HBsAg Screen"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "TestOne, VirologyOneWaitlist Kingthree"
    },
    "encounter": {
      "reference": "Encounter/eRBnCDoF82PAbVQpoCd7E0g3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200237960"
      },
      "display": "Appointment"
    },
    "effectiveDateTime": "2024-05-30T21:14:00Z",
    "issued": "2024-05-31T11:34:26Z",
    "valueString": "Non-reactive",
    "specimen": {
      "reference": "Specimen/eE6VnFy.r7JyHEFAJQa66QB4uBJ6y8rgBz3-80yYCloo3",
      "display": "Specimen 24SJC-151V0005"
    }
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eMIl6Y9ZHcgFzzYop6CFaq-2eBnJsEfxxaV6w5bLZtKJtEBrGUaH8aCr1wyKO3tl72dHTTLdZcXth0vtRvZHQHQ3",
    "basedOn": [
      {
        "reference": "ServiceRequest/eDn7.csXGU-grjQ9.JBXtOXcEHL3g6WRV99Kev8mTchw3",
        "display": "Hepatitis B core antibody, serology"
      }
    ],
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "laboratory",
            "display": "Laboratory"
          }
        ],
        "text": "Laboratory"
      },
      {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
            "code": "Microbiology",
            "display": "Microbiology"
          }
        ],
        "text": "Microbiology"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "http://loinc.org",
          "code": "13952-7",
          "display": "Hepatitis B virus core Ab [Units/volume] in Serum"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30467",
          "code": "SHBCI"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
          "code": "1232905"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
          "code": "210102709",
          "display": "Anti-HBcore"
        }
      ],
      "text": "Anti-HBcore"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "TestOne, VirologyOneWaitlist Kingthree"
    },
    "encounter": {
      "reference": "Encounter/eRBnCDoF82PAbVQpoCd7E0g3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200237960"
      },
      "display": "Appointment"
    },
    "effectiveDateTime": "2024-05-30T21:14:00Z",
    "issued": "2024-05-31T11:35:09Z",
    "valueString": "Non-reactive",
    "specimen": {
      "reference": "Specimen/eoT5z4gpZEhD8cxYLVsQcy-wgVavbAC.8pj5.R-6.11U3",
      "display": "Specimen 24SJC-151V0006"
    },
    "referenceRange": [
      {
        "text": "Non-reactive"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eQeRs10bZ96W7cu3HLu2GQWbkUg5OIC6CjUccH3AknUHEFDB2A.MzMD5hAyTVHbgw3",
    "basedOn": [
      {
        "reference": "ServiceRequest/eEZgcnRIz-VKcfC5G70f4Qe-KEK26evKiMCFrTHlOmHg3",
        "display": "Hepatitis C antibody, serology"
      }
    ],
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "laboratory",
            "display": "Laboratory"
          }
        ],
        "text": "Laboratory"
      },
      {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
            "code": "Microbiology",
            "display": "Microbiology"
          }
        ],
        "text": "Microbiology"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "http://loinc.org",
          "code": "16128-1",
          "display": "Hepatitis C virus Ab [Presence] in Serum"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30467",
          "code": "SHCI"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
          "code": "1232907"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
          "code": "595",
          "display": "ANTI-HEPATITIS C SCREEN"
        }
      ],
      "text": "ANTI-HEPATITIS C SCREEN"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "OneOATS, DonorEpic"
    },
    "encounter": {
      "reference": "Encounter/eKWbRphjYOxUbO9hhwFkdQg3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200239141"
      },
      "display": "Appointment"
    },
    "effectiveDateTime": "2024-09-18T14:21:00Z",
    "issued": "2024-09-18T14:28:31Z",
    "valueString": "Non-reactive",
    "note": [
      {
        "text": "Testing performed on the Abbott architect.\r\n\r\nVirology comment 7\r\n"
      }
    ],
    "specimen": {
      "reference": "Specimen/emiNzUzvNmdtbn6XyFAtMUF88Gysslh0C.9Jb8C.5IPw3",
      "display": "Specimen 24SJC-261V0001"
    }
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "ekic0pe2AZv6a.-16bDi3mrGy3ut5d3Nkd4xe-qUN4Goby76ZXywAKds3hUfwICgJbR2byGmrOq92bURQK-zg3g3",
    "basedOn": [
      {
        "reference": "ServiceRequest/eJnxqU-hWzmi-jYdBw0WjhJjOK8KZH8Lq2QOFRymIThg3",
        "display": "HTLV 1/2 antibody, serology"
      }
    ],
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "laboratory",
            "display": "Laboratory"
          }
        ],
        "text": "Laboratory"
      },
      {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
            "code": "Microbiology",
            "display": "Microbiology"
          }
        ],
        "text": "Microbiology"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "http://loinc.org",
          "code": "16982-1",
          "display": "HTLV I+II Ab [Presence] in Serum"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30467",
          "code": "SHTLVI"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
          "code": "1810837"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
          "code": "210102755",
          "display": "HTLV 1/2 Ab Scr"
        }
      ],
      "text": "HTLV 1/2 Ab Scr"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "OneOATS, DonorEpic"
    },
    "encounter": {
      "reference": "Encounter/eKWbRphjYOxUbO9hhwFkdQg3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200239141"
      },
      "display": "Appointment"
    },
    "effectiveDateTime": "2024-09-18T14:21:00Z",
    "issued": "2024-09-18T14:29:21Z",
    "valueString": "Non-Reactive",
    "note": [
      {
        "text": "No HTLV 1/2 antibodies detected. \r\n\r\nTesting performed on the Abbott Architect.\r\n\r\nVirology comment 10\r\n"
      }
    ],
    "specimen": {
      "reference": "Specimen/eVbbak1UJbvXI8oBfgYkqRhTFgooqWD78t58Ggqfgrr43",
      "display": "Specimen 24SJC-261V0001"
    }
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eOYnFBYvSw5.MG9QWZwAB3HaZBP2PPt8Cdmz8NkjHcRt50jhL8DurN0qxhR7Rrejz3",
    "basedOn": [
      {
        "reference": "ServiceRequest/eRkvtEf8VsylG88.BDMeBmvm5dwXgYSQ5S-eGLJ8KyCI3",
        "display": "Varicella zoster immunity, serology"
      }
    ],
    "status": "amended",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "laboratory",
            "display": "Laboratory"
          }
        ],
        "text": "Laboratory"
      },
      {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
            "code": "Microbiology",
            "display": "Microbiology"
          }
        ],
        "text": "Microbiology"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "http://loinc.org",
          "code": "19162-7",
          "display": "Varicella zoster virus IgG Ab [Presence] in Serum by Immunoassay"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30467",
          "code": "SVZVII"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
          "code": "1552053"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
          "code": "2658",
          "display": "Varicella Zoster IgG Antibody"
        }
      ],
      "text": "Varicella Zoster IgG Antibody"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "TestOne, VirologyOneWaitlist Kingthree"
    },
    "encounter": {
      "reference": "Encounter/eRBnCDoF82PAbVQpoCd7E0g3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200237960"
      },
      "display": "Appointment"
    },
    "effectiveDateTime": "2024-06-01T21:14:00Z",
    "issued": "2024-06-20T16:07:53Z",
    "valueString": "reactive",
    "note": [
      {
        "text": "changed to reactive"
      }
    ],
    "specimen": {
      "reference": "Specimen/eg56uOuQa1GGDP5-YOMsBOYuMPGMF0x8qA4n2iq2Mjww3",
      "display": "Specimen 24HGH-151I0002"
    }
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "emWRDtImyXgL2eyzF-4M4h8JoQeaL69vPNaZhR3ri6sSicBehcKiAfYWMl938B86B3",
    "basedOn": [
      {
        "reference": "ServiceRequest/emeCu9grTwawHQDrP7dNmZJJ2nocgrU6uhCFE9NRZLvY3",
        "display": "Measles immunity, serology"
      }
    ],
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "laboratory",
            "display": "Laboratory"
          }
        ],
        "text": "Laboratory"
      },
      {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
            "code": "Microbiology",
            "display": "Microbiology"
          }
        ],
        "text": "Microbiology"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "http://loinc.org",
          "code": "20479-2",
          "display": "Measles virus IgG Ab [Presence] in Serum"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
          "code": "267"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
          "code": "3276",
          "display": "Measles IgG Antibody"
        }
      ],
      "text": "Measles IgG Antibody"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "RecipientSix, RecordSix"
    },
    "encounter": {
      "reference": "Encounter/ew.0e7gKoOuaVHlTl4aPuRg3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200238368"
      },
      "display": "Appointment"
    },
    "effectiveDateTime": "2024-07-03T17:53:00Z",
    "issued": "2024-07-03T17:53:19Z",
    "valueString": "Reactive",
    "note": [
      {
        "text": "Tested"
      }
    ],
    "specimen": {
      "reference": "Specimen/eSgn.AByCuCYr8mQG33wc7D292gb0ARvQJK9xiO0GS6M3",
      "display": "Specimen 24HGH-184I0001"
    }
  },
  "search": {
    "mode": "match"
  }
},
{
  "link": [
    {
      "relation": "self",
      "url": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/Observation/eAbIOI25PmBMkNb11SvT2hA3CwqMpUQmt5cVfhka3POrVnF2coovb2zv1raIbOBgs3"
    }
  ],
  "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/Observation/eAbIOI25PmBMkNb11SvT2hA3CwqMpUQmt5cVfhka3POrVnF2coovb2zv1raIbOBgs3",
  "resource": {
    "resourceType": "Observation",
    "id": "eAbIOI25PmBMkNb11SvT2hA3CwqMpUQmt5cVfhka3POrVnF2coovb2zv1raIbOBgs3",
    "basedOn": [
      {
        "reference": "ServiceRequest/erRToBK4LTl5zYPtGXAYVK27Azn4Zl5jl-MnUvVpL1l43",
        "display": "Mumps immunity, serology"
      }
    ],
    "status": "amended",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "laboratory",
            "display": "Laboratory"
          }
        ],
        "text": "Laboratory"
      },
      {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
            "code": "Microbiology",
            "display": "Microbiology"
          }
        ],
        "text": "Microbiology"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "http://loinc.org",
          "code": "22415-4",
          "display": "Mumps virus IgG Ab [Presence] in Serum"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
          "code": "1990000492"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
          "code": "3312",
          "display": "Mumps IgG Interpretation"
        }
      ],
      "text": "Mumps IgG Interpretation"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Sam, Vel Jay"
    },
    "encounter": {
      "reference": "Encounter/ecvT5vmYAeWq1MD9N6RrQCw3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200237633"
      },
      "display": "Documentation"
    },
    "effectiveDateTime": "2023-06-01T13:55:00Z",
    "issued": "2024-05-08T15:10:57Z",
    "valueString": "Negative",
    "note": [
      {
        "text": "Comment 4"
      }
    ],
    "specimen": {
      "reference": "Specimen/e5bNrB5IqYgdP7XPKFyTasckg-aNfn7wUIvwYpanurks3",
      "display": "Specimen"
    }
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eTha2eMoZXcDT8M8uJKYvXf5AR6FzCpi1q9VHpXoY.ikuQq45HEJRb..KX-PrTQxNrUkHZyoTQxNWxWxjeVdIwA3",
    "basedOn": [
      {
        "reference": "ServiceRequest/eQqWuf9jakHWhCHcQy4VKRVB70uZ95Ho1yAyxYYWRAcs3",
        "display": "Rubella immunity, serology"
      }
    ],
    "status": "amended",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "laboratory",
            "display": "Laboratory"
          }
        ],
        "text": "Laboratory"
      },
      {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
            "code": "Microbiology",
            "display": "Microbiology"
          }
        ],
        "text": "Microbiology"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "http://loinc.org",
          "code": "25514-1",
          "display": "Rubella virus IgG Ab [Units/volume] in Serum"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30467",
          "code": "SRUBII"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
          "code": "1511311"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
          "code": "210102789",
          "display": "Rubella IgG Ab"
        }
      ],
      "text": "Rubella IgG Ab"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "TestOne, VirologyOneWaitlist Kingthree"
    },
    "encounter": {
      "reference": "Encounter/eWW5AXxD9QOaFKmcqlwSyhQ3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200237656"
      },
      "display": "Documentation"
    },
    "effectiveDateTime": "2023-06-01T13:55:00Z",
    "issued": "2024-06-10T17:24:36Z",
    "valueString": "Negative",
    "note": [
      {
        "text": "Changed to negative"
      }
    ],
    "specimen": {
      "reference": "Specimen/e5gCc8YbIM2SL5nQAeuOplZv2vDNnyVUqLtaj.mwybSs3",
      "display": "Specimen"
    }
  },
  "search": {
    "mode": "match"
  }
},
{
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "edSxBjWH2.T4kig-0u05CskYQOhS8PkUB.yHwMK66bbUUykr9tdezi0-7csdfDhtdKR.fjvaSBiBX1F6tgzU09w3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#357",
          "display": "OATS DONOR CRITERIA PREFERRED DONOR TYPE"
        }
      ],
      "text": "OATS DONOR CRITERIA PREFERRED DONOR TYPE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:14:44Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Deceased or Living Donor"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eylg1IQ2jDdEJt48BhHcGvgwJnrfEb0yaaXwt.R0zVzi-TIGb4e7ORUNKHtNrz7ACl2c4lJloKpr5qx0XVxBuBg3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#345",
          "display": "OATS DONOR CRITERIA A2 OR A2B"
        }
      ],
      "text": "OATS DONOR CRITERIA A2 OR A2B"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:14:44Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueBoolean": true
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "ewA0Rk2N.GT0JVHmObAdandPc2wHZWSoAF0wnWmLPLgjdifLRo8T1QLCyKfo7PlbEPgKvQmrGuc6Zuh3qdfdkgA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#343",
          "display": "OATS DONOR CRITERIA ABO INCOMPATIBLE"
        }
      ],
      "text": "OATS DONOR CRITERIA ABO INCOMPATIBLE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:14:44Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueBoolean": false
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eqmhIaVWPEPWunkWCJOT7UveBDhuPQATLd6hopWLOceE3mqgWHYP3kVdDtZRk2TKCEnilW2khP4YSklgbk-7Czw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#347",
          "display": "OATS DONOR CRITERIA HCV AB+"
        }
      ],
      "text": "OATS DONOR CRITERIA HCV AB+"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:14:44Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueBoolean": false
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "epF6.iPUyo.CUVqf759h8MspMuXfmsXRHb-VTpI-BgQaAKuZqt12MHStJzSPwz8l6Rpv0kcPbm.4Hc7c8sKl7iA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#346",
          "display": "OATS DONOR CRITERIA HCV NAT+"
        }
      ],
      "text": "OATS DONOR CRITERIA HCV NAT+"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:14:44Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueBoolean": true
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eZBfCDwpUw0MSZjdm0lE0QPXXoMjnYMdoRSDt3xE6QNEmBeusTIm25L0AwzpAn.gz-qeZu366iCZPrXLek6I56Q3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#349",
          "display": "OATS DONOR CRITERIA EXTENDED CRITERIA DONOR (ECD)"
        }
      ],
      "text": "OATS DONOR CRITERIA EXTENDED CRITERIA DONOR (ECD)"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:14:44Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueBoolean": false
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eRmqOqzV5pBMxmml0m09q.laQiPt10d0tGDGSBVf0zjqXZVgmD.PIGz3Ma4oMBLweznB3oJDhH4Bx.tOKJ1freQ3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#361",
          "display": "OATS LIVING DONOR TO DONATE TO"
        }
      ],
      "text": "OATS LIVING DONOR TO DONATE TO"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
      "display": "MayUpgradeTwoFour, ScriptEightySevenD"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/euwNx6uQyy3aQAne1I5KUUw3"
      }
    ],
    "issued": "2024-11-06T22:03:36Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Pre-selected Recipient"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
   
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eHDAX8WFRPCqQPRr.KLBBkHRui2fqDDbxmNljH68w9hep76WHwSM7cEhri16tyxw4RXzdsKoSTIduy5fqfy1P.A3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#362",
          "display": "OATS PRE-SELECTED RECIPIENT"
        }
      ],
      "text": "OATS PRE-SELECTED RECIPIENT"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
      "display": "MayUpgradeTwoFour, ScriptEightySevenD"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/euwNx6uQyy3aQAne1I5KUUw3"
      }
    ],
    "issued": "2024-11-06T22:03:36Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Intended Recipient"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eIOdFNY2QutYtTz3.Q8zpgecZY.fi989O5LK4X2EsVL6LDB8y71B6aEdO6l9ysiCHydQiL84SH.kswzYeDRe0QA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#363",
          "display": "OATS TO BE ALLOCATED TO A RECIPIENT"
        }
      ],
      "text": "OATS TO BE ALLOCATED TO A RECIPIENT"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
      "display": "NoVirology, OATSTwo GroupSix"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eREj2vT7oIOc5gdeJ9U45ag3"
      }
    ],
    "issued": "2024-11-01T19:35:35Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Non-Directed Donation (KPD - End of Chain)"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
    
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eXX2ZT5xwnUCbQ1OB1JKNmL-19gpe7tMudJeIqwmNWWbbUarG5FBwjfE5jCeAvVUsClGooczH8vne8a8JgMQpfA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#358",
          "display": "OATS ABO A SUB TYPE"
        }
      ],
      "text": "OATS ABO A SUB TYPE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
      "display": "MayUpgradeTwoFour, ScriptEightySevenD"
    },
    "focus": [
      {
        "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
        "display": "MayUpgradeTwoFour, ScriptEightySevenD"
      }
    ],
    "issued": "2024-11-06T22:03:36Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "A1"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
   
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e-euaniUF7nr3PVd9Z46Gp4u0DFHLj20XFSDk3E1.-SjTSIpz4T.0Fj4Aloxyqr-ZUeMFe5RuQzNsL1z0aqJMWQ3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#034",
          "display": "EXCEPTIONAL DISTRIBUTION CONSIDERATION"
        }
      ],
      "text": "EXCEPTIONAL DISTRIBUTION CONSIDERATION"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
      "display": "MayUpgradeTwoFour, ScriptEightySevenD"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/euwNx6uQyy3aQAne1I5KUUw3"
      }
    ],
    "issued": "2024-11-06T22:03:40Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueBoolean": true
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eMylcWMPJuKzCxY0P8iXLe9Dk2jIuIXcUfcNv.U0pSobS8iDz-SEvsPHXfJgrScc6WcEtJby0V-BHRuvbyloqqg3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#373",
          "display": "OATS EXECPTIONAL DISTRIBUTION REASON(S)"
        }
      ],
      "text": "OATS EXECPTIONAL DISTRIBUTION REASON(S)"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
      "display": "MayUpgradeTwoFour, ScriptEightySevenD"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/euwNx6uQyy3aQAne1I5KUUw3"
      }
    ],
    "issued": "2024-11-18T17:55:08Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Other"
      },
      {
        "code": {
          "text": "Line 2"
        },
        "valueString": "History of malignancy"
      },
      {
        "code": {
          "text": "Line 3"
        },
        "valueString": "Travel to/lived in history with risk for"
      },
      {
        "code": {
          "text": "Line 4"
        },
        "valueString": "IRD - History IVDU in preceding 5 years"
      },
      {
        "code": {
          "text": "Line 5"
        },
        "valueString": "IRD - Known sex history risk"
      },
      {
        "code": {
          "text": "Line 6"
        },
        "valueString": "IRD - Incarceration > 72 hours in last 12 months"
      },
      {
        "code": {
          "text": "Line 7"
        },
        "valueString": "IRD - Tattoo/piercing with non-sterile procedures < 12 months"
      },
      {
        "code": {
          "text": "Line 8"
        },
        "valueString": "IRD - Intranasal cocaine use < 6 months"
      },
      {
        "code": {
          "text": "Line 9"
        },
        "valueString": "Positive for Sexually Transmitted Infection"
      },
      {
        "code": {
          "text": "Line 10"
        },
        "valueString": "Hep B Core +"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e00RDWiVoXIGigiKeEFy3-mnBm43OHPImjANAeZZqBbWdej2oKZiz-AZ0-stOeue2VdHDjHsQ7mxLVKGi0QtZ6w3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#374",
          "display": "OATS EXCEPTIONAL DISTRIBUTION OTHER REASON"
        }
      ],
      "text": "OATS EXCEPTIONAL DISTRIBUTION OTHER REASON"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
      "display": "MayUpgradeTwoFour, ScriptEightySevenD"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/euwNx6uQyy3aQAne1I5KUUw3"
      }
    ],
    "issued": "2024-11-06T22:03:58Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "This is the exceptional distribution other reason."
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
   
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eYtH0sqQjmcgUoqPRK4EmnMjBMOXbOl-luyAas.7Z37RtE13fGpDqJU9kko0uOVRTSaK2xtfSoaqALIpQrqOAEw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#404",
          "display": "OATS DONOR RELATIONSHIP V2"
        }
      ],
      "text": "OATS DONOR RELATIONSHIP V2"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
      "display": "MayUpgradeTwoFour, ScriptEightySevenD"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/euwNx6uQyy3aQAne1I5KUUw3"
      }
    ],
    "issued": "2024-12-23T19:08:10Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "PARENT"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
    
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eA60MOYd9.z8RLbBNJdW5GukGwZQ9lWxIF4uYtumT0Kg2sgRyBZ1pUm7YtJt-JuGOBXN8N3ghSagqmIRZqmfA5A3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#112",
          "display": "DONOR RECOVERY SURGEON"
        }
      ],
      "text": "DONOR RECOVERY SURGEON"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
      "display": "MayUpgradeTwoFour, ScriptEightySevenD"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/euwNx6uQyy3aQAne1I5KUUw3"
      }
    ],
    "issued": "2024-10-10T13:37:30Z",
    "performer": [
      {
        "reference": "Practitioner/e-yoIPAqwXr6xcRnkjh7bqA3",
        "display": "INTRA-OP, NURSE"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Dr. Lambe"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
   
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eBQ2hevutR2qPSNe41N9ZN74nydvVZXobzDOm7h3IbnSzABLnJ7pYu8R9MWJ6pgB1qY0km6qFhJZ7NhJnKyu2Yg3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#398",
          "display": "OATS RECOVERY START"
        }
      ],
      "text": "OATS RECOVERY START"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
      "display": "MayUpgradeTwoFour, ScriptEightySevenD"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/euwNx6uQyy3aQAne1I5KUUw3"
      }
    ],
    "issued": "2024-12-11T19:14:11Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2024-10-10T14:41:00Z"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
   
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e7DDutO7oLy-Vf1leMByWP0kJMKTVugG2ZT888qmtU7QlAIvar-ZbrAVUfr4DMUIayGK4ozpiBccVCU6E0cUOMQ3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#399",
          "display": "OATS RECOVERY END"
        }
      ],
      "text": "OATS RECOVERY END"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
      "display": "MayUpgradeTwoFour, ScriptEightySevenD"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/euwNx6uQyy3aQAne1I5KUUw3"
      }
    ],
    "issued": "2024-12-11T19:14:11Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2024-10-10T15:17:00Z"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
   
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "ew6G70ye3DdpZ2RR7VTM.zgoffofpUCobC7x6U2-hNhUji6AVDxPCUN8PXcroquoAgaqVpkOQs.9tHmS6VPvsmw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#400",
          "display": "OATS CROSS CLAMP"
        }
      ],
      "text": "OATS CROSS CLAMP"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
      "display": "MayUpgradeTwoFour, ScriptEightySevenD"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/euwNx6uQyy3aQAne1I5KUUw3"
      }
    ],
    "issued": "2024-12-11T19:11:56Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2024-10-10T13:32:00Z"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
    
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eDXTTcWT5s3vfbESqUSt.WBSIxujM9vaHdk5SJi.63gRPVxtoWDf1jEh8vQeVJR49ESOTlLM731p5FbuNc2vveT8PICoEt79BPKJaRi03vQi7.Of4qj7wdfWeUSGyYms13",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#114",
          "display": "DONOR - DONOR FLUSH TIME END/CROSS CLAMP"
        }
      ],
      "text": "DONOR - DONOR FLUSH TIME END/CROSS CLAMP"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "BodyStructure/e5079wnZFwMKK1LMi.BaZ5Njmt163zL8pcEkSHIdnW7r638nYJjq.nM9lp3kUyiIe3",
        "display": "RIGHT KIDNEY_102924"
      }
    ],
    "issued": "2024-10-10T13:38:48Z",
    "performer": [
      {
        "reference": "Practitioner/e-yoIPAqwXr6xcRnkjh7bqA3",
        "display": "INTRA-OP, NURSE"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2024-10-10T13:38:00Z"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
      ],
      
      [
          {
              "fullUrl": "http://localhost:4004/hapi-fhir-jpaserver/fhir/EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3",
              "resource": {
                  "resourceType": "EpisodeOfCare",
                  "id": "eh55rvilfnQJ.b5vLlatESw3",
                  "meta": {
                      "versionId": "1",
                      "lastUpdated": "2025-05-20T18:20:14.045+00:00",
                      "source": "#zqE5oLQ57XthVqjV"
                  },
                  "extension": [
                      {
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name",
                          "valueString": "Kidney Transplant Waitlist - Qualified: 27/1/2025"
                      },
                      {
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient",
                          "valueCodeableConcept": {
                              "coding": [
                                  {
                                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                                      "code": "2",
                                      "display": "Recipient"
                                  }
                              ],
                              "text": "Recipient"
                          }
                      },
                      {
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator",
                          "extension": [
                              {
                                  "url": "organ-class",
                                  "valueCodeableConcept": {
                                      "coding": [
                                          {
                                              "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                                              "code": "16",
                                              "display": "Kidney"
                                          }
                                      ],
                                      "text": "Kidney"
                                  }
                              },
                              {
                                  "url": "coordinator",
                                  "valueReference": {
                                      "reference": "Practitioner/e6zs7QnhOHCa9Td08H6Y8MF4G-UvFNh0wg85S4XIH0Vc3",
                                      "type": "Practitioner",
                                      "display": "Jennifer Donnelly"
                                  }
                              }
                          ]
                      },
                      {
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status",
                          "extension": [
                              {
                                  "url": "phase",
                                  "valueCodeableConcept": {
                                      "coding": [
                                          {
                                              "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                                              "code": "30",
                                              "display": "Waitlist"
                                          }
                                      ],
                                      "text": "Waitlist"
                                  }
                              },
                              {
                                  "url": "status",
                                  "valueString": "Active"
                              },
                              {
                                  "url": "effective",
                                  "valueDate": "2025-01-27"
                              }
                          ]
                      },
                      {
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date",
                          "valueDate": "2024-05-08"
                      },
                      {
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-evaluation",
                          "valuePeriod": {
                              "start": "2024-11-29",
                              "end": "2025-01-27"
                          }
                      },
                      {
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-center-waitlist-date",
                          "valueDate": "2025-01-27"
                      },
                      {
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-waitlist-date",
                          "valueDate": "2025-01-27"
                      },
                      {
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center",
                          "valueString": "St. Joseph's Healthcare Hamilton (Hamilton, ON)"
                      },
                      {
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ",
                          "valueReference": {
                              "reference": "BodyStructure/etcItSK6S-VNvvdoYPSAegTOkTI3pkr-ywEFGTX8QdFASQ58bwrFipL5299Fb3bzT3",
                              "type": "BodyStructure",
                              "display": "Left Kidney"
                          }
                      }
                  ],
                  "status": "active",
                  "type": [
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
                                  "code": "49",
                                  "display": "Transplant"
                              },
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
                                  "code": "4",
                                  "display": "Transplant"
                              }
                          ],
                          "text": "Transplant"
                      }
                  ],
                  "patient": {
                      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                      "type": "Patient",
                      "display": "Kumar, Ram_Update"
                  },
                  "period": {
                      "start": "2024-05-08"
                  },
                  "team": [
                      {
                          "reference": "CareTeam/em44bHHpWYvu4PckY1XP9uZsKtuMc6dvpJ4P8rW7LxWw3",
                          "type": "CareTeam"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          }
      ]
  ],
  "sectionsChecked": []
};
const mock_patient_RAM = {
  "resourceType": "Patient",
  "id": "eTBYY2m2lofBOygbq9ebQjg3",
  "meta": {
      "versionId": "1",
      "lastUpdated": "2025-04-28T19:09:43.670+00:00",
      "source": "#xDDqZabb6i5txIYl"
  },
  "text": {
      "status": "generated",
      "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><div class=\"hapiHeaderText\">Ram_Update <b>KUMAR </b></div><table class=\"hapiPropertyTable\"><tbody><tr><td>Identifier</td><td>SJT2S3Q1XVZ9NXP</td></tr><tr><td>Address</td><td><span>abc street </span><br/><span>Oshawa </span><span>ON </span><span>CA </span></td></tr><tr><td>Date of birth</td><td><span>11 October 1967</span></td></tr></tbody></table></div>"
  },
  "extension": [
      {
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/legal-sex",
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.698084.130.657370.25811",
                      "code": "male",
                      "display": "male"
                  }
              ]
          }
      },
      {
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/sex-for-clinical-use",
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.698084.130.657370.25811",
                      "code": "male",
                      "display": "male"
                  }
              ]
          }
      },
      {
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-race",
          "extension": [
              {
                  "url": "ombCategory",
                  "valueCoding": {
                      "system": "http://terminology.hl7.org/CodeSystem/v3-NullFlavor",
                      "code": "UNK",
                      "display": "Unknown"
                  }
              },
              {
                  "url": "text",
                  "valueString": "Unknown"
              }
          ]
      },
      {
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-ethnicity",
          "extension": [
              {
                  "url": "text",
                  "valueString": "Unknown"
              }
          ]
      },
      {
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-sex",
          "valueCode": "248153007"
      },
      {
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/calculated-pronouns-to-use-for-text",
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "http://loinc.org",
                      "code": "LA29518-0",
                      "display": "he/him/his/his/himself"
                  }
              ]
          }
      }
  ],
  "identifier": [
      {
          "use": "usual",
          "type": {
              "text": "CEID" 
          },
          "system": "urn:oid:1.2.840.114350.1.13.403.3.7.3.688884.100",
          "value": "SJT2S3Q1XVZ9NXP"
      },
      {
          "use": "usual",
          "type": {
              "text": "EPIC"
          },
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.0",
          "value": "E17286"
      },
      {
          "use": "usual",
          "type": {
              "text": "EXTERNAL"
          },
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.698084",
          "value": "Z18990"
      },
      {
          "use": "usual",
          "type": {
              "text": "FHIR"
          },
          "system": "http://open.epic.com/FHIR/StructureDefinition/patient-dstu2-fhir-id",
          "value": "Tl8fLgaHMq9pzzlLW2910c9FHa3PHNPtk.L.ai-wcq9oB"
      },
      {
          "use": "usual",
          "type": {
              "text": "FHIR STU3"
          },
          "system": "http://open.epic.com/FHIR/StructureDefinition/patient-fhir-id",
          "value": "eTBYY2m2lofBOygbq9ebQjg3"
      },
      {
          "use": "usual",
          "type": {
              "text": "INTERNAL"
          },
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.698084",
          "value": "    Z18990"
      },
      {
          "use": "usual",
          "type": {
              "text": "EPI"
          },
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.14",
          "value": "J0002009634"
      },
      {
          "use": "usual",
          "type": {
              "text": "TGLNRecipient"
          },
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.1650000001",
          "value": "650913"
      }
  ],
  "active": true,
  "name": [
      {
          "use": "official",
          "text": "Ram_Update Kumar",
          "family": "Kumar",
          "given": [
              "Ram_Update",
              "Middle"
          ]
      },
      {
          "use": "usual",
          "text": "Ram_Update Kumar",
          "family": "Kumar",
          "given": [
              "Ram_Update" 
          ]
      },
      {
          "use": "old",
          "text": "KUMAR,RAM",
          "family": "Kumar",
          "given": [
              "Ram"
          ]
      }
  ],
  "telecom": [
      {
          "system": "phone",
          "value": "416-989-8583",
          "use": "home",
          "rank": 2
      },
      {
          "system": "phone",
          "value": "226-989-8585",
          "use": "work",
          "rank": 3
      },
      {
          "system": "phone",
          "value": "905-522-1155",
          "use": "mobile" 
      },
      {
          "system": "other",
          "value": "519-787-8964",
          "rank": 1
      },
      {
          "system": "fax",
          "value": "519-502-1122",
          "use": "home"
      },
      {
          "system": "other",
          "value": "705-522-1122"
      },
      {
          "system": "email",
          "value": "5687@hotmail.com",
          "rank": 1
      },
      {
        "system": "pager",
        "value": "ttte0",
        "rank": 1
    }
  ],
  "gender": "male",
  "birthDate": "1967-10-11",
  "deceasedBoolean": true,
  "address": [
      {
          "use": "home",
          "line": [
              "abc street"
          ],
          "city": "Oshawa",
          "state": "ON",
          "postalCode": "L1J 0V4",
          "country": "CA",
          "period": {
              "start": "2024-06-13"
          }
      },
      {
          "use": "old",
          "line": [
              "abc street"
          ],
          "city": "City of Colorado",
          "postalCode": "C1C 2C8",
          "country": "CA"
      },
      {
          "use": "old",
          "line": [
              "abc street"
          ],
          "city": "Oshawa",
          "state": "ON",
          "postalCode": "L1J 0V4",
          "country": "CA"
      }
  ],
  "managingOrganization": {
      "reference": "Organization/eoC57gcpft1DFUAEXm4.fXg3",
      "display": "St. Joseph's Healthcare Hamilton"
  }
};
const mock_patient_SMHOne = {
  "resourceType": "Patient",
  "id": "eZ4Fxy8ToBxyhpU9iFBCBKA3",
  "extension": [
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.698084.130.657370.334219900",
                      "code": "male",
                      "display": "male"
                  }
              ],
              "text": "Male"
          },
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/legal-sex"
      },
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.698084.130.657370.334219900",
                      "code": "male",
                      "display": "male"
                  }
              ]
          },
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/sex-for-clinical-use"
      },
      {
          "valueCode": "M",
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-birthsex"
      },
      {
          "extension": [
              {
                  "valueCoding": {
                      "system": "http://terminology.hl7.org/CodeSystem/v3-NullFlavor",
                      "code": "UNK",
                      "display": "Unknown"
                  },
                  "url": "ombCategory"
              },
              {
                  "valueString": "Unknown",
                  "url": "text"
              }
          ],
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-race"
      },
      {
          "extension": [
              {
                  "valueString": "Unknown",
                  "url": "text"
              }
          ],
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-ethnicity"
      },
      {
          "valueCode": "248153007",
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-sex"
      },
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "http://loinc.org",
                      "code": "LA29518-0",
                      "display": "he/him/his/his/himself"
                  }
              ]
          },
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/calculated-pronouns-to-use-for-text"
      }
  ],
  "identifier": [
      {
          "use": "usual",
          "type": {
              "text": "CEID"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.688884.100",
          "value": "UPOKDLK7VXPBVRP"
      },
      {
          "use": "usual",
          "type": {
              "text": "EPIC"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.0",
          "value": "E3517"
      },
      {
          "use": "usual",
          "type": {
              "text": "EPI"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.14",
          "value": "900000811"
      },
      {
          "use": "usual",
          "type": {
              "text": "EXTERNAL"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698084",
          "value": "Z3523"
      },
      {
          "use": "usual",
          "type": {
              "text": "FHIR"
          },
          "system": "http://open.epic.com/FHIR/StructureDefinition/patient-dstu2-fhir-id",
          "value": "TSEz66EdHpd1B2KJf9z7AfVZaMfqLagYbO2VwNdy1OngB"
      },
      {
          "use": "usual",
          "type": {
              "text": "FHIR STU3"
          },
          "system": "http://open.epic.com/FHIR/StructureDefinition/patient-fhir-id",
          "value": "eZ4Fxy8ToBxyhpU9iFBCBKA3"
      },
      {
          "use": "usual",
          "type": {
              "text": "INTERNAL"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698084",
          "value": "     Z3523"
      }
  ],
  "active": true,
  "name": [
      {
          "use": "official",
          "text": "RecipientOne SMHOne",
          "family": "SMHOne",
          "given": [
              "RecipientOne"
          ]
      },
      {
          "use": "usual",
          "text": "RecipientOne SMHOne",
          "family": "SMHOne",
          "given": [
              "RecipientOne"
          ]
      }
  ],
  "gender": "male",
  "birthDate": "1991-11-07",
  "deceasedBoolean": false,
  "address": [
      {
          "use": "home",
          "text": "465 Yonge St\r\nToronto M4Y 1X4\r\nCanada",
          "line": [
              "465 Yonge St"
          ],
          "city": "Toronto",
          "state": "ON",
          "postalCode": "M4Y 1X4",
          "country": "CA",
          "period": {
              "start": "2025-08-05"
          }
      }
  ],
  "managingOrganization": {
      "reference": "Organization/epl8pKYqH0a4Few804sH00Q3",
      "display": "UNITY SERVICE AREA"
  }
};
const mock_patient_SMHTwo = {
  "resourceType": "Patient",
  "id": "eg4w2uavogNXkl9HAAw2Pzg3",
  "extension": [
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.698084.130.657370.334219900",
                      "code": "female",
                      "display": "female"
                  }
              ],
              "text": "Female"
          },
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/legal-sex"
      },
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "http://hl7.org/fhir/gender-identity",
                      "code": "male",
                      "display": "male"
                  }
              ],
              "text": "Male"
          },
          "url": "http://hl7.org/fhir/StructureDefinition/patient-genderIdentity"
      },
      {
          "valueCode": "F",
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-birthsex"
      },
      {
          "extension": [
              {
                  "valueCoding": {
                      "system": "http://terminology.hl7.org/CodeSystem/v3-NullFlavor",
                      "code": "UNK",
                      "display": "Unknown"
                  },
                  "url": "ombCategory"
              },
              {
                  "valueString": "Unknown",
                  "url": "text"
              }
          ],
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-race"
      },
      {
          "extension": [
              {
                  "valueString": "Unknown",
                  "url": "text"
              }
          ],
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-ethnicity"
      },
      {
          "valueCode": "184115007",
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-sex"
      },
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "http://snomed.info/sct",
                      "code": "446151000124109",
                      "display": "Identifies as male gender (finding)"
                  }
              ]
          },
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-genderIdentity"
      },
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "http://loinc.org",
                      "code": "LA29518-0",
                      "display": "he/him/his/his/himself"
                  }
              ]
          },
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/calculated-pronouns-to-use-for-text"
      }
  ],
  "identifier": [
      {
          "use": "usual",
          "type": {
              "text": "CEID"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.688884.100",
          "value": "UPOD37D37Q75KG8"
      },
      {
          "use": "usual",
          "type": {
              "text": "EPIC"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.0",
          "value": "E3518"
      },
      {
          "use": "usual",
          "type": {
              "text": "EPI"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.14",
          "value": "900000812"
      },
      {
          "use": "usual",
          "type": {
              "text": "EXTERNAL"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698084",
          "value": "Z3524"
      },
      {
          "use": "usual",
          "type": {
              "text": "FHIR"
          },
          "system": "http://open.epic.com/FHIR/StructureDefinition/patient-dstu2-fhir-id",
          "value": "T1gbhbIGozuug.5sTvq-ztiHvc4F2aPIfYc1U36LOy9cB"
      },
      {
          "use": "usual",
          "type": {
              "text": "FHIR STU3"
          },
          "system": "http://open.epic.com/FHIR/StructureDefinition/patient-fhir-id",
          "value": "eg4w2uavogNXkl9HAAw2Pzg3"
      },
      {
          "use": "usual",
          "type": {
              "text": "INTERNAL"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698084",
          "value": "     Z3524"
      },
      {
          "use": "usual",
          "system": "https://open.epic.com/FHIR/StructureDefinition/PayerMemberId",
          "value": "3011479387"
      }
  ],
  "active": true,
  "name": [
      {
          "use": "official",
          "text": "RecipientTwo EMRTwo SMHTwo",
          "family": "SMHTwo",
          "given": [
              "RecipientTwo",
              "EMRTwo"
          ]
      },
      {
          "use": "usual",
          "text": "RecipientTwo EMRTwo SMHTwo",
          "family": "SMHTwo",
          "given": [
              "RecipientTwo",
              "EMRTwo"
          ]
      }
  ],
  "telecom": [
      {
          "system": "phone",
          "value": "+1 416-989-8583",
          "use": "home",
          "rank": 1
      },
      {
          "system": "phone",
          "value": "+1 226-989-8585",
          "use": "mobile",
          "rank": 2
      },
      {
          "system": "email",
          "value": "qwerty@gmail.com",
          "rank": 1
      }
  ],
  "gender": "female",
  "birthDate": "1990-11-11",
  "deceasedBoolean": false,
  "address": [
      {
          "use": "home",
          "text": "123 abc street\r\nCity of Colorado M4Y 1X4\r\nCanada",
          "line": [
              "123 abc street"
          ],
          "city": "City of Colorado",
          "state": "MB",
          "postalCode": "M4Y 1X4",
          "country": "CA",
          "period": {
              "start": "2025-08-05"
          }
      }
  ],
  "managingOrganization": {
      "reference": "Organization/epl8pKYqH0a4Few804sH00Q3",
      "display": "UNITY SERVICE AREA"
  }
};
const mock_patient_SMHThree = {
  "resourceType": "Patient",
  "id": "eFH6wiZlxSz18W5j4PJARuw3",
  "extension": [
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.698084.130.657370.334219900",
                      "code": "unknown",
                      "display": "unknown"
                  }
              ],
              "text": "Unknown"
          },
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/legal-sex"
      },
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "http://hl7.org/fhir/gender-identity",
                      "code": "other",
                      "display": "other"
                  }
              ],
              "text": "Not Listed"
          },
          "url": "http://hl7.org/fhir/StructureDefinition/patient-genderIdentity"
      },
      {
          "extension": [
              {
                  "valueCoding": {
                      "system": "http://terminology.hl7.org/CodeSystem/v3-NullFlavor",
                      "code": "UNK",
                      "display": "Unknown"
                  },
                  "url": "ombCategory"
              },
              {
                  "valueString": "Unknown",
                  "url": "text"
              }
          ],
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-race"
      },
      {
          "extension": [
              {
                  "valueString": "Unknown",
                  "url": "text"
              }
          ],
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-ethnicity"
      },
      {
          "valueCode": "184115007",
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-sex"
      },
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "https://open.epic.com/FHIR/Epic/pronoun-set",
                      "code": "EP-PS-DO-NOT-USE-PRONOUNS",
                      "display": "do not use pronouns"
                  }
              ]
          },
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/calculated-pronouns-to-use-for-text"
      }
  ],
  "identifier": [
      {
          "use": "usual",
          "type": {
              "text": "CEID"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.688884.100",
          "value": "UPODMC76W6DRRTN"
      },
      {
          "use": "usual",
          "type": {
              "text": "EPIC"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.0",
          "value": "E3521"
      },
      {
          "use": "usual",
          "type": {
              "text": "EPI"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.14",
          "value": "900000815"
      },
      {
          "use": "usual",
          "type": {
              "text": "EXTERNAL"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698084",
          "value": "Z3527"
      },
      {
          "use": "usual",
          "type": {
              "text": "FHIR"
          },
          "system": "http://open.epic.com/FHIR/StructureDefinition/patient-dstu2-fhir-id",
          "value": "TSsiMsJ3s0nQoh-HBSzBQoaR.JNQc6bZazHvzt3cZaToB"
      },
      {
          "use": "usual",
          "type": {
              "text": "FHIR STU3"
          },
          "system": "http://open.epic.com/FHIR/StructureDefinition/patient-fhir-id",
          "value": "eFH6wiZlxSz18W5j4PJARuw3"
      },
      {
          "use": "usual",
          "type": {
              "text": "INTERNAL"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698084",
          "value": "     Z3527"
      },
      {
          "use": "usual",
          "system": "https://open.epic.com/FHIR/StructureDefinition/PayerMemberId",
          "value": "574357317"
      }
  ],
  "active": true,
  "name": [
      {
          "use": "official",
          "text": "RecipientThree EMRThree SMHThree",
          "family": "SMHThree",
          "given": [
              "RecipientThree",
              "EMRThree"
          ]
      },
      {
          "use": "usual",
          "text": "RecipientThree EMRThree SMHThree",
          "family": "SMHThree",
          "given": [
              "RecipientThree",
              "EMRThree"
          ]
      }
  ],
  "gender": "unknown",
  "birthDate": "1960-12-12",
  "deceasedBoolean": false,
  "address": [
      {
          "use": "home",
          "text": "280 Dundas Street\r\nRichmond Hill AL 23456\r\nUnited States of America",
          "line": [
              "280 Dundas Street"
          ],
          "city": "Richmond Hill",
          "state": "AL",
          "postalCode": "23456",
          "country": "US",
          "period": {
              "start": "2025-08-06"
          }
      }
  ],
  "managingOrganization": {
      "reference": "Organization/epl8pKYqH0a4Few804sH00Q3",
      "display": "UNITY SERVICE AREA"
  }
};
const mock_patient_SMHFour = {
  "resourceType": "Patient",
  "id": "eyOhcUNJTB0DMWk0EgziXJA3",
  "extension": [
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.698084.130.657370.334219900",
                      "code": "male",
                      "display": "male"
                  }
              ],
              "text": "Male"
          },
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/legal-sex"
      },
      {
        "valueCodeableConcept": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/gender-identity",
              "code": "other",
              "display": "other"
            }
          ],
          "text": "Trans Woman"
        },
        "url": "http://hl7.org/fhir/StructureDefinition/patient-genderIdentity"
      },
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.698084.130.657370.334219900",
                      "code": "male",
                      "display": "male"
                  }
              ]
          },
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/sex-for-clinical-use"
      },
      {
          "extension": [
              {
                  "valueCoding": {
                      "system": "http://terminology.hl7.org/CodeSystem/v3-NullFlavor",
                      "code": "UNK",
                      "display": "Unknown"
                  },
                  "url": "ombCategory"
              },
              {
                  "valueString": "Unknown",
                  "url": "text"
              }
          ],
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-race"
      },
      {
          "extension": [
              {
                  "valueString": "Unknown",
                  "url": "text"
              }
          ],
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-ethnicity"
      },
      {
          "valueCode": "248153007",
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-sex"
      },
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "http://loinc.org",
                      "code": "LA29518-0",
                      "display": "he/him/his/his/himself"
                  }
              ]
          },
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/calculated-pronouns-to-use-for-text"
      }
  ],
  "identifier": [
      {
          "use": "usual",
          "type": {
              "text": "CEID"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.688884.100",
          "value": "UPO8PZD582H7H2D"
      },
      {
          "use": "usual",
          "type": {
              "text": "EPIC"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.0",
          "value": "E3519"
      },
      {
          "use": "usual",
          "type": {
              "text": "EPI"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.14",
          "value": "900000813"
      },
      {
          "use": "usual",
          "type": {
              "text": "EXTERNAL"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698084",
          "value": "Z3525"
      },
      {
          "use": "usual",
          "type": {
              "text": "FHIR"
          },
          "system": "http://open.epic.com/FHIR/StructureDefinition/patient-dstu2-fhir-id",
          "value": "TjDLEYtFXc2J-HkCOO27T-rI08QPCJMdudbuYvMpyQGoB"
      },
      {
          "use": "usual",
          "type": {
              "text": "FHIR STU3"
          },
          "system": "http://open.epic.com/FHIR/StructureDefinition/patient-fhir-id",
          "value": "eyOhcUNJTB0DMWk0EgziXJA3"
      },
      {
          "use": "usual",
          "type": {
              "text": "INTERNAL"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698084",
          "value": "     Z3525"
      },
      {
          "use": "usual",
          "system": "https://open.epic.com/FHIR/StructureDefinition/PayerMemberId",
          "value": "1234567890"
      }
  ],
  "active": true,
  "name": [
      {
          "use": "official",
          "text": "RecipientFour SMHFour",
          "family": "SMHFour",
          "given": [
              "RecipientFour"
          ]
      },
      {
          "use": "usual",
          "text": "RecipientFour SMHFour",
          "family": "SMHFour",
          "given": [
              "RecipientFour"
          ]
      }
  ],
  "gender": "male",
  "birthDate": "1960-11-12",
  "deceasedBoolean": false,
  "address": [
      {
          "use": "home",
          "text": "280 Dundas Street\r\nRichmond Hill AL 23456\r\nUnited States of America",
          "line": [
              "280 Dundas Street"
          ],
          "city": "Richmond Hill",
          "state": "AL",
          "postalCode": "23456",
          "country": "US",
          "period": {
              "start": "2025-08-05"
          }
      }
  ],
  "managingOrganization": {
      "reference": "Organization/epl8pKYqH0a4Few804sH00Q3",
      "display": "UNITY SERVICE AREA"
  }
};
const initialDataMock3 = {
  "patient": {
      "resourceType": "Patient",
      "id": "eZ4Fxy8ToBxyhpU9iFBCBKA3",
      "extension": [
          {
              "valueCodeableConcept": {
                  "coding": [
                      {
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.698084.130.657370.334219900",
                          "code": "male",
                          "display": "male"
                      }
                  ],
                  "text": "Male"
              },
              "url": "http://open.epic.com/FHIR/StructureDefinition/extension/legal-sex"
          },
          {
              "valueCodeableConcept": {
                  "coding": [
                      {
                          "system": "http://hl7.org/fhir/gender-identity",
                          "code": "other",
                          "display": "other"
                      }
                  ],
                  "text": "Trans Woman"
              },
              "url": "http://hl7.org/fhir/StructureDefinition/patient-genderIdentity"
          },
          {
              "extension": [
                  {
                      "valueCoding": {
                          "system": "http://terminology.hl7.org/CodeSystem/v3-NullFlavor",
                          "code": "UNK",
                          "display": "Unknown"
                      },
                      "url": "ombCategory"
                  },
                  {
                      "valueString": "Unknown",
                      "url": "text"
                  }
              ],
              "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-race"
          },
          {
              "extension": [
                  {
                      "valueString": "Unknown",
                      "url": "text"
                  }
              ],
              "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-ethnicity"
          },
          {
              "valueCode": "184115007",
              "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-sex"
          },
          {
              "valueCodeableConcept": {
                  "coding": [
                      {
                          "system": "https://open.epic.com/FHIR/Epic/pronoun-set",
                          "code": "EP-PS-DO-NOT-USE-PRONOUNS",
                          "display": "do not use pronouns"
                      }
                  ]
              },
              "url": "http://open.epic.com/FHIR/StructureDefinition/extension/calculated-pronouns-to-use-for-text"
          }
      ],
      "identifier": [
          {
              "use": "usual",
              "type": {
                  "text": "EPIC"
              },
              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.0",
              "value": "E3517"
          },
          {
              "use": "usual",
              "type": {
                  "text": "EPI"
              },
              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.14",
              "value": "900000811"
          },
          {
              "use": "usual",
              "type": {
                  "text": "EXTERNAL"
              },
              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698084",
              "value": "Z3523"
          },
          {
              "use": "usual",
              "type": {
                  "text": "FHIR"
              },
              "system": "http://open.epic.com/FHIR/StructureDefinition/patient-dstu2-fhir-id",
              "value": "TSEz66EdHpd1B2KJf9z7AfVZaMfqLagYbO2VwNdy1OngB"
          },
          {
              "use": "usual",
              "type": {
                  "text": "FHIR STU3"
              },
              "system": "http://open.epic.com/FHIR/StructureDefinition/patient-fhir-id",
              "value": "eZ4Fxy8ToBxyhpU9iFBCBKA3"
          },
          {
              "use": "usual",
              "type": {
                  "text": "INTERNAL"
              },
              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698084",
              "value": "     Z3523"
          },
          {
              "use": "usual",
              "type": {
                  "text": "TGLNRecipient"
              },
              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.1650000006",
              "value": "67540"
          },
          {
              "use": "usual",
              "system": "https://open.epic.com/FHIR/StructureDefinition/PayerMemberId",
              "value": "1234567890"
          }
      ],
      "active": true,
      "name": [
          {
              "use": "official",
              "text": "RecipientOne SMHOne",
              "family": "SMHOne",
              "given": [
                  "RecipientOne"
              ]
          },
          {
              "use": "usual",
              "text": "RecipientOne SMHOne",
              "family": "SMHOne",
              "given": [
                  "RecipientOne"
              ]
          }
      ],
      "telecom": [
          {
              "system": "phone",
              "value": "+1 416-360-4000",
              "use": "home"
          },
          {
              "system": "phone",
              "value": "+1 416-340-3666",
              "use": "work"
          },
          {
              "system": "phone",
              "value": "+1 416-285-3666",
              "use": "mobile"
          },
          {
              "system": "email",
              "value": "123@oats.ca",
              "rank": 1
          }
      ],
      "gender": "male",
      "birthDate": "1991-11-07",
      "deceasedBoolean": false,
      "address": [
          {
              "use": "home",
              "text": "465 Yonge St\r\nToronto TORONTO M4Y 1X4\r\nCanada",
              "line": [
                  "465 Yonge St"
              ],
              "city": "Toronto",
              "district": "TORONTO",
              "state": "ON",
              "postalCode": "M4Y 1X4",
              "country": "CA",
              "period": {
                  "start": "2025-10-02"
              }
          },
          {
              "use": "old",
              "text": "465 Yonge St\r\nToronto M4Y 1X4\r\nCanada",
              "line": [
                  "465 Yonge St"
              ],
              "city": "Toronto",
              "state": "ON",
              "postalCode": "M4Y 1X4",
              "country": "CA",
              "period": {
                  "start": "2025-08-05",
                  "end": "2025-10-02"
              }
          }
      ],
      "managingOrganization": {
          "reference": "Organization/epl8pKYqH0a4Few804sH00Q3",
          "display": "UNITY SERVICE AREA"
      }
  },
  "entries": [
      [
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Coverage/emhPlfKo8G47e2Us700i22TZOql9PFZtf2Pz94OUjjQ03"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Coverage/emhPlfKo8G47e2Us700i22TZOql9PFZtf2Pz94OUjjQ03",
              "resource": {
                  "resourceType": "Coverage",
                  "id": "emhPlfKo8G47e2Us700i22TZOql9PFZtf2Pz94OUjjQ03",
                  "contained": [
                      {
                          "resourceType": "Organization",
                          "id": "org1",
                          "type": [
                              {
                                  "coding": [
                                      {
                                          "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.678671.120",
                                          "code": "3",
                                          "display": "Insurance Plan"
                                      }
                                  ],
                                  "text": "Insurance Plan"
                              }
                          ],
                          "name": "OHIP",
                          "contact": [
                              {
                                  "purpose": {
                                      "coding": [
                                          {
                                              "system": "http://terminology.hl7.org/CodeSystem/contactentity-type",
                                              "code": "BILL",
                                              "display": "Billing"
                                          }
                                      ]
                                  },
                                  "address": {
                                      "use": "billing",
                                      "line": [
                                          "EXEC TOWER  OSHAWA CENTRE",
                                          "419 KING ST WEST"
                                      ],
                                      "city": "Toronto",
                                      "state": "ON",
                                      "postalCode": "L1H 8L4",
                                      "country": "CA"
                                  }
                              }
                          ]
                      }
                  ],
                  "extension": [
                      {
                          "valueReference": {
                              "reference": "#org1"
                          },
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/billing-organization"
                      }
                  ],
                  "identifier": [
                      {
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.678671",
                          "value": "1465"
                      },
                      {
                          "type": {
                              "coding": [
                                  {
                                      "system": "http://terminology.hl7.org/CodeSystem/v2-0203",
                                      "code": "MB",
                                      "display": "Member Number"
                                  }
                              ]
                          },
                          "value": "1234567890"
                      }
                  ],
                  "status": "active",
                  "subscriber": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "subscriberId": "1234567890",
                  "beneficiary": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "relationship": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.678671.305",
                              "code": "01",
                              "display": "Self"
                          },
                          {
                              "system": "http://terminology.hl7.org/CodeSystem/subscriber-relationship",
                              "code": "self",
                              "display": "Self"
                          }
                      ],
                      "text": "Self"
                  },
                  "period": {
                      "start": "2013-03-31"
                  },
                  "payor": [
                      {
                          "reference": "Organization/edfM-VF1iMIWPWTWdwpoNdQ3",
                          "identifier": {
                              "use": "official",
                              "system": "http://open.epic.com/FHIR/StructureDefinition/payer-id",
                              "value": "10000"
                          },
                          "display": "OHIP"
                      }
                  ],
                  "class": [
                      {
                          "extension": [
                              {
                                  "valueIdentifier": {
                                      "use": "secondary",
                                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698080",
                                      "value": "1000001"
                                  },
                                  "url": "http://open.epic.com/FHIR/StructureDefinition/extension/epic-id"
                              }
                          ],
                          "type": {
                              "coding": [
                                  {
                                      "system": "http://terminology.hl7.org/CodeSystem/coverage-class",
                                      "code": "plan",
                                      "display": "Plan"
                                  }
                              ]
                          },
                          "value": "1000001",
                          "name": "OHIP"
                      }
                  ],
                  "order": 1
              },
              "search": {
                  "mode": "match"
              }
          }
      ],
      [
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f6a65I9z6dU8udcUn9imK2Q4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f6a65I9z6dU8udcUn9imK2Q4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f6a65I9z6dU8udcUn9imK2Q4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#059",
                              "display": "cPRA"
                          }
                      ],
                      "text": "CPRA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueQuantity": {
                              "value": 456
                          }
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSzs64wACKwaRyM0ChW-8gg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSzs64wACKwaRyM0ChW-8gg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fSzs64wACKwaRyM0ChW-8gg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16525",
                              "display": "OATS - PUSH DATA"
                          }
                      ],
                      "text": "OATS - PUSH DATA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fsEjuE08ag3FANsbstvAfMA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fsEjuE08ag3FANsbstvAfMA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fsEjuE08ag3FANsbstvAfMA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16531",
                              "display": "OATS - GENERAL KIDNEY COMMENTS"
                          }
                      ],
                      "text": "OATS - GENERAL KIDNEY COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Comments six"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
 
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "elDMk6vH3DhXdUaTg5SUXJwXtvmXFV7qP19LVRNLmkyg835ouDn6aT5w.V7XvGW-HGubK7BlUGOrB.oM3S0Prcg3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#336",
                    "display": "OATS REFERRAL DECISION DECLINE REASON"
                  }
                ],
                "text": "OATS REFERRAL DECISION DECLINE REASON"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "MayUpgradeTwoFour, ScriptEightySevenR"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                }
              ],
              "issued": "2024-11-06T21:05:22Z",
              "performer": [
                {
                  "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
                  "display": "GONZALES, ALVIN"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Patient does not meet referral criteria"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
   
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "eBQ2hevutR2qPSNe41N9ZN74nydvVZXobzDOm7h3IbnSzABLnJ7pYu8R9MWJ6pgB1qY0km6qFhJZ7NhJnKyu2Yg3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#398",
                    "display": "OATS RECOVERY START"
                  }
                ],
                "text": "OATS RECOVERY START"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
                "display": "MayUpgradeTwoFour, ScriptEightySevenD"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/euwNx6uQyy3aQAne1I5KUUw3"
                }
              ],
              "issued": "2024-12-11T19:14:11Z",
              "performer": [
                {
                  "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2024-10-10T14:41:00Z"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fT6SpekJyJHjnYKBKiiFBjg4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fT6SpekJyJHjnYKBKiiFBjg4",
            "resource": {
              "resourceType": "Observation",
              "id": "fT6SpekJyJHjnYKBKiiFBjg4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16574",
                    "display": "OATS - REFERRAL CANCELLED REASON"
                  }
                ],
                "text": "OATS - REFERRAL CANCELLED REASON"
              },
              "subject": {
                "reference": "Patient/eoN4fz8OEXuw.slGH1SO2XQ3",
                "display": "SITFourthteen, SITFourthteen"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                }
              ],
              "issued": "2025-10-24T17:13:06Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Recipient relocated"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgVk6SkJBJCzMJOw0GDud.g4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgVk6SkJBJCzMJOw0GDud.g4",
            "resource": {
              "resourceType": "Observation",
              "id": "fgVk6SkJBJCzMJOw0GDud.g4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16539",
                    "display": "OATS - LIVING DONOR RECOVERY COMMENTS"
                  }
                ],
                "text": "OATS - LIVING DONOR RECOVERY COMMENTS"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-09-25T17:37:12Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Testing recovery details "
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fOk3JvQnmUhsc9nMaoxeOcQ4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fOk3JvQnmUhsc9nMaoxeOcQ4",
            "resource": {
              "resourceType": "Observation",
              "id": "fOk3JvQnmUhsc9nMaoxeOcQ4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16540",
                    "display": "OATS - LIVING DONOR RECOVERY COMPLETED"
                  }
                ],
                "text": "OATS - LIVING DONOR RECOVERY COMPLETED"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-09-25T17:37:12Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueBoolean": true
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKfPw--KbYC4NuauObvPlxw4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKfPw--KbYC4NuauObvPlxw4",
            "resource": {
              "resourceType": "Observation",
              "id": "fKfPw--KbYC4NuauObvPlxw4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16542",
                    "display": "OATS - ORGAN SHIPPED"
                  }
                ],
                "text": "OATS - ORGAN SHIPPED"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-09-25T17:37:12Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueBoolean": true
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/faLXUefq0EQcaKWk5FuUv-Q4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/faLXUefq0EQcaKWk5FuUv-Q4",
            "resource": {
              "resourceType": "Observation",
              "id": "faLXUefq0EQcaKWk5FuUv-Q4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16569",
                    "display": "OATS - SHIPPED OUT OF PROVINCE"
                  }
                ],
                "text": "OATS - SHIPPED OUT OF PROVINCE"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-10-06T14:19:31Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueBoolean": true
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fXgKmOYsXSD0Y9rfxEyPBEA4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fXgKmOYsXSD0Y9rfxEyPBEA4",
            "resource": {
              "resourceType": "Observation",
              "id": "fXgKmOYsXSD0Y9rfxEyPBEA4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16571",
                    "display": "OATS - PERFUSION PUMP"
                  }
                ],
                "text": "OATS - PERFUSION PUMP"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-10-06T14:19:31Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueBoolean": true
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fu4tYEvA48HaaIvI49TPWYQ4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fu4tYEvA48HaaIvI49TPWYQ4",
            "resource": {
              "resourceType": "Observation",
              "id": "fu4tYEvA48HaaIvI49TPWYQ4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16572",
                    "display": "OATS - PERFUSION DATE AND TIME"
                  }
                ],
                "text": "OATS - PERFUSION DATE AND TIME"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-10-06T14:19:31Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2025-10-06T14:19:00Z"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fw.eFFHpMBrYMfuPKEVma-A4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fw.eFFHpMBrYMfuPKEVma-A4",
            "resource": {
              "resourceType": "Observation",
              "id": "fw.eFFHpMBrYMfuPKEVma-A4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16573",
                    "display": "OATS - ORGAN SUCCESSFULLY TRANSPLANTED"
                  }
                ],
                "text": "OATS - ORGAN SUCCESSFULLY TRANSPLANTED"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-10-06T14:19:31Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueBoolean": true
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fNEFwsvfbpROAIGPjn4X6LA4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fNEFwsvfbpROAIGPjn4X6LA4",
            "resource": {
              "resourceType": "Observation",
              "id": "fNEFwsvfbpROAIGPjn4X6LA4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#400",
                    "display": "OATS CROSS CLAMP"
                  }
                ],
                "text": "OATS CROSS CLAMP"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-09-25T17:53:18Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2025-09-22T17:51:00Z"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fP.al0N1Pg1QvD15OFVmyZA4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fP.al0N1Pg1QvD15OFVmyZA4",
            "resource": {
              "resourceType": "Observation",
              "id": "fP.al0N1Pg1QvD15OFVmyZA4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#114",
                    "display": "DONOR - DONOR FLUSH TIME END/CROSS CLAMP"
                  }
                ],
                "text": "DONOR - DONOR FLUSH TIME END/CROSS CLAMP"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-10-02T17:24:13Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2025-10-02T17:23:00Z"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fhb6S8X-Xaqo8XpI1XAsemg4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fhb6S8X-Xaqo8XpI1XAsemg4",
            "resource": {
              "resourceType": "Observation",
              "id": "fhb6S8X-Xaqo8XpI1XAsemg4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#321",
                    "display": "OATS - UNKNOWN GENDER"
                  }
                ],
                "text": "OATS - UNKNOWN GENDER"
              },
              "subject": {
                "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                "display": "SITSix, SITSix SITMIDDLESIX"
              },
              "focus": [
                {
                  "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                  "display": "SITSix, SITSix SITMIDDLESIX"
                }
              ],
              "issued": "2025-10-27T20:15:00Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Trans Woman"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {

            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "eyoMRUjclNBbwhXQ598UPLZ3LV6i5b-cxDxTsW6XCjynyrM5vrJTTrKfDCY34GKyLw2O8Rn4ywxXs-Tu5.vnRxw3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#379",
                    "display": "OATS FAILURE CAUSE"
                  }
                ],
                "text": "OATS FAILURE CAUSE"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "Failure, Graft"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/efztqfGU03Gqvo01NlU5tOw3"
                }
              ],
              "issued": "2024-12-06T16:45:25Z",
              "performer": [
                {
                  "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "OTHER"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/f8RoGoKpeGNWz1L2xAPLnKg4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/f8RoGoKpeGNWz1L2xAPLnKg4",
            "resource": {
              "resourceType": "Observation",
              "id": "f8RoGoKpeGNWz1L2xAPLnKg4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16519",
                    "display": "OATS - LDCMVLAB"
                  }
                ],
                "text": "OATS - LDCMVLAB"
              },
              "subject": {
                "reference": "Patient/e3rg0mjTOTi7wdQLUZ0kkyw3",
                "display": "SITLDOne, SITLDOne"
              },
              "focus": [
                {
                  "reference": "Patient/e3rg0mjTOTi7wdQLUZ0kkyw3",
                  "display": "SITLDOne, SITLDOne"
                }
              ],
              "issued": "2025-10-16T15:43:20Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "PUBLIC HEALTH LABORATORY"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fimmZL1g-v932shUu4axPFw4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fimmZL1g-v932shUu4axPFw4",
            "resource": {
              "resourceType": "Observation",
              "id": "fimmZL1g-v932shUu4axPFw4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#403",
                    "display": "OATS LINKED RECIPIENT TGLN"
                  }
                ],
                "text": "OATS LINKED RECIPIENT TGLN"
              },
              "subject": {
                "reference": "Patient/e3rg0mjTOTi7wdQLUZ0kkyw3",
                "display": "SITLDOne, SITLDOne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/en6mARfmq0F5hQzOiCBNPwA3"
                }
              ],
              "issued": "2025-10-27T20:00:48Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "68641"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fSrGw3FZrFH2zVbrhV-eP2g4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fSrGw3FZrFH2zVbrhV-eP2g4",
            "resource": {
              "resourceType": "Observation",
              "id": "fSrGw3FZrFH2zVbrhV-eP2g4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#309",
                    "display": "OATS FOLLOWUP SOURCE INFORMATION"
                  }
                ],
                "text": "OATS FOLLOWUP SOURCE INFORMATION"
              },
              "subject": {
                "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                "display": "SITSixupdate, SITSixUpdate SITMIDDLESIXupdate"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/e9ohqnnNLu8QTyi7Vl29JfA3"
                }
              ],
              "issued": "2025-10-27T20:42:01Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Other"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fcZRyeFT99RbVk1VzmsCzBg4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fcZRyeFT99RbVk1VzmsCzBg4",
            "resource": {
              "resourceType": "Observation",
              "id": "fcZRyeFT99RbVk1VzmsCzBg4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#315",
                    "display": "OATS FOLLOWUP SOURCE INFORMATION OTHER"
                  }
                ],
                "text": "OATS FOLLOWUP SOURCE INFORMATION OTHER"
              },
              "subject": {
                "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                "display": "SITSixupdate, SITSixUpdate SITMIDDLESIXupdate"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/e9ohqnnNLu8QTyi7Vl29JfA3"
                }
              ],
              "issued": "2025-10-27T20:42:01Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "testing f/u comment"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fGomxQtUjGJEya-3Xr-emCQ4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fGomxQtUjGJEya-3Xr-emCQ4",
            "resource": {
              "resourceType": "Observation",
              "id": "fGomxQtUjGJEya-3Xr-emCQ4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#314",
                    "display": "OATS FOLLOWUP CLINIC VISIT DATE"
                  }
                ],
                "text": "OATS FOLLOWUP CLINIC VISIT DATE"
              },
              "subject": {
                "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                "display": "SITSixupdate, SITSixUpdate SITMIDDLESIXupdate"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/e9ohqnnNLu8QTyi7Vl29JfA3"
                }
              ],
              "issued": "2025-10-27T20:42:01Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2025-10-22"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fSgdUp9YF7xzfCcoyIEgJOw4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fSgdUp9YF7xzfCcoyIEgJOw4",
            "resource": {
              "resourceType": "Observation",
              "id": "fSgdUp9YF7xzfCcoyIEgJOw4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#317",
                    "display": "OATS RETURN TO DIALYSIS DATE"
                  }
                ],
                "text": "OATS RETURN TO DIALYSIS DATE"
              },
              "subject": {
                "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                "display": "SITSixupdate, SITSixUpdate SITMIDDLESIXupdate"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/e9ohqnnNLu8QTyi7Vl29JfA3"
                }
              ],
              "issued": "2025-10-27T20:42:01Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2025-10-27"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fkN6XBHLNAj8-F2U90OiZ7w4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fkN6XBHLNAj8-F2U90OiZ7w4",
            "resource": {
              "resourceType": "Observation",
              "id": "fkN6XBHLNAj8-F2U90OiZ7w4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#329",
                    "display": "OATS FOLLOWUP - CREATININE UNKNOWN"
                  }
                ],
                "text": "OATS FOLLOWUP - CREATININE UNKNOWN"
              },
              "subject": {
                "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                "display": "SITSixupdate, SITSixUpdate SITMIDDLESIXupdate"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/e9ohqnnNLu8QTyi7Vl29JfA3"
                }
              ],
              "issued": "2025-10-27T20:42:01Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueBoolean": true
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fHIdwecqHGXKE4fk0tSYKuw4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fHIdwecqHGXKE4fk0tSYKuw4",
            "resource": {
              "resourceType": "Observation",
              "id": "fHIdwecqHGXKE4fk0tSYKuw4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16510",
                    "display": "OATS - LDHEPBCORE"
                  }
                ],
                "text": "OATS - LDHEPBCORE"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Negative"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fzDkTD-1obxXqR5mA0Vyh8g4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fzDkTD-1obxXqR5mA0Vyh8g4",
            "resource": {
              "resourceType": "Observation",
              "id": "fzDkTD-1obxXqR5mA0Vyh8g4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16558",
                    "display": "OATS - LDCMVINSTANT"
                  }
                ],
                "text": "OATS - LDCMVINSTANT"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2025-10-22T17:24:00Z"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fulpq4zpkgTvQEmrPLl0Bug4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fulpq4zpkgTvQEmrPLl0Bug4",
            "resource": {
              "resourceType": "Observation",
              "id": "fulpq4zpkgTvQEmrPLl0Bug4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16511",
                    "display": "OATS - LDHEPBSAB"
                  }
                ],
                "text": "OATS - LDHEPBSAB"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Negative"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/f.KdXM9H-xk5PA7qfFeCxIQ4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/f.KdXM9H-xk5PA7qfFeCxIQ4",
            "resource": {
              "resourceType": "Observation",
              "id": "f.KdXM9H-xk5PA7qfFeCxIQ4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16512",
                    "display": "OATS - LDCMV"
                  }
                ],
                "text": "OATS - LDCMV"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Positive"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fNCoY7ON5v3jN3wbAhoY3tQ4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fNCoY7ON5v3jN3wbAhoY3tQ4",
            "resource": {
              "resourceType": "Observation",
              "id": "fNCoY7ON5v3jN3wbAhoY3tQ4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16513",
                    "display": "OATS - LDHEPBSAG"
                  }
                ],
                "text": "OATS - LDHEPBSAG"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Negative"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/ffaDats9QarIDNgygzKFQwQ4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/ffaDats9QarIDNgygzKFQwQ4",
            "resource": {
              "resourceType": "Observation",
              "id": "ffaDats9QarIDNgygzKFQwQ4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16514",
                    "display": "OATS - LDHEPC"
                  }
                ],
                "text": "OATS - LDHEPC"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Positive"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fppzCzpxRewghVKNVLrUQoA4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fppzCzpxRewghVKNVLrUQoA4",
            "resource": {
              "resourceType": "Observation",
              "id": "fppzCzpxRewghVKNVLrUQoA4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16515",
                    "display": "OATS - LDHIV"
                  }
                ],
                "text": "OATS - LDHIV"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Not Tested"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fIzbl-Qdo8qfYeGu2ExlsJw4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fIzbl-Qdo8qfYeGu2ExlsJw4",
            "resource": {
              "resourceType": "Observation",
              "id": "fIzbl-Qdo8qfYeGu2ExlsJw4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16516",
                    "display": "OATS - LDVDRL"
                  }
                ],
                "text": "OATS - LDVDRL"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Positive"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/frQpp0jBy-GJKPQc3KBaP4Q4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/frQpp0jBy-GJKPQc3KBaP4Q4",
            "resource": {
              "resourceType": "Observation",
              "id": "frQpp0jBy-GJKPQc3KBaP4Q4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16517",
                    "display": "OATS - LDEBV"
                  }
                ],
                "text": "OATS - LDEBV"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Negative"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fd4cy5DQo80TXwSgMuMNFHg4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fd4cy5DQo80TXwSgMuMNFHg4",
            "resource": {
              "resourceType": "Observation",
              "id": "fd4cy5DQo80TXwSgMuMNFHg4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16518",
                    "display": "OATS - WNV"
                  }
                ],
                "text": "OATS - WNV"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Not Tested"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fuYccAx.BXrHtCKygaGQflw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fuYccAx.BXrHtCKygaGQflw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fuYccAx.BXrHtCKygaGQflw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16532",
                              "display": "OATS - DONOR ACCEPTANCE COMMENTS"
                          }
                      ],
                      "text": "OATS - DONOR ACCEPTANCE COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:11:28Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Donor Acceptance Comments"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {

            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "e512AOvSC3zGPs1dz1bxr2D3aBjBi9iR2.x2OwWmIGEu-akVsVkB0rp9s2mhOqZUakc9mxb2O8EZfhTrNZdBzTA3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#292",
                    "display": "OATS - MEDICAL ASSESSMENT REL CONTRAINDICATIONS"
                  }
                ],
                "text": "OATS - MEDICAL ASSESSMENT REL CONTRAINDICATIONS"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "Kumar, Ram_Update"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
                }
              ],
              "issued": "2024-11-29T20:21:50Z",
              "performer": [
                {
                  "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Age and functional capacity"
                },
                {
                  "code": {
                    "text": "Line 2"
                  },
                  "valueString": "Cause of Kidney Disease"
                },
                {
                  "code": {
                    "text": "Line 3"
                  },
                  "valueString": "Psychosocial Considerations"
                },
                {
                  "code": {
                    "text": "Line 4"
                  },
                  "valueString": "Obesity"
                },
                {
                  "code": {
                    "text": "Line 5"
                  },
                  "valueString": "Systemic Diseases"
                },
                {
                  "code": {
                    "text": "Line 6"
                  },
                  "valueString": "Infections"
                },
                {
                  "code": {
                    "text": "Line 7"
                  },
                  "valueString": "Pulmonary Disease"
                },
                {
                  "code": {
                    "text": "Line 8"
                  },
                  "valueString": "Cardiac Disease"
                },
                {
                  "code": {
                    "text": "Line 9"
                  },
                  "valueString": "Cerebral Vascular Disease"
                },
                {
                  "code": {
                    "text": "Line 10"
                  },
                  "valueString": "Peripheral Vascular Disease"
                },
                {
                  "code": {
                    "text": "Line 11"
                  },
                  "valueString": "Gastrointestinal Disease"
                },
                {
                  "code": {
                    "text": "Line 12"
                  },
                  "valueString": "Liver Disease"
                },
                {
                  "code": {
                    "text": "Line 13"
                  },
                  "valueString": "Genitourinary Disease"
                },
                {
                  "code": {
                    "text": "Line 14"
                  },
                  "valueString": "Hematologic Disorders"
                },
                {
                  "code": {
                    "text": "Line 15"
                  },
                  "valueString": "Hyperparathyroidism"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
  
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "edB41AO1moSG0eIEmOJPz0DFWaiAOOyOApcHvu5C7DPKgv.Y2jz2vgAdBWXwhGee0NNphXS2CvaWnTO83IOa8jA3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#291",
                    "display": "OATS - MEDICAL ASSESSMENT ABS CONTRAINDICATIONS"
                  }
                ],
                "text": "OATS - MEDICAL ASSESSMENT ABS CONTRAINDICATIONS"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "Kumar, Ram_Update"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
                }
              ],
              "issued": "2024-11-29T20:21:50Z",
              "performer": [
                {
                  "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Comorbidities"
                },
                {
                  "code": {
                    "text": "Line 2"
                  },
                  "valueString": "Consent"
                },
                {
                  "code": {
                    "text": "Line 3"
                  },
                  "valueString": "Post-Transplant Care"
                },
                {
                  "code": {
                    "text": "Line 4"
                  },
                  "valueString": "Psychosocial Considerations"
                },
                {
                  "code": {
                    "text": "Line 5"
                  },
                  "valueString": "Malignancy"
                },
                {
                  "code": {
                    "text": "Line 6"
                  },
                  "valueString": "Pulmoary Disease"
                },
                {
                  "code": {
                    "text": "Line 7"
                  },
                  "valueString": "Cardiac Disease"
                },
                {
                  "code": {
                    "text": "Line 8"
                  },
                  "valueString": "Peripheral Vascular Disease"
                },
                {
                  "code": {
                    "text": "Line 9"
                  },
                  "valueString": "Gastrointestinal Disease"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
 
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "e58WVNM0jb629nEMoRQLKgz0zLIo-u6pNIPq6t5dqF5.tU8JjuTdwkXoCmZ089TPENJmYfO7lxv1bdRS7zi9kkg3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#327",
                    "display": "OATS - FURTHER TESTING REQUIRED OTHER"
                  }
                ],
                "text": "OATS - FURTHER TESTING REQUIRED OTHER"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "MayUpgradeTwoFour, ScriptEightySevenR"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
                }
              ],
              "issued": "2024-11-06T21:12:39Z",
              "performer": [
                {
                  "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
                  "display": "GONZALES, ALVIN"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "This is an other field for medical assessment decision reason."
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
  
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "ezOI4wA1544vR-YyamuQlmnpGwDvcz4MCrMNwby-sCnsDQkUu4odZTTqT3anAZLKH913VsMaE1HHqNokgis.fAQ3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#289",
                    "display": "OATS - MEDICAL ASSESSMENT NOT ELIGIBLE"
                  }
                ],
                "text": "OATS - MEDICAL ASSESSMENT NOT ELIGIBLE"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "Kumar, Ram_Update"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
                }
              ],
              "issued": "2024-11-29T20:21:50Z",
              "performer": [
                {
                  "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Recipient does not meet listing criteria"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
 
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "eAveF-aMGBJcv7OH3nC3SgXg7VbM2er2OVDw.Q33Q-wiWjjHNfppYpzVs0327-IpjcZH0qNrVMXFF.IDJSD0tKg3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#283",
                    "display": "OATS - DELAY END DATE"
                  }
                ],
                "text": "OATS - DELAY END DATE"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "MayUpgradeTwoFour, ScriptEightySevenR"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
                }
              ],
              "issued": "2024-11-06T21:12:39Z",
              "performer": [
                {
                  "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
                  "display": "GONZALES, ALVIN"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2024-11-06"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
 
            "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/Observation/eWg3JhB-KqjIeXeJEUvFp3l3toZtuC-giMFccaguGNELDJ5wff7IOL.AEdb.F1F5GnTnqEYSy5EXZhVBXFjyOCA3",
            "resource": {
              "resourceType": "Observation",
              "id": "eWg3JhB-KqjIeXeJEUvFp3l3toZtuC-giMFccaguGNELDJ5wff7IOL.AEdb.F1F5GnTnqEYSy5EXZhVBXFjyOCA3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#282",
                    "display": "OATS - DELAY START DATE"
                  }
                ],
                "text": "OATS - DELAY START DATE"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "MayUpgradeTwoFour, ScriptEightySevenR"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
                }
              ],
              "issued": "2024-11-06T21:12:39Z",
              "performer": [
                {
                  "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
                  "display": "GONZALES, ALVIN"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2024-11-05"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
  
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "eEY6QUFLjk.6utt6AMxpFeHPwE8Bx4J1IwK9S86MwFKM5u.OBqzcgpMSlWBS2BXsuuQJifS53BWrPMVUr-OBgNg3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#288",
                    "display": "OATS - MEDICAL ASSESSMENT CANCELLED"
                  }
                ],
                "text": "OATS - MEDICAL ASSESSMENT CANCELLED"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "MayUpgradeTwoFour, ScriptEightySevenR"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
                }
              ],
              "issued": "2024-11-06T21:12:39Z",
              "performer": [
                {
                  "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
                  "display": "GONZALES, ALVIN"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Recipient Death Related to Organ Failure"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
  
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "e3zPGgVwXGU9ZJmm32I24--RP5WAZuhtlxig4bc1CmG.qrUoScgpcfp6d22OgQ.KEfxSpNN4bNRchRsQO6Hy0VQ3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#290",
                    "display": "OATS - MEDICAL ASSESSMENT FURTHER TESTING"
                  }
                ],
                "text": "OATS - MEDICAL ASSESSMENT FURTHER TESTING"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "MayUpgradeTwoFour, ScriptEightySevenR"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
                }
              ],
              "issued": "2024-11-06T21:12:39Z",
              "performer": [
                {
                  "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
                  "display": "GONZALES, ALVIN"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Down staging for HCC"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fQ9eG5nH-ZyBPQwmMCDhYpA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fQ9eG5nH-ZyBPQwmMCDhYpA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fQ9eG5nH-ZyBPQwmMCDhYpA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16533",
                              "display": "OATS - TRANSPLANT START"
                          }
                      ],
                      "text": "OATS - TRANSPLANT START"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02T23:16:00Z"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSOtYTvg3RlCpGVbFRJEIwg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSOtYTvg3RlCpGVbFRJEIwg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fSOtYTvg3RlCpGVbFRJEIwg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16534",
                              "display": "OATS - REWARM TIME"
                          }
                      ],
                      "text": "OATS - REWARM TIME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueTime": "01:01:00"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fo4qGLHFpnudFgahiv6D2Ew4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fo4qGLHFpnudFgahiv6D2Ew4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fo4qGLHFpnudFgahiv6D2Ew4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16535",
                              "display": "OATS - COLD ISCHEMIC TIME (CIT)"
                          }
                      ],
                      "text": "OATS - COLD ISCHEMIC TIME (CIT)"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueTime": "01:01:00"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f5lTe6ECyzNSIkXY4oNMkHw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f5lTe6ECyzNSIkXY4oNMkHw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f5lTe6ECyzNSIkXY4oNMkHw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#177",
                              "display": "TXP DIALYSIS - DIALYSIS TYPE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Frequent Nocturnal Dialysis"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJLs2FuJR3mdEKlHkQpgEig4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJLs2FuJR3mdEKlHkQpgEig4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fJLs2FuJR3mdEKlHkQpgEig4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#178",
                              "display": "TXP DIALYSIS - DIALYSIS ACCESS MODE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS ACCESS MODE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Central Venous Catheter (CVC)"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKzLPY7TXE6TfZsnbHKrgcw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKzLPY7TXE6TfZsnbHKrgcw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fKzLPY7TXE6TfZsnbHKrgcw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#179",
                              "display": "TXP DIALYSIS - DIALYSIS LOCATION"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS LOCATION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Other"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fq6IDTU1JQvz8KDaSaiM0Hg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fq6IDTU1JQvz8KDaSaiM0Hg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fq6IDTU1JQvz8KDaSaiM0Hg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#180",
                              "display": "TXP DIALYSIS - OTHER DIALYSIS LOCATION"
                          }
                      ],
                      "text": "TXP DIALYSIS - OTHER DIALYSIS LOCATION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Other Address"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fz5r6xdyXLjU7xNob-Q8lYQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fz5r6xdyXLjU7xNob-Q8lYQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fz5r6xdyXLjU7xNob-Q8lYQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#184",
                              "display": "TXP DIALYSIS - PRE-EMPTIVE"
                          }
                      ],
                      "text": "TXP DIALYSIS - PRE-EMPTIVE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2xLXqBCZHHIvf98aC5Cnng4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2xLXqBCZHHIvf98aC5Cnng4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f2xLXqBCZHHIvf98aC5Cnng4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#207",
                              "display": "TXP DIALYSIS - DIALYSIS CENTRE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS CENTRE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Alberta Hospital"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fwzFV6yBHYlxXobiHrZHxtw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fwzFV6yBHYlxXobiHrZHxtw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fwzFV6yBHYlxXobiHrZHxtw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#262",
                              "display": "OATS INTEGRATION - ETHNICITY"
                          }
                      ],
                      "text": "OATS INTEGRATION - ETHNICITY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                          "display": "SMHOne, RecipientOne"
                      }
                  ],
                  "issued": "2025-10-10T17:45:05Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Other"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fI4wqWREJVMOVc3ybaeR5hg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fI4wqWREJVMOVc3ybaeR5hg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fI4wqWREJVMOVc3ybaeR5hg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#263",
                              "display": "OATS INTEGRATION - OTHER ETHNICITY"
                          }
                      ],
                      "text": "OATS INTEGRATION - OTHER ETHNICITY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                          "display": "SMHOne, RecipientOne"
                      }
                  ],
                  "issued": "2025-10-10T17:45:05Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "testing other eth"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fBgBEAl8yLFP5IbboHRuDmQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fBgBEAl8yLFP5IbboHRuDmQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fBgBEAl8yLFP5IbboHRuDmQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#273",
                              "display": "OATS - CONSULTATION DECISION"
                          }
                      ],
                      "text": "OATS - CONSULTATION DECISION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Consult Completed"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frRj0I4JQmBg-rkdrW7uRng4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frRj0I4JQmBg-rkdrW7uRng4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "frRj0I4JQmBg-rkdrW7uRng4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#276",
                              "display": "OATS - REFERRING ORGANIZATION NAME"
                          }
                      ],
                      "text": "OATS - REFERRING ORGANIZATION NAME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "OrgOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYb-lNYyMLSVjOIOry-qMig4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYb-lNYyMLSVjOIOry-qMig4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fYb-lNYyMLSVjOIOry-qMig4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#277",
                              "display": "OATS REFERRING ORGANIZATION TYPE"
                          }
                      ],
                      "text": "OATS REFERRING ORGANIZATION TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "DIALYSIS CENTER"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2XIzuam7wDjymR9.70SV1g4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2XIzuam7wDjymR9.70SV1g4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f2XIzuam7wDjymR9.70SV1g4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#279",
                              "display": "OATS - CONSULTATION DATE"
                          }
                      ],
                      "text": "OATS - CONSULTATION DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-09-24"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fa2YHVSg23HokaRtpmP.4Fg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fa2YHVSg23HokaRtpmP.4Fg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fa2YHVSg23HokaRtpmP.4Fg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#284",
                              "display": "OATS - CONSULTATION COMMENTS"
                          }
                      ],
                      "text": "OATS - CONSULTATION COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing consultation comments "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fw2KyG5W8frBFmRQHvOGOSg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fw2KyG5W8frBFmRQHvOGOSg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fw2KyG5W8frBFmRQHvOGOSg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#285",
                              "display": "OATS - MEDICAL ASSESSMENT DATE"
                          }
                      ],
                      "text": "OATS - MEDICAL ASSESSMENT DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSqBNYzWgrIbXKomhWl9d8Q4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSqBNYzWgrIbXKomhWl9d8Q4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fSqBNYzWgrIbXKomhWl9d8Q4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#287",
                              "display": "OATS - MEDICAL ASSESSMENT DECISION"
                          }
                      ],
                      "text": "OATS - MEDICAL ASSESSMENT DECISION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Recipient to be Listed"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f45VwNXiOchwTqQQ5tDQvig4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f45VwNXiOchwTqQQ5tDQvig4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f45VwNXiOchwTqQQ5tDQvig4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#293",
                              "display": "OATS - MEDICAL ASSESSMENT COMMENTS"
                          }
                      ],
                      "text": "OATS - MEDICAL ASSESSMENT COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing medical assessment comments "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fyLiC3oNQuO5.flbtkU2NoA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fyLiC3oNQuO5.flbtkU2NoA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fyLiC3oNQuO5.flbtkU2NoA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#296",
                              "display": "OATS - STAGED KIDNEY"
                          }
                      ],
                      "text": "OATS - STAGED KIDNEY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIGZf1dNXZJMAiZ7-oDG2yA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIGZf1dNXZJMAiZ7-oDG2yA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fIGZf1dNXZJMAiZ7-oDG2yA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#297",
                              "display": "OATS - KPD PATIENT"
                          }
                      ],
                      "text": "OATS - KPD PATIENT"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/favdd-CaihhV4pVJtUJhiAA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/favdd-CaihhV4pVJtUJhiAA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "favdd-CaihhV4pVJtUJhiAA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#299",
                              "display": "OATS - LIST EXCHANGE PATIENT"
                          }
                      ],
                      "text": "OATS - LIST EXCHANGE PATIENT"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxoqMbZ5u2yC4tesDN8mtZg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxoqMbZ5u2yC4tesDN8mtZg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fxoqMbZ5u2yC4tesDN8mtZg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#300",
                              "display": "OATS - LIST EXCHANGE DATE"
                          }
                      ],
                      "text": "OATS - LIST EXCHANGE DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-30"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f9MKw7v6sARuNudB9Iop8zQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f9MKw7v6sARuNudB9Iop8zQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f9MKw7v6sARuNudB9Iop8zQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#301",
                              "display": "OATS - PREVIOUS LIVING DONOR"
                          }
                      ],
                      "text": "OATS - PREVIOUS LIVING DONOR"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fK-MGYI8MqSwpjNvoSq.8OQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fK-MGYI8MqSwpjNvoSq.8OQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fK-MGYI8MqSwpjNvoSq.8OQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#303",
                              "display": "OATS - PREVIOUS DONATION DATE"
                          }
                      ],
                      "text": "OATS - PREVIOUS DONATION DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-31"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fCooSroi6S0sc7HcMgOZVvg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fCooSroi6S0sc7HcMgOZVvg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fCooSroi6S0sc7HcMgOZVvg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#309",
                              "display": "OATS FOLLOWUP SOURCE INFORMATION"
                          }
                      ],
                      "text": "OATS FOLLOWUP SOURCE INFORMATION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkIeCuBwW7X6O93Sh8giIIA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkIeCuBwW7X6O93Sh8giIIA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fkIeCuBwW7X6O93Sh8giIIA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#314",
                              "display": "OATS FOLLOWUP CLINIC VISIT DATE"
                          }
                      ],
                      "text": "OATS FOLLOWUP CLINIC VISIT DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fh8Y8YTD8RqDVpk4iofbHbQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fh8Y8YTD8RqDVpk4iofbHbQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fh8Y8YTD8RqDVpk4iofbHbQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#317",
                              "display": "OATS RETURN TO DIALYSIS DATE"
                          }
                      ],
                      "text": "OATS RETURN TO DIALYSIS DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fawMXHrp7DSOLceAom8xvnw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fawMXHrp7DSOLceAom8xvnw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fawMXHrp7DSOLceAom8xvnw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#320",
                              "display": "OATS - DEMOGRAPHICS GENDER VS SEX"
                          }
                      ],
                      "text": "OATS - DEMOGRAPHICS GENDER VS SEX"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-07T14:39:54Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                    {
                      "code": {
                        "text": "Line 1"
                      },
                      "valueBoolean": true
                    }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIShZ3BsZUb8xu.XdBOCbwQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIShZ3BsZUb8xu.XdBOCbwQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fIShZ3BsZUb8xu.XdBOCbwQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#320",
                              "display": "OATS - DEMOGRAPHICS GENDER VS SEX"
                          }
                      ],
                      "text": "OATS - DEMOGRAPHICS GENDER VS SEX"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                          "display": "SMHOne, RecipientOne"
                      }
                  ],
                  "issued": "2025-10-10T17:45:05Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fUVgmmS0QIEoyT-53X7GxRQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fUVgmmS0QIEoyT-53X7GxRQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fUVgmmS0QIEoyT-53X7GxRQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#321",
                              "display": "OATS - UNKNOWN GENDER"
                          }
                      ],
                      "text": "OATS - UNKNOWN GENDER"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                          "display": "SMHOne, RecipientOne"
                      }
                  ],
                  "issued": "2025-10-10T17:45:05Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "testing other gender"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGPETej3TGMU3pL9XveqOIg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGPETej3TGMU3pL9XveqOIg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fGPETej3TGMU3pL9XveqOIg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#323",
                              "display": "OATS - REFERRAL DETAILS - COMMENTS"
                          }
                      ],
                      "text": "OATS - REFERRAL DETAILS - COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Test "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJK4vVirmWM63M7wmX.mixw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJK4vVirmWM63M7wmX.mixw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fJK4vVirmWM63M7wmX.mixw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#325",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE ESTIMATED"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE ESTIMATED"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0jH0IJMOnl7w2JwyDdHXhw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0jH0IJMOnl7w2JwyDdHXhw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f0jH0IJMOnl7w2JwyDdHXhw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#326",
                              "display": "OATS GRAFT FUNCTION AT DEATH"
                          }
                      ],
                      "text": "OATS GRAFT FUNCTION AT DEATH"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Unknown"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIVycu4A2d615v8Eo1f0-dQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIVycu4A2d615v8Eo1f0-dQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fIVycu4A2d615v8Eo1f0-dQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#328",
                              "display": "OATS FOLLOWUP COMMENTS"
                          }
                      ],
                      "text": "OATS FOLLOWUP COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing post-transplant comments "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fpGbcJ5UaIlt2cnWYq8snIw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fpGbcJ5UaIlt2cnWYq8snIw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fpGbcJ5UaIlt2cnWYq8snIw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#330",
                              "display": "TXP DIALYSIS - DIALYSIS START DATE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS START DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-14"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fX8Nv6Jfld9qHZa9lAjeQDg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fX8Nv6Jfld9qHZa9lAjeQDg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fX8Nv6Jfld9qHZa9lAjeQDg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#331",
                              "display": "TXP DIALYSIS - DIALYSIS END DATE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS END DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-17"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgBfEfOG6EFBRskvJjZV2bw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgBfEfOG6EFBRskvJjZV2bw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fgBfEfOG6EFBRskvJjZV2bw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#332",
                              "display": "OATS ABO BLOOD TYPE"
                          }
                      ],
                      "text": "OATS ABO BLOOD TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                          "display": "SMHOne, RecipientOne"
                      }
                  ],
                  "issued": "2025-08-06T02:57:09Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "AB"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fbNY2qVwHTsoHow5DY5LKgw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fbNY2qVwHTsoHow5DY5LKgw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fbNY2qVwHTsoHow5DY5LKgw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#333",
                              "display": "OATS ABO RH FACTOR"
                          }
                      ],
                      "text": "OATS ABO RH FACTOR"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                          "display": "SMHOne, RecipientOne"
                      }
                  ],
                  "issued": "2025-08-06T02:57:09Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Positive"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fqYHEIsMGTeS0j5NQiKddnA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#334",
                              "display": "OATS REFERRAL DECISION"
                          }
                      ],
                      "text": "OATS REFERRAL DECISION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Referral Accepted"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYenN980Ym00-ubiZqAEhCg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYenN980Ym00-ubiZqAEhCg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fYenN980Ym00-ubiZqAEhCg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#335",
                              "display": "OATS REFERRAL DECISION DATE"
                          }
                      ],
                      "text": "OATS REFERRAL DECISION DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2024-07-23"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxdlSZYm1yXQQe3UX6g8bkg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxdlSZYm1yXQQe3UX6g8bkg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fxdlSZYm1yXQQe3UX6g8bkg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#337",
                              "display": "REFERRAL PRIMARY DIAGNOSIS"
                          }
                      ],
                      "text": "REFERRAL PRIMARY DIAGNOSIS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "AMYLOID"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGzKpZVWMcw.n8LqOQuLKWw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGzKpZVWMcw.n8LqOQuLKWw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fGzKpZVWMcw.n8LqOQuLKWw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#338",
                              "display": "REFERRAL PRIMARY DIAGNOSIS DATE"
                          }
                      ],
                      "text": "REFERRAL PRIMARY DIAGNOSIS DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2024-07-23"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTZIh7HwDy6IlVOXKpDs29w4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTZIh7HwDy6IlVOXKpDs29w4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fTZIh7HwDy6IlVOXKpDs29w4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#340",
                              "display": "OATS REFERRING PROVIDER TYPE"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "GENERAL SURGEON"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f4n5e2R3AQ98g4J.NNVZAbw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f4n5e2R3AQ98g4J.NNVZAbw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f4n5e2R3AQ98g4J.NNVZAbw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#341",
                              "display": "OATS REFERRING PROVIDER FIRST NAME"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER FIRST NAME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "NameOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fM1-INlKkzX0agFBewRaenA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fM1-INlKkzX0agFBewRaenA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fM1-INlKkzX0agFBewRaenA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#342",
                              "display": "OATS REFERRING PROVIDER LAST NAME"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER LAST NAME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "LastOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkpqOvat7x.2hahHw-g1ITg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkpqOvat7x.2hahHw-g1ITg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fkpqOvat7x.2hahHw-g1ITg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#343",
                              "display": "OATS DONOR CRITERIA ABO INCOMPATIBLE"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA ABO INCOMPATIBLE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f---pfiVbBXrLZZ2bOj5IDw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f---pfiVbBXrLZZ2bOj5IDw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f---pfiVbBXrLZZ2bOj5IDw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#345",
                              "display": "OATS DONOR CRITERIA A2 OR A2B"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA A2 OR A2B"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fd-e6RMSIj.k6epGJu2wGhQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fd-e6RMSIj.k6epGJu2wGhQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fd-e6RMSIj.k6epGJu2wGhQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#346",
                              "display": "OATS DONOR CRITERIA HCV NAT+"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA HCV NAT+"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fXEE7CfrACs5uginZmoyhXg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fXEE7CfrACs5uginZmoyhXg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fXEE7CfrACs5uginZmoyhXg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#347",
                              "display": "OATS DONOR CRITERIA HCV AB+"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA HCV AB+"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGTAxybcPbMmF6e0Ft4v0Vw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGTAxybcPbMmF6e0Ft4v0Vw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fGTAxybcPbMmF6e0Ft4v0Vw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#348",
                              "display": "OATS DONOR CRITERIA HEP B CORE AB+"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA HEP B CORE AB+"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frpP.9Tj9LzmtBFQyaK9XzA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frpP.9Tj9LzmtBFQyaK9XzA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "frpP.9Tj9LzmtBFQyaK9XzA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#349",
                              "display": "OATS DONOR CRITERIA EXTENDED CRITERIA DONOR (ECD)"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA EXTENDED CRITERIA DONOR (ECD)"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-026jFDg5NfF71jkcxnrQQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-026jFDg5NfF71jkcxnrQQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f-026jFDg5NfF71jkcxnrQQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#351",
                              "display": "OATS CONSULTATION TRANSPLANT PHYSICIAN"
                          }
                      ],
                      "text": "OATS CONSULTATION TRANSPLANT PHYSICIAN"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Jeff Zaltzman"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f79XbDZMrpFnJ.IGhwSaveA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f79XbDZMrpFnJ.IGhwSaveA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f79XbDZMrpFnJ.IGhwSaveA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#352",
                              "display": "OATS REFERRING PROVIDER ADDRESS"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER ADDRESS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "AddressOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f25V63huaxM0FexPWcLHF6Q4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f25V63huaxM0FexPWcLHF6Q4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f25V63huaxM0FexPWcLHF6Q4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#353",
                              "display": "OATS REFERRING PROVIDER CITY"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER CITY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "CityOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fEC3bziO.tvqnDoa5fqx2sA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fEC3bziO.tvqnDoa5fqx2sA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fEC3bziO.tvqnDoa5fqx2sA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#354",
                              "display": "OATS REFERRING PROVIDER COUNTRY"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER COUNTRY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "CANADA"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ffxlfqg0iw8TRO4Slvmcnyg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ffxlfqg0iw8TRO4Slvmcnyg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ffxlfqg0iw8TRO4Slvmcnyg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#355",
                              "display": "OATS REFERRING PROVIDER PROVINCE"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER PROVINCE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueCodeableConcept": {
                              "coding": [
                                  {
                                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.4.699080.50",
                                      "code": "58",
                                      "display": "Ontario"
                                  }
                              ],
                              "text": "Ontario"
                          }
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0p.R8bt-.mVW3x8.UT2yXg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0p.R8bt-.mVW3x8.UT2yXg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f0p.R8bt-.mVW3x8.UT2yXg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#356",
                              "display": "OATS REFERRING PROVIDER POSTAL CODE"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER POSTAL CODE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "L1L2L3"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fRdD26SPUCHICBz82O8QrGg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fRdD26SPUCHICBz82O8QrGg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fRdD26SPUCHICBz82O8QrGg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#357",
                              "display": "OATS DONOR CRITERIA PREFERRED DONOR TYPE"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA PREFERRED DONOR TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Deceased or Living Donor"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fPM896dVsaGWG4bA-II14eQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fPM896dVsaGWG4bA-II14eQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fPM896dVsaGWG4bA-II14eQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#359",
                              "display": "OATS BLOOD TYPE VERIFIED"
                          }
                      ],
                      "text": "OATS BLOOD TYPE VERIFIED"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-06T02:57:09Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fjfjDPe.lXW8pnZAwqNT6DQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fjfjDPe.lXW8pnZAwqNT6DQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fjfjDPe.lXW8pnZAwqNT6DQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#377",
                              "display": "OATS RECIPIENT STATUS"
                          }
                      ],
                      "text": "OATS RECIPIENT STATUS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Recipient death"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fLS9O5FTJowQE4.2tP.7gNQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fLS9O5FTJowQE4.2tP.7gNQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fLS9O5FTJowQE4.2tP.7gNQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#381",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fp6X.EKWV2OVGiuGubVdXOw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fp6X.EKWV2OVGiuGubVdXOw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fp6X.EKWV2OVGiuGubVdXOw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#383",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH CATEGORY"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH CATEGORY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "OTHER"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgZSrklcdPBN.2WM1erjnlA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgZSrklcdPBN.2WM1erjnlA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fgZSrklcdPBN.2WM1erjnlA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#386",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH TYPE OTHER"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH TYPE OTHER"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "other death"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkduZImqZR1Zgzrrp3iquCA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkduZImqZR1Zgzrrp3iquCA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fkduZImqZR1Zgzrrp3iquCA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#388",
                              "display": "OATS RECIPIENT DEATH DATA - DEATH DATE"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - DEATH DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feEFo86i0kqGssRCwOu2ijw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feEFo86i0kqGssRCwOu2ijw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "feEFo86i0kqGssRCwOu2ijw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#389",
                              "display": "OATS RECIPIENT DEATH DATA - DEATH DATE ESTIMATED"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - DEATH DATE ESTIMATED"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTWKMh4B-LwbVLRopMhJGew4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTWKMh4B-LwbVLRopMhJGew4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fTWKMh4B-LwbVLRopMhJGew4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#390",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH CATEGORY"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH CATEGORY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "OTHER"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fB8Yw7UVG0a3Sc0HgrTvSZQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fB8Yw7UVG0a3Sc0HgrTvSZQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fB8Yw7UVG0a3Sc0HgrTvSZQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#391",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feYjOGORRj1qx-36eyZRaAw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feYjOGORRj1qx-36eyZRaAw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "feYjOGORRj1qx-36eyZRaAw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#392",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE OTHER"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE OTHER"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "other death"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fcihOQFsqALYV.pawMuTY2g4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fcihOQFsqALYV.pawMuTY2g4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fcihOQFsqALYV.pawMuTY2g4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#393",
                              "display": "OATS RECIPIENT DEATH DATA - COMMENTS"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing recipient death comments"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKM4u1l0CO7AW3XK.d6IuxQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKM4u1l0CO7AW3XK.d6IuxQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fKM4u1l0CO7AW3XK.d6IuxQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#395",
                              "display": "OATS TRANSPLANT TYPE"
                          }
                      ],
                      "text": "OATS TRANSPLANT TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "RIGHT KIDNEY"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frfiOJ2orNaulWwwS9jjDew4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frfiOJ2orNaulWwwS9jjDew4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "frfiOJ2orNaulWwwS9jjDew4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#396",
                              "display": "OATS REMOVED FROM COLD"
                          }
                      ],
                      "text": "OATS REMOVED FROM COLD"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02T23:16:00Z"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIG8aWFGszO4eaWaGjXI3Og4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIG8aWFGszO4eaWaGjXI3Og4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fIG8aWFGszO4eaWaGjXI3Og4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#397",
                              "display": "OATS CLAMP REMOVAL"
                          }
                      ],
                      "text": "OATS CLAMP REMOVAL"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02T23:16:00Z"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-S0KvhLEqrnyRyuq8iDYPw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-S0KvhLEqrnyRyuq8iDYPw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f-S0KvhLEqrnyRyuq8iDYPw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#406",
                              "display": "OATS RETURN TO DIALYSIS"
                          }
                      ],
                      "text": "OATS RETURN TO DIALYSIS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          }
      ],
      [
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f6a65I9z6dU8udcUn9imK2Q4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f6a65I9z6dU8udcUn9imK2Q4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f6a65I9z6dU8udcUn9imK2Q4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#059",
                              "display": "cPRA"
                          }
                      ],
                      "text": "CPRA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueQuantity": {
                              "value": 456
                          }
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSzs64wACKwaRyM0ChW-8gg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSzs64wACKwaRyM0ChW-8gg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fSzs64wACKwaRyM0ChW-8gg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16525",
                              "display": "OATS - PUSH DATA"
                          }
                      ],
                      "text": "OATS - PUSH DATA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fsEjuE08ag3FANsbstvAfMA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fsEjuE08ag3FANsbstvAfMA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fsEjuE08ag3FANsbstvAfMA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16531",
                              "display": "OATS - GENERAL KIDNEY COMMENTS"
                          }
                      ],
                      "text": "OATS - GENERAL KIDNEY COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Comments six"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fuYccAx.BXrHtCKygaGQflw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fuYccAx.BXrHtCKygaGQflw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fuYccAx.BXrHtCKygaGQflw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16532",
                              "display": "OATS - DONOR ACCEPTANCE COMMENTS"
                          }
                      ],
                      "text": "OATS - DONOR ACCEPTANCE COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:11:28Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Donor Acceptance Comments"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fQ9eG5nH-ZyBPQwmMCDhYpA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fQ9eG5nH-ZyBPQwmMCDhYpA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fQ9eG5nH-ZyBPQwmMCDhYpA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16533",
                              "display": "OATS - TRANSPLANT START"
                          }
                      ],
                      "text": "OATS - TRANSPLANT START"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02T23:16:00Z"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSOtYTvg3RlCpGVbFRJEIwg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSOtYTvg3RlCpGVbFRJEIwg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fSOtYTvg3RlCpGVbFRJEIwg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16534",
                              "display": "OATS - REWARM TIME"
                          }
                      ],
                      "text": "OATS - REWARM TIME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueTime": "01:01:00"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fo4qGLHFpnudFgahiv6D2Ew4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fo4qGLHFpnudFgahiv6D2Ew4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fo4qGLHFpnudFgahiv6D2Ew4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16535",
                              "display": "OATS - COLD ISCHEMIC TIME (CIT)"
                          }
                      ],
                      "text": "OATS - COLD ISCHEMIC TIME (CIT)"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueTime": "01:01:00"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f5lTe6ECyzNSIkXY4oNMkHw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f5lTe6ECyzNSIkXY4oNMkHw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f5lTe6ECyzNSIkXY4oNMkHw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#177",
                              "display": "TXP DIALYSIS - DIALYSIS TYPE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Frequent Nocturnal Dialysis"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJLs2FuJR3mdEKlHkQpgEig4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJLs2FuJR3mdEKlHkQpgEig4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fJLs2FuJR3mdEKlHkQpgEig4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#178",
                              "display": "TXP DIALYSIS - DIALYSIS ACCESS MODE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS ACCESS MODE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Central Venous Catheter (CVC)"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKzLPY7TXE6TfZsnbHKrgcw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKzLPY7TXE6TfZsnbHKrgcw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fKzLPY7TXE6TfZsnbHKrgcw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#179",
                              "display": "TXP DIALYSIS - DIALYSIS LOCATION"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS LOCATION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Other"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fq6IDTU1JQvz8KDaSaiM0Hg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fq6IDTU1JQvz8KDaSaiM0Hg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fq6IDTU1JQvz8KDaSaiM0Hg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#180",
                              "display": "TXP DIALYSIS - OTHER DIALYSIS LOCATION"
                          }
                      ],
                      "text": "TXP DIALYSIS - OTHER DIALYSIS LOCATION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Other Address"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fz5r6xdyXLjU7xNob-Q8lYQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fz5r6xdyXLjU7xNob-Q8lYQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fz5r6xdyXLjU7xNob-Q8lYQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#184",
                              "display": "TXP DIALYSIS - PRE-EMPTIVE"
                          }
                      ],
                      "text": "TXP DIALYSIS - PRE-EMPTIVE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2xLXqBCZHHIvf98aC5Cnng4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2xLXqBCZHHIvf98aC5Cnng4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f2xLXqBCZHHIvf98aC5Cnng4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#207",
                              "display": "TXP DIALYSIS - DIALYSIS CENTRE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS CENTRE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Alberta Hospital"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fBgBEAl8yLFP5IbboHRuDmQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fBgBEAl8yLFP5IbboHRuDmQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fBgBEAl8yLFP5IbboHRuDmQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#273",
                              "display": "OATS - CONSULTATION DECISION"
                          }
                      ],
                      "text": "OATS - CONSULTATION DECISION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Consult Completed"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frRj0I4JQmBg-rkdrW7uRng4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frRj0I4JQmBg-rkdrW7uRng4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "frRj0I4JQmBg-rkdrW7uRng4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#276",
                              "display": "OATS - REFERRING ORGANIZATION NAME"
                          }
                      ],
                      "text": "OATS - REFERRING ORGANIZATION NAME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "OrgOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYb-lNYyMLSVjOIOry-qMig4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYb-lNYyMLSVjOIOry-qMig4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fYb-lNYyMLSVjOIOry-qMig4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#277",
                              "display": "OATS REFERRING ORGANIZATION TYPE"
                          }
                      ],
                      "text": "OATS REFERRING ORGANIZATION TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "DIALYSIS CENTER"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2XIzuam7wDjymR9.70SV1g4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2XIzuam7wDjymR9.70SV1g4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f2XIzuam7wDjymR9.70SV1g4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#279",
                              "display": "OATS - CONSULTATION DATE"
                          }
                      ],
                      "text": "OATS - CONSULTATION DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-09-24"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fa2YHVSg23HokaRtpmP.4Fg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fa2YHVSg23HokaRtpmP.4Fg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fa2YHVSg23HokaRtpmP.4Fg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#284",
                              "display": "OATS - CONSULTATION COMMENTS"
                          }
                      ],
                      "text": "OATS - CONSULTATION COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing consultation comments "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fw2KyG5W8frBFmRQHvOGOSg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fw2KyG5W8frBFmRQHvOGOSg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fw2KyG5W8frBFmRQHvOGOSg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#285",
                              "display": "OATS - MEDICAL ASSESSMENT DATE"
                          }
                      ],
                      "text": "OATS - MEDICAL ASSESSMENT DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSqBNYzWgrIbXKomhWl9d8Q4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSqBNYzWgrIbXKomhWl9d8Q4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fSqBNYzWgrIbXKomhWl9d8Q4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#287",
                              "display": "OATS - MEDICAL ASSESSMENT DECISION"
                          }
                      ],
                      "text": "OATS - MEDICAL ASSESSMENT DECISION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Recipient to be Listed"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f45VwNXiOchwTqQQ5tDQvig4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f45VwNXiOchwTqQQ5tDQvig4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f45VwNXiOchwTqQQ5tDQvig4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#293",
                              "display": "OATS - MEDICAL ASSESSMENT COMMENTS"
                          }
                      ],
                      "text": "OATS - MEDICAL ASSESSMENT COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing medical assessment comments "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fyLiC3oNQuO5.flbtkU2NoA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fyLiC3oNQuO5.flbtkU2NoA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fyLiC3oNQuO5.flbtkU2NoA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#296",
                              "display": "OATS - STAGED KIDNEY"
                          }
                      ],
                      "text": "OATS - STAGED KIDNEY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIGZf1dNXZJMAiZ7-oDG2yA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIGZf1dNXZJMAiZ7-oDG2yA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fIGZf1dNXZJMAiZ7-oDG2yA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#297",
                              "display": "OATS - KPD PATIENT"
                          }
                      ],
                      "text": "OATS - KPD PATIENT"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/favdd-CaihhV4pVJtUJhiAA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/favdd-CaihhV4pVJtUJhiAA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "favdd-CaihhV4pVJtUJhiAA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#299",
                              "display": "OATS - LIST EXCHANGE PATIENT"
                          }
                      ],
                      "text": "OATS - LIST EXCHANGE PATIENT"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxoqMbZ5u2yC4tesDN8mtZg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxoqMbZ5u2yC4tesDN8mtZg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fxoqMbZ5u2yC4tesDN8mtZg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#300",
                              "display": "OATS - LIST EXCHANGE DATE"
                          }
                      ],
                      "text": "OATS - LIST EXCHANGE DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-30"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f9MKw7v6sARuNudB9Iop8zQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f9MKw7v6sARuNudB9Iop8zQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f9MKw7v6sARuNudB9Iop8zQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#301",
                              "display": "OATS - PREVIOUS LIVING DONOR"
                          }
                      ],
                      "text": "OATS - PREVIOUS LIVING DONOR"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fK-MGYI8MqSwpjNvoSq.8OQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fK-MGYI8MqSwpjNvoSq.8OQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fK-MGYI8MqSwpjNvoSq.8OQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#303",
                              "display": "OATS - PREVIOUS DONATION DATE"
                          }
                      ],
                      "text": "OATS - PREVIOUS DONATION DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-31"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fCooSroi6S0sc7HcMgOZVvg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fCooSroi6S0sc7HcMgOZVvg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fCooSroi6S0sc7HcMgOZVvg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#309",
                              "display": "OATS FOLLOWUP SOURCE INFORMATION"
                          }
                      ],
                      "text": "OATS FOLLOWUP SOURCE INFORMATION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkIeCuBwW7X6O93Sh8giIIA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkIeCuBwW7X6O93Sh8giIIA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fkIeCuBwW7X6O93Sh8giIIA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#314",
                              "display": "OATS FOLLOWUP CLINIC VISIT DATE"
                          }
                      ],
                      "text": "OATS FOLLOWUP CLINIC VISIT DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fh8Y8YTD8RqDVpk4iofbHbQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fh8Y8YTD8RqDVpk4iofbHbQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fh8Y8YTD8RqDVpk4iofbHbQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#317",
                              "display": "OATS RETURN TO DIALYSIS DATE"
                          }
                      ],
                      "text": "OATS RETURN TO DIALYSIS DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fawMXHrp7DSOLceAom8xvnw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fawMXHrp7DSOLceAom8xvnw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fawMXHrp7DSOLceAom8xvnw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#320",
                              "display": "OATS - DEMOGRAPHICS GENDER VS SEX"
                          }
                      ],
                      "text": "OATS - DEMOGRAPHICS GENDER VS SEX"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-07T14:39:54Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                    {
                      "code": {
                        "text": "Line 1"
                      },
                      "valueBoolean": true
                    }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGPETej3TGMU3pL9XveqOIg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGPETej3TGMU3pL9XveqOIg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fGPETej3TGMU3pL9XveqOIg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#323",
                              "display": "OATS - REFERRAL DETAILS - COMMENTS"
                          }
                      ],
                      "text": "OATS - REFERRAL DETAILS - COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Test "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJK4vVirmWM63M7wmX.mixw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJK4vVirmWM63M7wmX.mixw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fJK4vVirmWM63M7wmX.mixw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#325",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE ESTIMATED"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE ESTIMATED"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0jH0IJMOnl7w2JwyDdHXhw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0jH0IJMOnl7w2JwyDdHXhw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f0jH0IJMOnl7w2JwyDdHXhw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#326",
                              "display": "OATS GRAFT FUNCTION AT DEATH"
                          }
                      ],
                      "text": "OATS GRAFT FUNCTION AT DEATH"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Unknown"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIVycu4A2d615v8Eo1f0-dQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIVycu4A2d615v8Eo1f0-dQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fIVycu4A2d615v8Eo1f0-dQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#328",
                              "display": "OATS FOLLOWUP COMMENTS"
                          }
                      ],
                      "text": "OATS FOLLOWUP COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing post-transplant comments "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fpGbcJ5UaIlt2cnWYq8snIw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fpGbcJ5UaIlt2cnWYq8snIw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fpGbcJ5UaIlt2cnWYq8snIw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#330",
                              "display": "TXP DIALYSIS - DIALYSIS START DATE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS START DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-14"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fX8Nv6Jfld9qHZa9lAjeQDg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fX8Nv6Jfld9qHZa9lAjeQDg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fX8Nv6Jfld9qHZa9lAjeQDg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#331",
                              "display": "TXP DIALYSIS - DIALYSIS END DATE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS END DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-17"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fqYHEIsMGTeS0j5NQiKddnA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#334",
                              "display": "OATS REFERRAL DECISION"
                          }
                      ],
                      "text": "OATS REFERRAL DECISION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Referral Accepted"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYenN980Ym00-ubiZqAEhCg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYenN980Ym00-ubiZqAEhCg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fYenN980Ym00-ubiZqAEhCg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#335",
                              "display": "OATS REFERRAL DECISION DATE"
                          }
                      ],
                      "text": "OATS REFERRAL DECISION DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2024-07-23"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxdlSZYm1yXQQe3UX6g8bkg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxdlSZYm1yXQQe3UX6g8bkg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fxdlSZYm1yXQQe3UX6g8bkg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#337",
                              "display": "REFERRAL PRIMARY DIAGNOSIS"
                          }
                      ],
                      "text": "REFERRAL PRIMARY DIAGNOSIS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "AMYLOID"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGzKpZVWMcw.n8LqOQuLKWw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGzKpZVWMcw.n8LqOQuLKWw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fGzKpZVWMcw.n8LqOQuLKWw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#338",
                              "display": "REFERRAL PRIMARY DIAGNOSIS DATE"
                          }
                      ],
                      "text": "REFERRAL PRIMARY DIAGNOSIS DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2024-07-23"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTZIh7HwDy6IlVOXKpDs29w4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTZIh7HwDy6IlVOXKpDs29w4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fTZIh7HwDy6IlVOXKpDs29w4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#340",
                              "display": "OATS REFERRING PROVIDER TYPE"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "GENERAL SURGEON"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f4n5e2R3AQ98g4J.NNVZAbw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f4n5e2R3AQ98g4J.NNVZAbw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f4n5e2R3AQ98g4J.NNVZAbw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#341",
                              "display": "OATS REFERRING PROVIDER FIRST NAME"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER FIRST NAME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "NameOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fM1-INlKkzX0agFBewRaenA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fM1-INlKkzX0agFBewRaenA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fM1-INlKkzX0agFBewRaenA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#342",
                              "display": "OATS REFERRING PROVIDER LAST NAME"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER LAST NAME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "LastOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkpqOvat7x.2hahHw-g1ITg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkpqOvat7x.2hahHw-g1ITg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fkpqOvat7x.2hahHw-g1ITg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#343",
                              "display": "OATS DONOR CRITERIA ABO INCOMPATIBLE"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA ABO INCOMPATIBLE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f---pfiVbBXrLZZ2bOj5IDw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f---pfiVbBXrLZZ2bOj5IDw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f---pfiVbBXrLZZ2bOj5IDw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#345",
                              "display": "OATS DONOR CRITERIA A2 OR A2B"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA A2 OR A2B"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fd-e6RMSIj.k6epGJu2wGhQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fd-e6RMSIj.k6epGJu2wGhQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fd-e6RMSIj.k6epGJu2wGhQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#346",
                              "display": "OATS DONOR CRITERIA HCV NAT+"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA HCV NAT+"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fXEE7CfrACs5uginZmoyhXg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fXEE7CfrACs5uginZmoyhXg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fXEE7CfrACs5uginZmoyhXg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#347",
                              "display": "OATS DONOR CRITERIA HCV AB+"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA HCV AB+"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGTAxybcPbMmF6e0Ft4v0Vw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGTAxybcPbMmF6e0Ft4v0Vw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fGTAxybcPbMmF6e0Ft4v0Vw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#348",
                              "display": "OATS DONOR CRITERIA HEP B CORE AB+"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA HEP B CORE AB+"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frpP.9Tj9LzmtBFQyaK9XzA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frpP.9Tj9LzmtBFQyaK9XzA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "frpP.9Tj9LzmtBFQyaK9XzA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#349",
                              "display": "OATS DONOR CRITERIA EXTENDED CRITERIA DONOR (ECD)"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA EXTENDED CRITERIA DONOR (ECD)"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-026jFDg5NfF71jkcxnrQQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-026jFDg5NfF71jkcxnrQQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f-026jFDg5NfF71jkcxnrQQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#351",
                              "display": "OATS CONSULTATION TRANSPLANT PHYSICIAN"
                          }
                      ],
                      "text": "OATS CONSULTATION TRANSPLANT PHYSICIAN"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Jeff Zaltzman"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f79XbDZMrpFnJ.IGhwSaveA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f79XbDZMrpFnJ.IGhwSaveA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f79XbDZMrpFnJ.IGhwSaveA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#352",
                              "display": "OATS REFERRING PROVIDER ADDRESS"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER ADDRESS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "AddressOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f25V63huaxM0FexPWcLHF6Q4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f25V63huaxM0FexPWcLHF6Q4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f25V63huaxM0FexPWcLHF6Q4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#353",
                              "display": "OATS REFERRING PROVIDER CITY"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER CITY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "CityOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fEC3bziO.tvqnDoa5fqx2sA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fEC3bziO.tvqnDoa5fqx2sA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fEC3bziO.tvqnDoa5fqx2sA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#354",
                              "display": "OATS REFERRING PROVIDER COUNTRY"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER COUNTRY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "CANADA"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ffxlfqg0iw8TRO4Slvmcnyg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ffxlfqg0iw8TRO4Slvmcnyg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ffxlfqg0iw8TRO4Slvmcnyg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#355",
                              "display": "OATS REFERRING PROVIDER PROVINCE"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER PROVINCE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueCodeableConcept": {
                              "coding": [
                                  {
                                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.4.699080.50",
                                      "code": "58",
                                      "display": "Ontario"
                                  }
                              ],
                              "text": "Ontario"
                          }
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0p.R8bt-.mVW3x8.UT2yXg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0p.R8bt-.mVW3x8.UT2yXg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f0p.R8bt-.mVW3x8.UT2yXg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#356",
                              "display": "OATS REFERRING PROVIDER POSTAL CODE"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER POSTAL CODE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "L1L2L3"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fRdD26SPUCHICBz82O8QrGg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fRdD26SPUCHICBz82O8QrGg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fRdD26SPUCHICBz82O8QrGg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#357",
                              "display": "OATS DONOR CRITERIA PREFERRED DONOR TYPE"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA PREFERRED DONOR TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Deceased or Living Donor"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fPM896dVsaGWG4bA-II14eQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fPM896dVsaGWG4bA-II14eQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fPM896dVsaGWG4bA-II14eQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#359",
                              "display": "OATS BLOOD TYPE VERIFIED"
                          }
                      ],
                      "text": "OATS BLOOD TYPE VERIFIED"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-06T02:57:09Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fjfjDPe.lXW8pnZAwqNT6DQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fjfjDPe.lXW8pnZAwqNT6DQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fjfjDPe.lXW8pnZAwqNT6DQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#377",
                              "display": "OATS RECIPIENT STATUS"
                          }
                      ],
                      "text": "OATS RECIPIENT STATUS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Recipient death"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fLS9O5FTJowQE4.2tP.7gNQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fLS9O5FTJowQE4.2tP.7gNQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fLS9O5FTJowQE4.2tP.7gNQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#381",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fp6X.EKWV2OVGiuGubVdXOw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fp6X.EKWV2OVGiuGubVdXOw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fp6X.EKWV2OVGiuGubVdXOw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#383",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH CATEGORY"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH CATEGORY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "OTHER"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgZSrklcdPBN.2WM1erjnlA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgZSrklcdPBN.2WM1erjnlA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fgZSrklcdPBN.2WM1erjnlA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#386",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH TYPE OTHER"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH TYPE OTHER"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "other death"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkduZImqZR1Zgzrrp3iquCA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkduZImqZR1Zgzrrp3iquCA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fkduZImqZR1Zgzrrp3iquCA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#388",
                              "display": "OATS RECIPIENT DEATH DATA - DEATH DATE"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - DEATH DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feEFo86i0kqGssRCwOu2ijw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feEFo86i0kqGssRCwOu2ijw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "feEFo86i0kqGssRCwOu2ijw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#389",
                              "display": "OATS RECIPIENT DEATH DATA - DEATH DATE ESTIMATED"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - DEATH DATE ESTIMATED"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTWKMh4B-LwbVLRopMhJGew4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTWKMh4B-LwbVLRopMhJGew4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fTWKMh4B-LwbVLRopMhJGew4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#390",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH CATEGORY"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH CATEGORY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "OTHER"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fB8Yw7UVG0a3Sc0HgrTvSZQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fB8Yw7UVG0a3Sc0HgrTvSZQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fB8Yw7UVG0a3Sc0HgrTvSZQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#391",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feYjOGORRj1qx-36eyZRaAw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feYjOGORRj1qx-36eyZRaAw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "feYjOGORRj1qx-36eyZRaAw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#392",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE OTHER"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE OTHER"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "other death"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fcihOQFsqALYV.pawMuTY2g4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fcihOQFsqALYV.pawMuTY2g4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fcihOQFsqALYV.pawMuTY2g4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#393",
                              "display": "OATS RECIPIENT DEATH DATA - COMMENTS"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing recipient death comments"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKM4u1l0CO7AW3XK.d6IuxQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKM4u1l0CO7AW3XK.d6IuxQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fKM4u1l0CO7AW3XK.d6IuxQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#395",
                              "display": "OATS TRANSPLANT TYPE"
                          }
                      ],
                      "text": "OATS TRANSPLANT TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "RIGHT KIDNEY"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frfiOJ2orNaulWwwS9jjDew4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frfiOJ2orNaulWwwS9jjDew4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "frfiOJ2orNaulWwwS9jjDew4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#396",
                              "display": "OATS REMOVED FROM COLD"
                          }
                      ],
                      "text": "OATS REMOVED FROM COLD"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02T23:16:00Z"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIG8aWFGszO4eaWaGjXI3Og4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIG8aWFGszO4eaWaGjXI3Og4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fIG8aWFGszO4eaWaGjXI3Og4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#397",
                              "display": "OATS CLAMP REMOVAL"
                          }
                      ],
                      "text": "OATS CLAMP REMOVAL"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02T23:16:00Z"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-S0KvhLEqrnyRyuq8iDYPw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-S0KvhLEqrnyRyuq8iDYPw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f-S0KvhLEqrnyRyuq8iDYPw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#406",
                              "display": "OATS RETURN TO DIALYSIS"
                          }
                      ],
                      "text": "OATS RETURN TO DIALYSIS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          }
      ],
      [
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3",
              "resource": {
                  "resourceType": "EpisodeOfCare",
                  "id": "eBoTe.FFtYzhCAhiO-M2TbA3",
                  "extension": [
                      {
                          "valueString": "Kidney Transplant - 2/10/2025  (#1)",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
                      },
                      {
                          "valueCodeableConcept": {
                              "coding": [
                                  {
                                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                                      "code": "2",
                                      "display": "Recipient"
                                  }
                              ],
                              "text": "Recipient"
                          },
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
                      },
                      {
                          "extension": [
                              {
                                  "valueCodeableConcept": {
                                      "coding": [
                                          {
                                              "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                                              "code": "16",
                                              "display": "Kidney"
                                          }
                                      ],
                                      "text": "Kidney"
                                  },
                                  "url": "organ-class"
                              },
                              {
                                  "valueReference": {
                                      "reference": "Practitioner/el16FdtlssUCWMkeZfO2CMg3",
                                      "type": "Practitioner",
                                      "display": "Coordinator Phoenix, RN"
                                  },
                                  "url": "coordinator"
                              }
                          ],
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
                      },
                      {
                          "extension": [
                              {
                                  "valueCodeableConcept": {
                                      "coding": [
                                          {
                                              "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                                              "code": "50",
                                              "display": "Transplanted"
                                          }
                                      ],
                                      "text": "Transplanted"
                                  },
                                  "url": "phase"
                              },
                              {
                                  "valueString": "Active Follow-up",
                                  "url": "status"
                              },
                              {
                                  "valueDate": "2025-10-02",
                                  "url": "effective"
                              }
                          ],
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
                      },
                      {
                          "valueDate": "2025-08-05",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
                      },
                      {
                          "valuePeriod": {
                              "start": "2025-09-24",
                              "end": "2025-10-02"
                          },
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-evaluation"
                      },
                      {
                          "valueDate": "2025-10-02",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-center-waitlist-date"
                      },
                      {
                          "valueDate": "2025-10-02",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-waitlist-date"
                      },
                      {
                          "valueDate": "2025-10-02",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-transplanted-date"
                      },
                      {
                          "valueString": "St. Michael's Hospital (Toronto, ON)",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
                      }
                  ],
                  "status": "active",
                  "type": [
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.726668",
                                  "code": "49",
                                  "display": "Transplant"
                              },
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.4.726668.130",
                                  "code": "4",
                                  "display": "Transplant"
                              }
                          ],
                          "text": "Transplant"
                      }
                  ],
                  "patient": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "type": "Patient",
                      "display": "SMHOne, RecipientOne"
                  },
                  "period": {
                      "start": "2025-08-05"
                  },
                  "team": [
                      {
                          "reference": "CareTeam/e6YjTLfVn73.lWbazIyc1OfLJ1ja9HdjQ.4m.riSPdvw3",
                          "type": "CareTeam",
                          "display": "Care Team"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          }
      ],
      [
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e1-OlxqRWZlyiPGMfSGpMIG.nBxJLG1CdnTOvSW9PfDrkLVLj5ZEgbfLP1XlyebdiNgCulR2kZpTR7Bl3gJ-mww3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e1-OlxqRWZlyiPGMfSGpMIG.nBxJLG1CdnTOvSW9PfDrkLVLj5ZEgbfLP1XlyebdiNgCulR2kZpTR7Bl3gJ-mww3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e1-OlxqRWZlyiPGMfSGpMIG.nBxJLG1CdnTOvSW9PfDrkLVLj5ZEgbfLP1XlyebdiNgCulR2kZpTR7Bl3gJ-mww3",
                  "extension": [
                      {
                          "valueIdentifier": {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.707684",
                              "value": "395"
                          },
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/template-id"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "vital-signs",
                                  "display": "Vital Signs"
                              }
                          ],
                          "text": "Vital Signs"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.707679",
                              "code": "11",
                              "display": "Height"
                          },
                          {
                              "system": "http://open.epic.com/FHIR/StructureDefinition/observation-flowsheet-id",
                              "code": "tqIZ.9Xom.NjB5dsfS9O.Ow0",
                              "display": "Height"
                          },
                          {
                              "system": "urn:oid:1.2.246.537.6.96",
                              "code": "8302-2"
                          },
                          {
                              "system": "http://loinc.org",
                              "code": "8302-2",
                              "display": "Body height"
                          },
                          {
                              "system": "http://loinc.org",
                              "code": "8716-3",
                              "display": "Vital signs"
                          }
                      ],
                      "text": "Height"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2024-10-01T14:46:00Z",
                  "issued": "2025-08-06T02:47:23Z",
                  "performer": [
                      {
                          "reference": "Practitioner/enQJjyYC0qHEF4yABThitOQ3",
                          "display": "Sarah Chung"
                      }
                  ],
                  "valueQuantity": {
                      "value": 90,
                      "unit": "cm",
                      "system": "http://unitsofmeasure.org",
                      "code": "cm"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e1-OlxqRWZlyiPGMfSGpMIG.nBxJLG1CdnTOvSW9PfDo9ddh5dr34T8R-8jteN7lD2Ubw8Xi-HgpYC8.M1.mvsg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e1-OlxqRWZlyiPGMfSGpMIG.nBxJLG1CdnTOvSW9PfDo9ddh5dr34T8R-8jteN7lD2Ubw8Xi-HgpYC8.M1.mvsg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e1-OlxqRWZlyiPGMfSGpMIG.nBxJLG1CdnTOvSW9PfDo9ddh5dr34T8R-8jteN7lD2Ubw8Xi-HgpYC8.M1.mvsg3",
                  "extension": [
                      {
                          "valueIdentifier": {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.707684",
                              "value": "395"
                          },
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/template-id"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "vital-signs",
                                  "display": "Vital Signs"
                              }
                          ],
                          "text": "Vital Signs"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.707679",
                              "code": "14",
                              "display": "Weight"
                          },
                          {
                              "system": "http://open.epic.com/FHIR/StructureDefinition/observation-flowsheet-id",
                              "code": "t5Cn9FBZGCKy2gCB5bnkZtA0",
                              "display": "Weight"
                          },
                          {
                              "system": "urn:oid:1.2.246.537.6.96",
                              "code": "29463-7"
                          },
                          {
                              "system": "http://loinc.org",
                              "code": "29463-7",
                              "display": "Body weight"
                          },
                          {
                              "system": "http://loinc.org",
                              "code": "3141-9",
                              "display": "Body weight Measured"
                          },
                          {
                              "system": "http://loinc.org",
                              "code": "8716-3",
                              "display": "Vital signs"
                          }
                      ],
                      "text": "Weight"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2024-10-01T14:46:00Z",
                  "issued": "2025-08-06T02:47:23Z",
                  "performer": [
                      {
                          "reference": "Practitioner/enQJjyYC0qHEF4yABThitOQ3",
                          "display": "Sarah Chung"
                      }
                  ],
                  "valueQuantity": {
                      "value": 90,
                      "unit": "kg",
                      "system": "http://unitsofmeasure.org",
                      "code": "kg"
                  }
              },
              "search": {
                  "mode": "match"
              }
          }
      ],
      [
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeett5xbrQW8nKXPZs7ijMBtw4MQReuCYD2TIGnZ40VUBPFPrgFpE-KyORbErZpzb3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeett5xbrQW8nKXPZs7ijMBtw4MQReuCYD2TIGnZ40VUBPFPrgFpE-KyORbErZpzb3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eeett5xbrQW8nKXPZs7ijMBtw4MQReuCYD2TIGnZ40VUBPFPrgFpE-KyORbErZpzb3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ePWcZukcl3CvakNzY1K8.Oc1cPDrFlXm7SiYR0Yz3lGY3",
                          "display": "Hepatitis B Acute Infection"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "5195-3",
                              "display": "Hepatitis B virus surface Ag [Presence] in Serum"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "HBSAG"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "HBAG"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1551308"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "5195-3"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HEPATITIS B VIRUS SURFACE AG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "PLV13"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1551308",
                              "display": "Hepatitis B Surface Antigen"
                          }
                      ],
                      "text": "Hepatitis B Surface Antigen"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:14:36Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/eVkGmlR3Rx5655Bhh3U7h5Q3",
                      "display": "Specimen 25S-233C0001"
                  },
                  "referenceRange": [
                      {
                          "text": "Nonreactive"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eIr0-OP5iSIt4q.Zj.2fgjGgS9T3TmmGjfvYEn-fTLloyNO9ysvx-k7u4e4uNRU2L3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eIr0-OP5iSIt4q.Zj.2fgjGgS9T3TmmGjfvYEn-fTLloyNO9ysvx-k7u4e4uNRU2L3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eIr0-OP5iSIt4q.Zj.2fgjGgS9T3TmmGjfvYEn-fTLloyNO9ysvx-k7u4e4uNRU2L3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ePfLrb8Bugk9qhqwHqJap.7rhdvL8MfIjLtTeXEiUc-M3",
                          "display": "Hepatitis B Chronic Infection"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "5195-3",
                              "display": "Hepatitis B virus surface Ag [Presence] in Serum"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "HBSAG"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "HBAG"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1551308"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "5195-3"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HEPATITIS B VIRUS SURFACE AG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "PLV13"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1551308",
                              "display": "Hepatitis B Surface Antigen"
                          }
                      ],
                      "text": "Hepatitis B Surface Antigen"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:43:00Z",
                  "issued": "2025-08-20T18:49:26Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/eSZiNo5Xv7Y-iUeBhQc2CMA3",
                      "display": "Specimen 25S-232C0003"
                  },
                  "referenceRange": [
                      {
                          "text": "Nonreactive"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ezykgctlnASn05IHc9Z6qwAJ1QQaUGjx2jaxKh3-xUtptP84T-f9-e8TrYG-.YraB3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ezykgctlnASn05IHc9Z6qwAJ1QQaUGjx2jaxKh3-xUtptP84T-f9-e8TrYG-.YraB3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ezykgctlnASn05IHc9Z6qwAJ1QQaUGjx2jaxKh3-xUtptP84T-f9-e8TrYG-.YraB3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eeQwI6dztGI3giM225fSFdxv40GCiATH0tSWVuRPNCNc3",
                          "display": "Hepatitis B Core Antibody"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "13952-7",
                              "display": "Hepatitis B virus core Ab [Presence] in Serum or Plasma by Immunoassay"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "HBCT"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "HBCT"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1551494"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "13952-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Hepatitis B virus core Ab:ACnc:Pt:Ser:Ord:EIA"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "PLV18"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1551494",
                              "display": "Hepatitis B Core Total (IgG+IgM) Antibody"
                          }
                      ],
                      "text": "Hepatitis B Core Total (IgG+IgM) Antibody"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:46:00Z",
                  "issued": "2025-08-20T18:49:06Z",
                  "valueString": "Reactive",
                  "interpretation": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/v3-ObservationInterpretation",
                                  "code": "A",
                                  "display": "Abnormal"
                              }
                          ],
                          "text": "Abnormal"
                      }
                  ],
                  "specimen": {
                      "reference": "Specimen/ejRQHev1n95WqzM2rB3jFHg3",
                      "display": "Specimen 25S-232C0004"
                  },
                  "referenceRange": [
                      {
                          "text": "Nonreactive"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeett5xbrQW8nKXPZs7ijMBtw4MQReuCYD2TIGnZ40VVoqn3ZPCsD3R84JFO6IVVR3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeett5xbrQW8nKXPZs7ijMBtw4MQReuCYD2TIGnZ40VVoqn3ZPCsD3R84JFO6IVVR3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eeett5xbrQW8nKXPZs7ijMBtw4MQReuCYD2TIGnZ40VVoqn3ZPCsD3R84JFO6IVVR3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ePWcZukcl3CvakNzY1K8.Oc1cPDrFlXm7SiYR0Yz3lGY3",
                          "display": "Hepatitis B Acute Infection"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "22322-2",
                              "display": "Hepatitis B virus surface Ab [Presence] in Serum"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "HBAB"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1558020"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "22322-2"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HEPATITIS B VIRUS SURFACE AB:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1558020",
                              "display": "Hepatitis B Surface Antibody"
                          }
                      ],
                      "text": "Hepatitis B Surface Antibody"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:14:36Z",
                  "dataAbsentReason": {
                      "coding": [
                          {
                              "system": "http://terminology.hl7.org/CodeSystem/data-absent-reason",
                              "code": "unknown",
                              "display": "Unknown"
                          }
                      ],
                      "text": "No value exists"
                  },
                  "note": [
                      {
                          "text": "Non-Immune <10 IU/L\r\nImmune >=10 IU/L\r\n"
                      }
                  ],
                  "specimen": {
                      "reference": "Specimen/eVkGmlR3Rx5655Bhh3U7h5Q3",
                      "display": "Specimen 25S-233C0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
 
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "ezQyHkgeitIjgCmRY7LkbjTamKWFjE.Cc.US-.Ad.767lPmKWnvRFS1.f3rllVv4J3",
              "basedOn": [
                {
                  "reference": "ServiceRequest/eJLc0cVYCXn0hRIuqJ8tZbcnQKb7f2flHZa-mbil4jzs3",
                  "display": "Creatinine"
                }
              ],
              "status": "final",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                      "code": "laboratory",
                      "display": "Laboratory"
                    }
                  ],
                  "text": "Laboratory"
                },
                {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
                      "code": "Lab",
                      "display": "Lab"
                    }
                  ],
                  "text": "Lab"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30467",
                    "code": "CRV"
                  },
                  {
                    "system": "http://loinc.org",
                    "code": "14682-9",
                    "display": "Creatinine [Moles/volume] in Serum or Plasma"
                  },
                  
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
                    "code": "1526296"
                  },
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
                    "code": "1526296",
                    "display": "Creatinine"
                  }
                ],
                "text": "Creatinine"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "TestOne, VirologyOneWaitlist Kingthree"
              },
              "encounter": {
                "reference": "Encounter/eyfjhroUuSoubei8mEnpfsg3",
                "identifier": {
                  "use": "usual",
                  "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
                  "value": "200239102"
                },
                "display": "Appointment"
              },
              "effectiveDateTime": "2024-09-16T20:15:00Z",
              "issued": "2024-09-18T13:56:28Z",
              "valueQuantity": {
                "value": 50,
                "unit": "umol/L",
                "system": "http://unitsofmeasure.org",
                "code": "umol/L"
              },
              "specimen": {
                "reference": "Specimen/eVQxcpxJaoMOFEje2nfWh7nijLv7T8Mf9FtpSbcazIY83",
                "display": "Specimen 24SJC-260Y0005"
              },
              "referenceRange": [
                {
                  "low": {
                    "value": 49,
                    "unit": "umol/L",
                    "system": "http://unitsofmeasure.org",
                    "code": "umol/L"
                  },
                  "high": {
                    "value": 90,
                    "unit": "umol/L",
                    "system": "http://unitsofmeasure.org",
                    "code": "umol/L"
                  },
                  "text": "49 - 90 umol/L"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
              "link": [
                {
                  "relation": "self",
                  "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/eyr5.8VEROfm97kI1Ail-4Rmd5.sKuvM1ogNS5JzpogADMpFo0aBuAzh3RX9QibVL3"
                }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/eyr5.8VEROfm97kI1Ail-4Rmd5.sKuvM1ogNS5JzpogADMpFo0aBuAzh3RX9QibVL3",
              "resource": {
                "resourceType": "Observation",
                "id": "eyr5.8VEROfm97kI1Ail-4Rmd5.sKuvM1ogNS5JzpogADMpFo0aBuAzh3RX9QibVL3",
                "basedOn": [
                  {
                    "reference": "ServiceRequest/eBPSqpm5IvgHdbob-XqHb9Xzt34FzqkfSM9wNiFMmOtg3",
                    "display": "Hepatitis B Acute Infection"
                  }
                ],
                "status": "final",
                "category": [
                  {
                    "coding": [
                      {
                        "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                        "code": "laboratory",
                        "display": "Laboratory"
                      }
                    ],
                    "text": "Laboratory"
                  },
                  {
                    "coding": [
                      {
                        "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                        "code": "Lab",
                        "display": "Lab"
                      }
                    ],
                    "text": "Lab"
                  }
                ],
                "code": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.165",
                      "code": "16935-9"
                    },
                    {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                      "code": "9070",
                      "display": "Hepatitis B virus Surface antibody OLIS"
                    }
                  ],
                  "text": "Hepatitis B virus Surface antibody OLIS"
                },
                "subject": {
                  "reference": "Patient/eb73cp2bb9.y4qGd9yKCQVA3",
                  "display": "Unityp, Oatsrecipientsix"
                },
                "encounter": {
                  "reference": "Encounter/eczWj6vbqv5SBCbJaWQ3fLACv2YnN9UdPRIoPs3DZ4ZM3",
                  "identifier": {
                    "use": "usual",
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                    "value": "10000113231"
                  },
                  "display": "Documentation"
                },
                "effectiveDateTime": "2025-02-25T05:00:00Z",
                "issued": "2025-12-18T17:30:41Z",
                "valueQuantity": {
                  "value": 1000,
                  "comparator": ">"
                },
                "specimen": {
                  "reference": "Specimen/elAqSkfxhTqy9Oj.1M6p2ZTNpYlt9Xl68va.A5L4p.yw3",
                  "display": "Specimen"
                }
              },
              "search": {
                "mode": "match"
              }
            },
            {
              "link": [
                {
                  "relation": "self",
                  "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/ehjbhPFeRS2eJOhKMX3SV9zKGvlG3bEsZrKt5hhM-GAy8nA3PiDR.YM3ijKhB48pL3"
                }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/ehjbhPFeRS2eJOhKMX3SV9zKGvlG3bEsZrKt5hhM-GAy8nA3PiDR.YM3ijKhB48pL3",
              "resource": {
                "resourceType": "Observation",
                "id": "ehjbhPFeRS2eJOhKMX3SV9zKGvlG3bEsZrKt5hhM-GAy8nA3PiDR.YM3ijKhB48pL3",
                "basedOn": [
                  {
                    "reference": "ServiceRequest/eY.G6VdKbGu4RllqIrroQPhZyb1Gc9e2zkZd6NRpCDfA3",
                    "display": "Cytomegalovirus (CMV), Diagnostic Serology"
                  }
                ],
                "status": "final",
                "category": [
                  {
                    "coding": [
                      {
                        "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                        "code": "laboratory",
                        "display": "Laboratory"
                      }
                    ],
                    "text": "Laboratory"
                  },
                  {
                    "coding": [
                      {
                        "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                        "code": "Microbiology",
                        "display": "Microbiology"
                      }
                    ],
                    "text": "Microbiology"
                  }
                ],
                "code": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.165",
                      "code": "11008-0"
                    },
                    {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                      "code": "3273",
                      "display": "Cytomegalovirus antibody IgG OLIS"
                    }
                  ],
                  "text": "Cytomegalovirus antibody IgG OLIS"
                },
                "subject": {
                  "reference": "Patient/eb73cp2bb9.y4qGd9yKCQVA3",
                  "display": "Unityp, Oatsrecipientsix"
                },
                "encounter": {
                  "reference": "Encounter/eciZtjG4Ynj9a-u520JCdoEFM9ZJpV-SwrE5wfO4RoRw3",
                  "identifier": {
                    "use": "usual",
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                    "value": "10000113363"
                  },
                  "display": "Documentation"
                },
                "effectiveDateTime": "2026-01-05T05:00:00Z",
                "issued": "2026-01-05T18:55:15Z",
                "valueString": "Positive",
                "specimen": {
                  "reference": "Specimen/e3Y7ypGO9EbGz.GzT4LWvQqYkfK4mFqlPgrfdFgnwhHo3",
                  "display": "Specimen"
                }
              },
              "search": {
                "mode": "match"
              }
            },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eIr0-OP5iSIt4q.Zj.2fgjGgS9T3TmmGjfvYEn-fTLlqsQLvv7Qh-WFExAsqIvSUO3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eIr0-OP5iSIt4q.Zj.2fgjGgS9T3TmmGjfvYEn-fTLlqsQLvv7Qh-WFExAsqIvSUO3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eIr0-OP5iSIt4q.Zj.2fgjGgS9T3TmmGjfvYEn-fTLlqsQLvv7Qh-WFExAsqIvSUO3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ePfLrb8Bugk9qhqwHqJap.7rhdvL8MfIjLtTeXEiUc-M3",
                          "display": "Hepatitis B Chronic Infection"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "22322-2",
                              "display": "Hepatitis B virus surface Ab [Presence] in Serum"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "HBAB"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1558020"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "22322-2"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HEPATITIS B VIRUS SURFACE AB:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1558020",
                              "display": "Hepatitis B Surface Antibody"
                          }
                      ],
                      "text": "Hepatitis B Surface Antibody"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:43:00Z",
                  "issued": "2025-08-20T18:49:26Z",
                  "dataAbsentReason": {
                      "coding": [
                          {
                              "system": "http://terminology.hl7.org/CodeSystem/data-absent-reason",
                              "code": "unknown",
                              "display": "Unknown"
                          }
                      ],
                      "text": "No value exists"
                  },
                  "note": [
                      {
                          "text": "Non-Immune <10 IU/L\r\nImmune >=10 IU/L\r\n"
                      }
                  ],
                  "specimen": {
                      "reference": "Specimen/eSZiNo5Xv7Y-iUeBhQc2CMA3",
                      "display": "Specimen 25S-232C0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eHCsP2ilPvbE.we1el6iDM99G7XpMo2Us8ACUMGAn8k-xrjj8IuQ9mJzltCuYMyZF3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eHCsP2ilPvbE.we1el6iDM99G7XpMo2Us8ACUMGAn8k-xrjj8IuQ9mJzltCuYMyZF3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eHCsP2ilPvbE.we1el6iDM99G7XpMo2Us8ACUMGAn8k-xrjj8IuQ9mJzltCuYMyZF3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e9Z6HgdlGQmfrvB7.hME-qjRecLKelzDpIgV6zmNrkUk3",
                          "display": "Group and Screen"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABSC"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "TABSC"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "ABSC"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "ABSC"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "PABSC"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "MABSC"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "NABSN"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "890-4"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1631699"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABSC_INTEP"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Blood group antibody screen:PrThr:Pt:Ser/Plas:Ord"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1631699",
                              "display": "Antibody Screen"
                          }
                      ],
                      "text": "Antibody Screen"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-06T02:49:00Z",
                  "issued": "2025-08-06T02:51:56Z",
                  "valueString": "AB",
                  "specimen": {
                      "reference": "Specimen/e8qTwcBSD7LKWWR1eqqyXrg3",
                      "display": "Specimen 25M-217B0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eHCsP2ilPvbE.we1el6iDM6AbrKI0QM1tgXYxG7K1QbkpjlbkJ0GKcOlfWgtLn7Sj3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eHCsP2ilPvbE.we1el6iDM6AbrKI0QM1tgXYxG7K1QbkpjlbkJ0GKcOlfWgtLn7Sj3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eHCsP2ilPvbE.we1el6iDM6AbrKI0QM1tgXYxG7K1QbkpjlbkJ0GKcOlfWgtLn7Sj3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e9Z6HgdlGQmfrvB7.hME-qjRecLKelzDpIgV6zmNrkUk3",
                          "display": "Group and Screen"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "883-9",
                              "display": "ABO group [Type] in Blood"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "TABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "ABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "883-9"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1810065"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABO_INTEP"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "ABO GROUP:TYPE:PT:BLD:NOM"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1810065",
                              "display": "ABO"
                          }
                      ],
                      "text": "ABO"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-06T02:49:00Z",
                  "issued": "2025-08-06T02:51:56Z",
                  "valueString": "AB",
                  "specimen": {
                      "reference": "Specimen/e8qTwcBSD7LKWWR1eqqyXrg3",
                      "display": "Specimen 25M-217B0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ep-y4TEriJafoE3zaQfocPINRru4scC4iY2K0gcnQeqDMDCEZveMrQfHn8qpvN8HX3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ep-y4TEriJafoE3zaQfocPINRru4scC4iY2K0gcnQeqDMDCEZveMrQfHn8qpvN8HX3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ep-y4TEriJafoE3zaQfocPINRru4scC4iY2K0gcnQeqDMDCEZveMrQfHn8qpvN8HX3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eBnUSBLRX7gujIpIzU6C5nIAXnVbtzPwHZ9h0WquLy4Q3",
                          "display": "External ABO/Rh Results"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Blood Bank",
                                  "display": "Blood Bank"
                              }
                          ],
                          "text": "Blood Bank"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "883-9",
                              "display": "ABO group [Type] in Blood"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "TABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "ABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "883-9"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1810065"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABO_INTEP"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "ABO GROUP:TYPE:PT:BLD:NOM"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1810065",
                              "display": "ABO"
                          }
                      ],
                      "text": "ABO"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-05T04:00:00Z",
                  "issued": "2025-08-06T02:45:02Z",
                  "valueString": "AB",
                  "specimen": {
                      "reference": "Specimen/exzjcaL0oP1WOlfV1.GsQcFnq0A0lZQOiLcpvIfy6vGU3",
                      "display": "Specimen"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eG4UkvKVVW6WpyUQc7p3aDky7U1IPRzhww8KCrIb1Dyhyw0agG62PudKen1O42kiZ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eG4UkvKVVW6WpyUQc7p3aDky7U1IPRzhww8KCrIb1Dyhyw0agG62PudKen1O42kiZ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eG4UkvKVVW6WpyUQc7p3aDky7U1IPRzhww8KCrIb1Dyhyw0agG62PudKen1O42kiZ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eTBKrcF4sGTwXKaSxqHUfwMOC-pquDSUdLvkKYf4rBOM3",
                          "display": "External ABO/Rh Results"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Blood Bank",
                                  "display": "Blood Bank"
                              }
                          ],
                          "text": "Blood Bank"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "883-9",
                              "display": "ABO group [Type] in Blood"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "TABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "ABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "883-9"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1810065"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABO_INTEP"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "ABO GROUP:TYPE:PT:BLD:NOM"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1810065",
                              "display": "ABO"
                          }
                      ],
                      "text": "ABO"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-04T04:00:00Z",
                  "issued": "2025-08-06T02:44:12Z",
                  "valueString": "AB",
                  "specimen": {
                      "reference": "Specimen/eWz6HL7SgVO7IbG1jMI7Nw5RNdk23MbBVwEacCml0Gpc3",
                      "display": "Specimen"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eHCsP2ilPvbE.we1el6iDM6AbrKI0QM1tgXYxG7K1QbmlUvsMt3yh1kbuoZliZVrM3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eHCsP2ilPvbE.we1el6iDM6AbrKI0QM1tgXYxG7K1QbmlUvsMt3yh1kbuoZliZVrM3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eHCsP2ilPvbE.we1el6iDM6AbrKI0QM1tgXYxG7K1QbmlUvsMt3yh1kbuoZliZVrM3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e9Z6HgdlGQmfrvB7.hME-qjRecLKelzDpIgV6zmNrkUk3",
                          "display": "Group and Screen"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "1305-2",
                              "display": "D Ag [Presence] in Blood"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "RH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "TRH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "RH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "14908-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1810067"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "RH_INTEP"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Rh:Type:Pt:Bld^newborn:Nom"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1810067",
                              "display": "Rh"
                          }
                      ],
                      "text": "Rh"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-06T02:49:00Z",
                  "issued": "2025-08-06T02:51:56Z",
                  "valueString": "Positive",
                  "specimen": {
                      "reference": "Specimen/e8qTwcBSD7LKWWR1eqqyXrg3",
                      "display": "Specimen 25M-217B0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ep-y4TEriJafoE3zaQfocPINRru4scC4iY2K0gcnQeqBS7QQMgWBGkcFWXKMWZVWJ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ep-y4TEriJafoE3zaQfocPINRru4scC4iY2K0gcnQeqBS7QQMgWBGkcFWXKMWZVWJ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ep-y4TEriJafoE3zaQfocPINRru4scC4iY2K0gcnQeqBS7QQMgWBGkcFWXKMWZVWJ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eBnUSBLRX7gujIpIzU6C5nIAXnVbtzPwHZ9h0WquLy4Q3",
                          "display": "External ABO/Rh Results"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Blood Bank",
                                  "display": "Blood Bank"
                              }
                          ],
                          "text": "Blood Bank"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "1305-2",
                              "display": "D Ag [Presence] in Blood"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "RH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "TRH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "RH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "14908-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1810067"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "RH_INTEP"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Rh:Type:Pt:Bld^newborn:Nom"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1810067",
                              "display": "Rh"
                          }
                      ],
                      "text": "Rh"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-05T04:00:00Z",
                  "issued": "2025-08-06T02:45:02Z",
                  "valueString": "Positive",
                  "specimen": {
                      "reference": "Specimen/exzjcaL0oP1WOlfV1.GsQcFnq0A0lZQOiLcpvIfy6vGU3",
                      "display": "Specimen"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eG4UkvKVVW6WpyUQc7p3aDky7U1IPRzhww8KCrIb1DygmmWRw1CAg2K28R6kmUVWT3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eG4UkvKVVW6WpyUQc7p3aDky7U1IPRzhww8KCrIb1DygmmWRw1CAg2K28R6kmUVWT3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eG4UkvKVVW6WpyUQc7p3aDky7U1IPRzhww8KCrIb1DygmmWRw1CAg2K28R6kmUVWT3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eTBKrcF4sGTwXKaSxqHUfwMOC-pquDSUdLvkKYf4rBOM3",
                          "display": "External ABO/Rh Results"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Blood Bank",
                                  "display": "Blood Bank"
                              }
                          ],
                          "text": "Blood Bank"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "1305-2",
                              "display": "D Ag [Presence] in Blood"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "RH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "TRH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "RH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "14908-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1810067"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "RH_INTEP"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Rh:Type:Pt:Bld^newborn:Nom"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1810067",
                              "display": "Rh"
                          }
                      ],
                      "text": "Rh"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-04T04:00:00Z",
                  "issued": "2025-08-06T02:44:12Z",
                  "valueString": "Positive",
                  "specimen": {
                      "reference": "Specimen/eWz6HL7SgVO7IbG1jMI7Nw5RNdk23MbBVwEacCml0Gpc3",
                      "display": "Specimen"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJwKrWZTVT03vs-9Dvq8yWl7kr74vAy22ZSHeY9mhx1LA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJwKrWZTVT03vs-9Dvq8yWl7kr74vAy22ZSHeY9mhx1LA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJwKrWZTVT03vs-9Dvq8yWl7kr74vAy22ZSHeY9mhx1LA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eLwDP-vrzQTpX9DgOc5amZrioC6.x3Dnfzz55Ygs13J03",
                          "display": "HIV Serology - Routine Diagnosis"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:56Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/etYHbZgIFadX42lGGkMUTFg3",
                      "display": "Specimen 25X-233P0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygIjmeKkNSKddSPqwrJbZ2Ty6YhmF3U4bgVqc-jT07.Yw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygIjmeKkNSKddSPqwrJbZ2Ty6YhmF3U4bgVqc-jT07.Yw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygIjmeKkNSKddSPqwrJbZ2Ty6YhmF3U4bgVqc-jT07.Yw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/elGh9ZQj9IXx1qDUkc0XhpXbri3Kx5dnpMSkpf5KeoAM3",
                          "display": "Toxoplasma gondii, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:41Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/eQB.U2qNPkHQ8ilSk6Dbxnw3",
                      "display": "Specimen 25X-233P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTdkgCOYmwvT55Z3Afg1j.4g4VeqBvKiAOgIzUZllhBXw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTdkgCOYmwvT55Z3Afg1j.4g4VeqBvKiAOgIzUZllhBXw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTdkgCOYmwvT55Z3Afg1j.4g4VeqBvKiAOgIzUZllhBXw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXxZGI2v5J9rRqfCXKabPlOM-E1wW8S2QLUwM76L7A0tYA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXxZGI2v5J9rRqfCXKabPlOM-E1wW8S2QLUwM76L7A0tYA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXxZGI2v5J9rRqfCXKabPlOM-E1wW8S2QLUwM76L7A0tYA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e4pzGl2fGWpXd8jldclC810YXkfTTTY9GXPIODaK9QZY3",
                          "display": "Herpes Simplex (HSV) 1 & 2, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:15:31Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLWTtdei2MiRpOEE-083aRHY-t4gNo1tAhKTQmOJK1P3DQ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLWTtdei2MiRpOEE-083aRHY-t4gNo1tAhKTQmOJK1P3DQ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLWTtdei2MiRpOEE-083aRHY-t4gNo1tAhKTQmOJK1P3DQ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eIQMSG8iBJD9fMPR0PY-nsU.zwMpPDgtLSKnGObIjcpA3",
                          "display": "Epstein-Barr Virus (EBV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:11Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5HqRz07ksVeEEhpUi1MMK2C2ft3ypMdHKqsFTdxsf8MXA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5HqRz07ksVeEEhpUi1MMK2C2ft3ypMdHKqsFTdxsf8MXA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5HqRz07ksVeEEhpUi1MMK2C2ft3ypMdHKqsFTdxsf8MXA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ebDFLIZilG4hKKqqtM5ilSYV1aCI8UP2zH1hB1NCZXWM3",
                          "display": "Mumps, Immunity Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:14:56Z",
                  "valueQuantity": {
                      "value": 1234556
                  },
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXLL0RmPxu6BKvCD6JvEcnLSFkKUdbFzj5kxlJnigc-shg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXLL0RmPxu6BKvCD6JvEcnLSFkKUdbFzj5kxlJnigc-shg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXLL0RmPxu6BKvCD6JvEcnLSFkKUdbFzj5kxlJnigc-shg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eAqo09SexQagGhha8eAKkw4oFTpdrnDdY4Xlg4lhgeas3",
                          "display": "Measles, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:11Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza0jRcBePaIMBkPQT56AtCxgtaIp34bnZivTKXektvvOEg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza0jRcBePaIMBkPQT56AtCxgtaIp34bnZivTKXektvvOEg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza0jRcBePaIMBkPQT56AtCxgtaIp34bnZivTKXektvvOEg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eX4wg7PnM.CXpETHbEwyF8QnG56FcHd-zGU94uPwf4ew3",
                          "display": "Hepatitis C, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:41Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.McNIJzchmaoHWRlQW6pZPFQRuadRq9gzVRR-uubVxk0Q3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.McNIJzchmaoHWRlQW6pZPFQRuadRq9gzVRR-uubVxk0Q3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.McNIJzchmaoHWRlQW6pZPFQRuadRq9gzVRR-uubVxk0Q3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfhAbPLeTLtL4EO59NXgm7iUnpRvgIlO7gDfZUeVYw83",
                          "display": "Rubella, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:48:31Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqBVavhsBz7Vl2BI4ErsmC1nctvaBBWD1p3OCTvam91fUg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqBVavhsBz7Vl2BI4ErsmC1nctvaBBWD1p3OCTvam91fUg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqBVavhsBz7Vl2BI4ErsmC1nctvaBBWD1p3OCTvam91fUg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfso70fdYJL3Gb3Pbo6mogoR5vL8L9dNi9PD-5bm-U03",
                          "display": "Varicella-Zoster Virus (VZV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:49:41Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCvH.XBhmUrLNNwA9o1L2eeSe7KUiZt8duG7vocKJneahA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCvH.XBhmUrLNNwA9o1L2eeSe7KUiZt8duG7vocKJneahA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCvH.XBhmUrLNNwA9o1L2eeSe7KUiZt8duG7vocKJneahA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eYWJ86ouL84fxt4TzBllaBxBw78gdCovhQO2LFE1aCMM3",
                          "display": "HTLV I and II, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:41Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "note": [
                      {
                          "text": "Previously Final Verified Results Added"
                      }
                  ],
                  "specimen": {
                      "reference": "Specimen/e8QxLw2Wr3fRyjxy4gJPNMA3",
                      "display": "Specimen 25X-232P0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdqhIFg1pk54us84ccpjSj90JFSFdfVdtGIu8QbC9okP.w3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdqhIFg1pk54us84ccpjSj90JFSFdfVdtGIu8QbC9okP.w3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdqhIFg1pk54us84ccpjSj90JFSFdfVdtGIu8QbC9okP.w3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/en0CidtqqPlhWhF78Gz72qvq3ir4912xgWNSuPjEPoVg3",
                          "display": "Cytomegalovirus (CMV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:01Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpm7KK29muTzetgLHy4G3OhH910y4KhPafvg37kFUyh7Q3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpm7KK29muTzetgLHy4G3OhH910y4KhPafvg37kFUyh7Q3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpm7KK29muTzetgLHy4G3OhH910y4KhPafvg37kFUyh7Q3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/en0CidtqqPlhWhF78Gz72qvq3ir4912xgWNSuPjEPoVg3",
                          "display": "Cytomegalovirus (CMV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071384"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "22244-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "CYTOMEGALOVIRUS AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071384",
                              "display": "Cytomegalovirus IgG CLIA"
                          }
                      ],
                      "text": "Cytomegalovirus IgG CLIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:01Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                {
                  "relation": "self",
                  "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/eDIt2N3wFe5abF2J8QW9xxVbmPHlSUeznNFPiZgLtLT8.K3wAPbH1zFzpNNrPXL4N3"
                }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/eDIt2N3wFe5abF2J8QW9xxVbmPHlSUeznNFPiZgLtLT8.K3wAPbH1zFzpNNrPXL4N3",
              "resource": {
                "resourceType": "Observation",
                "id": "eDIt2N3wFe5abF2J8QW9xxVbmPHlSUeznNFPiZgLtLT8.K3wAPbH1zFzpNNrPXL4N3",
                "basedOn": [
                  {
                    "reference": "ServiceRequest/ewg.SQoTDaIplJv-4B5y4ba.Xsc8d4wW83Z6LRk3nksI3",
                    "display": "Varicella-Zoster Virus (VZV), Diagnostic Serology"
                  }
                ],
                "status": "final",
                "category": [
                  {
                    "coding": [
                      {
                        "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                        "code": "laboratory",
                        "display": "Laboratory"
                      }
                    ],
                    "text": "Laboratory"
                  },
                  {
                    "coding": [
                      {
                        "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                        "code": "Microbiology",
                        "display": "Microbiology"
                      }
                    ],
                    "text": "Microbiology"
                  }
                ],
                "code": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.165",
                      "code": "21594-7"
                    },
                    {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                      "code": "12822",
                      "display": "Varicella-zoster virus antibody OLIS"
                    }
                  ],
                  "text": "Varicella-zoster virus antibody OLIS"
                },
                "subject": {
                  "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                  "display": "SITSix, SITSix SITMIDDLESIX"
                },
                "encounter": {
                  "reference": "Encounter/eaIzbITSKPAVKHOe8sOT1Net2NHD3VpZmA-0HYKR27yQ3",
                  "identifier": {
                    "use": "usual",
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                    "value": "10000112148"
                  },
                  "display": "Orders Only"
                },
                "effectiveDateTime": "2025-10-21T01:41:00Z",
                "issued": "2025-10-21T01:46:43Z",
                "valueString": "Nonreactive",
                "specimen": {
                  "reference": "Specimen/eErTiRuXFLOYu-PFkedf-ViVIZM5sFzHLSyIq24ySAwU3",
                  "display": "Specimen"
                }
              },
              "search": {
                "mode": "match"
              }
            },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpTMwrwfODKHkwEr6AeJkssf3l0iz6tE.-2Q5GZ07E-Qw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpTMwrwfODKHkwEr6AeJkssf3l0iz6tE.-2Q5GZ07E-Qw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpTMwrwfODKHkwEr6AeJkssf3l0iz6tE.-2Q5GZ07E-Qw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/en0CidtqqPlhWhF78Gz72qvq3ir4912xgWNSuPjEPoVg3",
                          "display": "Cytomegalovirus (CMV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071385"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30325-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "CYTOMEGALOVIRUS AB.IGM:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071385",
                              "display": "Cytomegalovirus IgM EIA"
                          }
                      ],
                      "text": "Cytomegalovirus IgM EIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:01Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLV4HM8nidfKEMczAXpG64nmEBvnZ7YsWmsNSGv-fIKhyg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLV4HM8nidfKEMczAXpG64nmEBvnZ7YsWmsNSGv-fIKhyg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLV4HM8nidfKEMczAXpG64nmEBvnZ7YsWmsNSGv-fIKhyg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eIQMSG8iBJD9fMPR0PY-nsU.zwMpPDgtLSKnGObIjcpA3",
                          "display": "Epstein-Barr Virus (EBV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "24114-1"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++24114-1"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071386"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071386",
                              "display": "Epstein Barr Virus VCA IgG MFI"
                          }
                      ],
                      "text": "Epstein Barr Virus VCA IgG MFI"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:11Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLXUrYrJFjm1IXby4g9aTvXzYy280Ie5GUSUmPUnGM.79g3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLXUrYrJFjm1IXby4g9aTvXzYy280Ie5GUSUmPUnGM.79g3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLXUrYrJFjm1IXby4g9aTvXzYy280Ie5GUSUmPUnGM.79g3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eIQMSG8iBJD9fMPR0PY-nsU.zwMpPDgtLSKnGObIjcpA3",
                          "display": "Epstein-Barr Virus (EBV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "7883-2"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "EPSTEIN BARR VIRUS NUCLEAR AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071387"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071387",
                              "display": "Epstein Barr Virus EBNA IgG MFI"
                          }
                      ],
                      "text": "Epstein Barr Virus EBNA IgG MFI"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:11Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLXh4adD5GTaLG4EatEavshgrazbb8huf4bb3kJZJUWPPg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLXh4adD5GTaLG4EatEavshgrazbb8huf4bb3kJZJUWPPg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLXh4adD5GTaLG4EatEavshgrazbb8huf4bb3kJZJUWPPg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eIQMSG8iBJD9fMPR0PY-nsU.zwMpPDgtLSKnGObIjcpA3",
                          "display": "Epstein-Barr Virus (EBV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071388"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "24115-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++24115-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071388",
                              "display": "Epstein Barr Virus VCA IgM MFI"
                          }
                      ],
                      "text": "Epstein Barr Virus VCA IgM MFI"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:11Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza3uEv0JILQeyH674qSwd7FSoghSOzCMEEdC7pojLVNePQ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza3uEv0JILQeyH674qSwd7FSoghSOzCMEEdC7pojLVNePQ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza3uEv0JILQeyH674qSwd7FSoghSOzCMEEdC7pojLVNePQ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eX4wg7PnM.CXpETHbEwyF8QnG56FcHd-zGU94uPwf4ew3",
                          "display": "Hepatitis C, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071400"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "16128-1"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HEPATITIS C VIRUS AB:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071400",
                              "display": "Hepatitis C Antibody"
                          }
                      ],
                      "text": "Hepatitis C Antibody"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:41Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNKXSYoW7QYDEQaLdD5am5rpFnyJlwIiAQLKuffrz9gYmA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNKXSYoW7QYDEQaLdD5am5rpFnyJlwIiAQLKuffrz9gYmA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNKXSYoW7QYDEQaLdD5am5rpFnyJlwIiAQLKuffrz9gYmA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eLwDP-vrzQTpX9DgOc5amZrioC6.x3Dnfzz55Ygs13J03",
                          "display": "HIV Serology - Routine Diagnosis"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071407"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON12263-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HIV 1+2 Ab+Ag:ACnc:Pt:Ser:Ord"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071407",
                              "display": "HIV-1/HIV-2 Ag/Ab Combo Screen"
                          }
                      ],
                      "text": "HIV-1/HIV-2 Ag/Ab Combo Screen"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:56Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/etYHbZgIFadX42lGGkMUTFg3",
                      "display": "Specimen 25X-233P0001"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCvavJ.YbTzWsHCFEO9jCgrh.9UcreZSiPhiIHU9.qlBdA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCvavJ.YbTzWsHCFEO9jCgrh.9UcreZSiPhiIHU9.qlBdA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCvavJ.YbTzWsHCFEO9jCgrh.9UcreZSiPhiIHU9.qlBdA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eYWJ86ouL84fxt4TzBllaBxBw78gdCovhQO2LFE1aCMM3",
                          "display": "HTLV I and II, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071408"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "16982-1"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HTLV 1+2 Ab:ACnc:Pt:Ser:Ord:IB"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071408",
                              "display": "HTLV I/II Antibody Screen"
                          }
                      ],
                      "text": "HTLV I/II Antibody Screen"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:41Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e8QxLw2Wr3fRyjxy4gJPNMA3",
                      "display": "Specimen 25X-232P0001"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXLXY7eGJuUXB5G3CHZZw02XPVsTNpf7jeBYoISYsl1tLw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXLXY7eGJuUXB5G3CHZZw02XPVsTNpf7jeBYoISYsl1tLw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXLXY7eGJuUXB5G3CHZZw02XPVsTNpf7jeBYoISYsl1tLw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eAqo09SexQagGhha8eAKkw4oFTpdrnDdY4Xlg4lhgeas3",
                          "display": "Measles, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071411"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "20479-2"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "MEASLES VIRUS AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071411",
                              "display": "Measles IgG MFI"
                          }
                      ],
                      "text": "Measles IgG MFI"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:11Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXJhPq9dDziPe7zwNWzJneCyWaNeh8E43ImJhC-gmN0xHw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXJhPq9dDziPe7zwNWzJneCyWaNeh8E43ImJhC-gmN0xHw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXJhPq9dDziPe7zwNWzJneCyWaNeh8E43ImJhC-gmN0xHw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eAqo09SexQagGhha8eAKkw4oFTpdrnDdY4Xlg4lhgeas3",
                          "display": "Measles, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071412"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "21503-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "MEASLES VIRUS AB.IGM:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071412",
                              "display": "Measles IgM MFI"
                          }
                      ],
                      "text": "Measles IgM MFI"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:11Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.O1apVdvBzq0ceUOvprvgUMXsg8zQtrnVvH7VS8A9gVRA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.O1apVdvBzq0ceUOvprvgUMXsg8zQtrnVvH7VS8A9gVRA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.O1apVdvBzq0ceUOvprvgUMXsg8zQtrnVvH7VS8A9gVRA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfhAbPLeTLtL4EO59NXgm7iUnpRvgIlO7gDfZUeVYw83",
                          "display": "Rubella, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071424"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "25514-1"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "RUBELLA VIRUS AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071424",
                              "display": "Rubella IgG EIA"
                          }
                      ],
                      "text": "Rubella IgG EIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:48:31Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.N-lyySKpovmInVs0pBHUHLXs.odoIDY3cPNsHjQNKl5Q3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.N-lyySKpovmInVs0pBHUHLXs.odoIDY3cPNsHjQNKl5Q3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.N-lyySKpovmInVs0pBHUHLXs.odoIDY3cPNsHjQNKl5Q3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfhAbPLeTLtL4EO59NXgm7iUnpRvgIlO7gDfZUeVYw83",
                          "display": "Rubella, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071425"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "31616-6"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "RUBELLA VIRUS AB.IGM:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071425",
                              "display": "Rubella IgM EIA"
                          }
                      ],
                      "text": "Rubella IgM EIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:48:31Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRCiwVPnWk8l.zfnc7ij0MFWYXwOZGC9mmvnlyvBJCHvg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRCiwVPnWk8l.zfnc7ij0MFWYXwOZGC9mmvnlyvBJCHvg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRCiwVPnWk8l.zfnc7ij0MFWYXwOZGC9mmvnlyvBJCHvg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071429"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "22587-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Treponema pallidum Ab:PrThr:Pt:Ser:Ord"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071429",
                              "display": "Syphilis Antibody screen"
                          }
                      ],
                      "text": "Syphilis Antibody screen"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJQJ3khv3WFZGIcvwJ99-WD3p3EVvFrGbw.hqw5k4VChZw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJQJ3khv3WFZGIcvwJ99-WD3p3EVvFrGbw.hqw5k4VChZw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJQJ3khv3WFZGIcvwJ99-WD3p3EVvFrGbw.hqw5k4VChZw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071430"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "41122-3"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "TREPONEMA PALLIDUM AB:ACNC:PT:XXX:QN"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071430",
                              "display": "Syphilis RPR Quantitation"
                          }
                      ],
                      "text": "Syphilis RPR Quantitation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRshHFi76UYFcf72cl93WN8WiaXKI4OxIMBJIqs1WmZyw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRshHFi76UYFcf72cl93WN8WiaXKI4OxIMBJIqs1WmZyw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRshHFi76UYFcf72cl93WN8WiaXKI4OxIMBJIqs1WmZyw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071431"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "24312-1"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Treponema pallidum Ab:ACnc:Pt:Ser:Ord:Aggl"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071431",
                              "display": "Syphilis TP.PA"
                          }
                      ],
                      "text": "Syphilis TP.PA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQyhQl-AxEGvVGbdy820owLFvyd-1DbgToi1YKaNI9Qe1aA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQyhQl-AxEGvVGbdy820owLFvyd-1DbgToi1YKaNI9Qe1aA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQyhQl-AxEGvVGbdy820owLFvyd-1DbgToi1YKaNI9Qe1aA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/elGh9ZQj9IXx1qDUkc0XhpXbri3Kx5dnpMSkpf5KeoAM3",
                          "display": "Toxoplasma gondii, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071433"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "22580-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "TOXOPLASMA GONDII AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071433",
                              "display": "Toxoplasmosis IgG CLIA"
                          }
                      ],
                      "text": "Toxoplasmosis IgG CLIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:41Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/eQB.U2qNPkHQ8ilSk6Dbxnw3",
                      "display": "Specimen 25X-233P0002"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygUwbOaACSZBj9FJKxeTn7k3on1GNSYmAQpsrKcBc72Eg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygUwbOaACSZBj9FJKxeTn7k3on1GNSYmAQpsrKcBc72Eg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygUwbOaACSZBj9FJKxeTn7k3on1GNSYmAQpsrKcBc72Eg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/elGh9ZQj9IXx1qDUkc0XhpXbri3Kx5dnpMSkpf5KeoAM3",
                          "display": "Toxoplasma gondii, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071434"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "8040-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "TOXOPLASMA GONDII AB.IGM:ACNC:PT:SER:QN"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071434",
                              "display": "Toxoplasmosis IgM CLIA"
                          }
                      ],
                      "text": "Toxoplasmosis IgM CLIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:41Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/eQB.U2qNPkHQ8ilSk6Dbxnw3",
                      "display": "Specimen 25X-233P0002"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqAyxfnC4bkjjoVhEehx6atf.9gm-kqEmFhm94jYCoWFPQ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqAyxfnC4bkjjoVhEehx6atf.9gm-kqEmFhm94jYCoWFPQ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqAyxfnC4bkjjoVhEehx6atf.9gm-kqEmFhm94jYCoWFPQ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfso70fdYJL3Gb3Pbo6mogoR5vL8L9dNi9PD-5bm-U03",
                          "display": "Varicella-Zoster Virus (VZV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071436"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "21597-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "VARICELLA ZOSTER VIRUS AB.IGM:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071436",
                              "display": "Varicella-Zoster IgM"
                          }
                      ],
                      "text": "Varicella-Zoster IgM"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:49:41Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdqhrni0KGlwS0qiQNfxXX4mwzhdGY-.XJvsbcU5jX7pmA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdqhrni0KGlwS0qiQNfxXX4mwzhdGY-.XJvsbcU5jX7pmA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdqhrni0KGlwS0qiQNfxXX4mwzhdGY-.XJvsbcU5jX7pmA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/en0CidtqqPlhWhF78Gz72qvq3ir4912xgWNSuPjEPoVg3",
                          "display": "Cytomegalovirus (CMV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071444"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071444",
                              "display": "CMV Interpretation"
                          }
                      ],
                      "text": "CMV Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:01Z",
                  "valueString": "No evidence of past exposure; indicates susceptibility.",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpkU4g15V9rUIsT1umdK2oxIGaR4LhHn-fE6XsfoSFLtg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpkU4g15V9rUIsT1umdK2oxIGaR4LhHn-fE6XsfoSFLtg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpkU4g15V9rUIsT1umdK2oxIGaR4LhHn-fE6XsfoSFLtg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/en0CidtqqPlhWhF78Gz72qvq3ir4912xgWNSuPjEPoVg3",
                          "display": "Cytomegalovirus (CMV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071445"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "77202-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Laboratory comment:Txt:Pt:Report:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071445",
                              "display": "CMV Note"
                          }
                      ],
                      "text": "CMV Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:01Z",
                  "valueString": "Results to be interpreted in the context of the clinical history, signs and symptoms of the patient.\r\n",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLVyIfNp-AHgeZ3jZOpi9a1NwANA8epjYTitGoHTvJEINg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLVyIfNp-AHgeZ3jZOpi9a1NwANA8epjYTitGoHTvJEINg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLVyIfNp-AHgeZ3jZOpi9a1NwANA8epjYTitGoHTvJEINg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eIQMSG8iBJD9fMPR0PY-nsU.zwMpPDgtLSKnGObIjcpA3",
                          "display": "Epstein-Barr Virus (EBV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071448"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071448",
                              "display": "Epstein Barr Virus Interpretation"
                          }
                      ],
                      "text": "Epstein Barr Virus Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:11Z",
                  "valueString": "No laboratory evidence of recent/past EBV infection.",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza1XWx1bDGMonihTx60MY-8YmQJvhYiuN1hEglCx7lU8FQ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza1XWx1bDGMonihTx60MY-8YmQJvhYiuN1hEglCx7lU8FQ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza1XWx1bDGMonihTx60MY-8YmQJvhYiuN1hEglCx7lU8FQ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eX4wg7PnM.CXpETHbEwyF8QnG56FcHd-zGU94uPwf4ew3",
                          "display": "Hepatitis C, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071457"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071457",
                              "display": "Hepatitis C Interpretation"
                          }
                      ],
                      "text": "Hepatitis C Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:41Z",
                  "valueString": "No evidence of HCV Antibody",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJK-wdc8xJ1RnwK8xK5ezgxNKy28AuxTh9BVWBCIuW3lA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJK-wdc8xJ1RnwK8xK5ezgxNKy28AuxTh9BVWBCIuW3lA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJK-wdc8xJ1RnwK8xK5ezgxNKy28AuxTh9BVWBCIuW3lA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eLwDP-vrzQTpX9DgOc5amZrioC6.x3Dnfzz55Ygs13J03",
                          "display": "HIV Serology - Routine Diagnosis"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071461"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON13032-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HIV final interpretation:Imp:Pt:XXX:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071461",
                              "display": "HIV Final Interpretation"
                          }
                      ],
                      "text": "HIV Final Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:56Z",
                  "valueString": "Non-reactive for HIV-1 p24 antigen and HIV-1/HIV-2 antibodies.\r\n",
                  "specimen": {
                      "reference": "Specimen/etYHbZgIFadX42lGGkMUTFg3",
                      "display": "Specimen 25X-233P0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJXwCMX0x.14C7SKKx8wzDetLshANnXx1gzV.4ZH5k9ww3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJXwCMX0x.14C7SKKx8wzDetLshANnXx1gzV.4ZH5k9ww3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJXwCMX0x.14C7SKKx8wzDetLshANnXx1gzV.4ZH5k9ww3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eLwDP-vrzQTpX9DgOc5amZrioC6.x3Dnfzz55Ygs13J03",
                          "display": "HIV Serology - Routine Diagnosis"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071462"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Comment:Imp:XXX:XXX:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON12722-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071462",
                              "display": "HIV Final Note"
                          }
                      ],
                      "text": "HIV Final Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:56Z",
                  "valueString": "For high-risk exposures, repeat HIV testing at 3 weeks and, if negative, at 6 weeks after possible exposure, or on presentation of symptoms compatible with acute HIV infection.\r\n",
                  "specimen": {
                      "reference": "Specimen/etYHbZgIFadX42lGGkMUTFg3",
                      "display": "Specimen 25X-233P0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCu1kzB.e1zmUJAjE2fdDCubi6NWrcO3z98VoV8vhsWMOw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCu1kzB.e1zmUJAjE2fdDCubi6NWrcO3z98VoV8vhsWMOw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCu1kzB.e1zmUJAjE2fdDCubi6NWrcO3z98VoV8vhsWMOw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eYWJ86ouL84fxt4TzBllaBxBw78gdCovhQO2LFE1aCMM3",
                          "display": "HTLV I and II, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071463"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON13563-2"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Interpretation:Imp:Pt:XXX:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071463",
                              "display": "HTLV I/II Final Interpretation"
                          }
                      ],
                      "text": "HTLV I/II Final Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:41Z",
                  "valueString": "No HTLV I / II antibodies detected.",
                  "specimen": {
                      "reference": "Specimen/e8QxLw2Wr3fRyjxy4gJPNMA3",
                      "display": "Specimen 25X-232P0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXL.8SncssMZsELakHhPZ5zKb7V3pwOVRejrunELXFVHtw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXL.8SncssMZsELakHhPZ5zKb7V3pwOVRejrunELXFVHtw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXL.8SncssMZsELakHhPZ5zKb7V3pwOVRejrunELXFVHtw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eAqo09SexQagGhha8eAKkw4oFTpdrnDdY4Xlg4lhgeas3",
                          "display": "Measles, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071465"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071465",
                              "display": "Measles Interpretation"
                          }
                      ],
                      "text": "Measles Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:11Z",
                  "valueString": "No serological evidence of recent or past Measles infection. If clinically indicated, please submit a new sample to monitor for any significant change in antibody level.",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXIdad2VmMs5b-t4CiqAeS6j84ifkiFmqY0lIos-9IpCfw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXIdad2VmMs5b-t4CiqAeS6j84ifkiFmqY0lIos-9IpCfw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXIdad2VmMs5b-t4CiqAeS6j84ifkiFmqY0lIos-9IpCfw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eAqo09SexQagGhha8eAKkw4oFTpdrnDdY4Xlg4lhgeas3",
                          "display": "Measles, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071466"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON12722-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Comment:Imp:XXX:XXX:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071466",
                              "display": "Measles Note"
                          }
                      ],
                      "text": "Measles Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:11Z",
                  "valueString": "Results to be interpreted in the context of the clinical history, signs and symptoms of the patient.",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5FVxz.71UUVdWo9H4KXzmgEqgWcXQsB0L4soF8Z6LQjGA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5FVxz.71UUVdWo9H4KXzmgEqgWcXQsB0L4soF8Z6LQjGA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5FVxz.71UUVdWo9H4KXzmgEqgWcXQsB0L4soF8Z6LQjGA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ebDFLIZilG4hKKqqtM5ilSYV1aCI8UP2zH1hB1NCZXWM3",
                          "display": "Mumps, Immunity Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071467"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10842-3"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION:IMP:Pt:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071467",
                              "display": "Mumps Interpretation"
                          }
                      ],
                      "text": "Mumps Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:14:56Z",
                  "valueString": "No evidence of immunity (indicates susceptibility)",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5FNPavE2TFh4NI3hNZp2LLgsqIGzaDLbPXA.EfPWzVAuA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5FNPavE2TFh4NI3hNZp2LLgsqIGzaDLbPXA.EfPWzVAuA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5FNPavE2TFh4NI3hNZp2LLgsqIGzaDLbPXA.EfPWzVAuA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ebDFLIZilG4hKKqqtM5ilSYV1aCI8UP2zH1hB1NCZXWM3",
                          "display": "Mumps, Immunity Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071468"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "77202-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Laboratory comment:Txt:Pt:Report:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071468",
                              "display": "Mumps Note"
                          }
                      ],
                      "text": "Mumps Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:14:56Z",
                  "valueString": "Results to be interpreted in the context of the clinical history, signs and symptoms of the patient. For assistance regarding the interpretation of specific IgG and IgM serology refer to Public Health Labstract Diagnostic Interpretation of Viral Specific IgM and IgG  Serology Lab-SD-044 at: http:www.publichealthontario.ca/Labstracts",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.NW-vOFVXVDbmVOr47aHCCLGBe9vnWnBdsyFD0sepI91g3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.NW-vOFVXVDbmVOr47aHCCLGBe9vnWnBdsyFD0sepI91g3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.NW-vOFVXVDbmVOr47aHCCLGBe9vnWnBdsyFD0sepI91g3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfhAbPLeTLtL4EO59NXgm7iUnpRvgIlO7gDfZUeVYw83",
                          "display": "Rubella, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071473"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071473",
                              "display": "Rubella Interpretation"
                          }
                      ],
                      "text": "Rubella Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:48:31Z",
                  "valueString": "No serological evidence of recent or past Rubella infection. If clinically indicated, please submit a new sample to monitor for any significant change in antibody level.",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.MjxteVujqcP.wz3.IO69zUTse3xR-SlBpSyhG9hnJcAQ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.MjxteVujqcP.wz3.IO69zUTse3xR-SlBpSyhG9hnJcAQ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.MjxteVujqcP.wz3.IO69zUTse3xR-SlBpSyhG9hnJcAQ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfhAbPLeTLtL4EO59NXgm7iUnpRvgIlO7gDfZUeVYw83",
                          "display": "Rubella, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071474"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071474",
                              "display": "Rubella Note"
                          }
                      ],
                      "text": "Rubella Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:48:31Z",
                  "valueString": "Results to be interpreted in the context of the clinical history, signs and symptoms of the patient.",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTueg1kgc-rweHZtgqM7LtaoHa-GVW2SGyu2piyv.k1tQ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTueg1kgc-rweHZtgqM7LtaoHa-GVW2SGyu2piyv.k1tQ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTueg1kgc-rweHZtgqM7LtaoHa-GVW2SGyu2piyv.k1tQ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071477"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071477",
                              "display": "Syphilis Serology Interpretation"
                          }
                      ],
                      "text": "Syphilis Serology Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueString": "No serological evidence of current or past infection.",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRKKDkh.dVR7.Vl-DmBMoNg64FhDuzMcshJc2j.kEOyrg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRKKDkh.dVR7.Vl-DmBMoNg64FhDuzMcshJc2j.kEOyrg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRKKDkh.dVR7.Vl-DmBMoNg64FhDuzMcshJc2j.kEOyrg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071478"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "77202-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Laboratory comment:Txt:Pt:Report:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071478",
                              "display": "Syphilis Serology Note"
                          }
                      ],
                      "text": "Syphilis Serology Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueString": "No confirmatory testing is performed on samples with non-reactive screening results. If not done already, repeat syphilis serology testing is recommended in 4 weeks for individuals suspected of syphilis infection or re-infection.",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygnhd8jaDM0u9dSTsL2V1VJiJ5eZYXGcQze98Xto4WPCA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygnhd8jaDM0u9dSTsL2V1VJiJ5eZYXGcQze98Xto4WPCA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygnhd8jaDM0u9dSTsL2V1VJiJ5eZYXGcQze98Xto4WPCA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/elGh9ZQj9IXx1qDUkc0XhpXbri3Kx5dnpMSkpf5KeoAM3",
                          "display": "Toxoplasma gondii, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071479"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071479",
                              "display": "Toxoplasmosis Interpretation"
                          }
                      ],
                      "text": "Toxoplasmosis Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:41Z",
                  "valueString": "No serological evidence of recent or past Toxoplasma gondii infection.",
                  "specimen": {
                      "reference": "Specimen/eQB.U2qNPkHQ8ilSk6Dbxnw3",
                      "display": "Specimen 25X-233P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQyja4EbNsPUUAkz58GzveZyNpzk-xTMYLJN4d7kUoEODdg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQyja4EbNsPUUAkz58GzveZyNpzk-xTMYLJN4d7kUoEODdg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQyja4EbNsPUUAkz58GzveZyNpzk-xTMYLJN4d7kUoEODdg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/elGh9ZQj9IXx1qDUkc0XhpXbri3Kx5dnpMSkpf5KeoAM3",
                          "display": "Toxoplasma gondii, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071480"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "77202-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Laboratory comment:Txt:Pt:Report:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071480",
                              "display": "Toxoplasmosis Note"
                          }
                      ],
                      "text": "Toxoplasmosis Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:41Z",
                  "valueString": "Results should be interpreted in conjunction with clinical history, signs and symptoms.",
                  "specimen": {
                      "reference": "Specimen/eQB.U2qNPkHQ8ilSk6Dbxnw3",
                      "display": "Specimen 25X-233P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqCQNcYeG85fym5kj0BV.57UhsG6SXQbr2HLN03.ZdT9EQ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqCQNcYeG85fym5kj0BV.57UhsG6SXQbr2HLN03.ZdT9EQ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqCQNcYeG85fym5kj0BV.57UhsG6SXQbr2HLN03.ZdT9EQ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfso70fdYJL3Gb3Pbo6mogoR5vL8L9dNi9PD-5bm-U03",
                          "display": "Varicella-Zoster Virus (VZV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071481"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071481",
                              "display": "Varicella-Zoster Interpretation"
                          }
                      ],
                      "text": "Varicella-Zoster Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:49:41Z",
                  "valueString": "No serological evidence of recent or past Varicella-Zoster infection. If clinically indicated, please submit a new sample to monitor for any significant change in antibody level.",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqDhZDGi28c-k3AH-fY9-.VPp8vs5EMTqF6Ii4aF2HbZlA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqDhZDGi28c-k3AH-fY9-.VPp8vs5EMTqF6Ii4aF2HbZlA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqDhZDGi28c-k3AH-fY9-.VPp8vs5EMTqF6Ii4aF2HbZlA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfso70fdYJL3Gb3Pbo6mogoR5vL8L9dNi9PD-5bm-U03",
                          "display": "Varicella-Zoster Virus (VZV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071482"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "77202-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Laboratory comment:Txt:Pt:Report:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071482",
                              "display": "Varicella-Zoster Note"
                          }
                      ],
                      "text": "Varicella-Zoster Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:49:41Z",
                  "valueString": "Results to be interpreted in the context of the clinical history, signs and symptoms of the patient.",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5EPCYY0WNslK0Sgsl4Aq7Ok2JQvmT2lerD4Bu5CpcRaYg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5EPCYY0WNslK0Sgsl4Aq7Ok2JQvmT2lerD4Bu5CpcRaYg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5EPCYY0WNslK0Sgsl4Aq7Ok2JQvmT2lerD4Bu5CpcRaYg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ebDFLIZilG4hKKqqtM5ilSYV1aCI8UP2zH1hB1NCZXWM3",
                          "display": "Mumps, Immunity Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "22415-4"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071488"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "MUMPS VIRUS AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071488",
                              "display": "Mumps IgG MFI"
                          }
                      ],
                      "text": "Mumps IgG MFI"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:14:56Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqCcbwVMrck5M85xfmVNjlqHGNfNpJmK7V2e7qi6q8mqJg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqCcbwVMrck5M85xfmVNjlqHGNfNpJmK7V2e7qi6q8mqJg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqCcbwVMrck5M85xfmVNjlqHGNfNpJmK7V2e7qi6q8mqJg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfso70fdYJL3Gb3Pbo6mogoR5vL8L9dNi9PD-5bm-U03",
                          "display": "Varicella-Zoster Virus (VZV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123120003"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "19162-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "VARICELLA ZOSTER VIRUS AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123120003",
                              "display": "Varicella-Zoster IgG"
                          }
                      ],
                      "text": "Varicella-Zoster IgG"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:49:41Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza1NXYtnNr2iCwQLInDLFwjb18vL.zUmpPyt8YAeW.zEyw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza1NXYtnNr2iCwQLInDLFwjb18vL.zUmpPyt8YAeW.zEyw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza1NXYtnNr2iCwQLInDLFwjb18vL.zUmpPyt8YAeW.zEyw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eX4wg7PnM.CXpETHbEwyF8QnG56FcHd-zGU94uPwf4ew3",
                          "display": "Hepatitis C, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1230300203"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON13050-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Hepatitis C virus Ab supplemental:ACnc:Pt:Ser:Ord"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1230300203",
                              "display": "Hepatitis C Antibody Supplemental"
                          }
                      ],
                      "text": "Hepatitis C Antibody Supplemental"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:41Z",
                  "valueString": "Nonreactive",
                  "note": [
                      {
                          "text": "HCV RNA reflex testing is performed on: \r\n1) First-time reactive HCV antibody results to determine active/current infection.\r\n2) Patients with a previous Positive HCV antibody result with no history of HCV RNA testing\r\n3) Inconclusive HCV antibody results. \r\nFor other HCV RNA requests, submit a serum specimen for HCV RNA testing Following PHOL recommended guidelines found at publichealthontario.ca/HepCRNA."
                      }
                  ],
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRz-qLeRQUzUahICQtnr.osHOhMZMmFqeJ49Xun1Pb4oA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRz-qLeRQUzUahICQtnr.osHOhMZMmFqeJ49Xun1Pb4oA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRz-qLeRQUzUahICQtnr.osHOhMZMmFqeJ49Xun1Pb4oA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1231200001"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "5393-4"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Treponema pallidum Ab:ACnc:Pt:Ser:Ord:IF"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1231200001",
                              "display": "Syphilis FTA Abs"
                          }
                      ],
                      "text": "Syphilis FTA Abs"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTCdzCIiWZxgm3wv3ayzWTtceKWzjlR7FjWzRYmjTcg0A3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTCdzCIiWZxgm3wv3ayzWTtceKWzjlR7FjWzRYmjTcg0A3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTCdzCIiWZxgm3wv3ayzWTtceKWzjlR7FjWzRYmjTcg0A3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1231200002"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "20507-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Reagin Ab:ACnc:Pt:Ser:Ord:RPR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1231200002",
                              "display": "Syphilis RPR Screen"
                          }
                      ],
                      "text": "Syphilis RPR Screen"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXyv4pw23KRHDEy6FoFLiDlj8TLIsS8BacqC77RBMTZ12w3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXyv4pw23KRHDEy6FoFLiDlj8TLIsS8BacqC77RBMTZ12w3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXyv4pw23KRHDEy6FoFLiDlj8TLIsS8BacqC77RBMTZ12w3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e4pzGl2fGWpXd8jldclC810YXkfTTTY9GXPIODaK9QZY3",
                          "display": "Herpes Simplex (HSV) 1 & 2, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1232701021"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "17850-9"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HERPES SIMPLEX VIRUS 1 AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1232701021",
                              "display": "Herpes Simplex Virus 1 IgG CLIA"
                          }
                      ],
                      "text": "Herpes Simplex Virus 1 IgG CLIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:15:31Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXwuNf-RT8VNI4jkQqfUGXixMqlftbZH11JTOlqa7nxDLg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXwuNf-RT8VNI4jkQqfUGXixMqlftbZH11JTOlqa7nxDLg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXwuNf-RT8VNI4jkQqfUGXixMqlftbZH11JTOlqa7nxDLg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e4pzGl2fGWpXd8jldclC810YXkfTTTY9GXPIODaK9QZY3",
                          "display": "Herpes Simplex (HSV) 1 & 2, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1232701022"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "17851-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HERPES SIMPLEX VIRUS 2 AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1232701022",
                              "display": "Herpes Simplex Virus 2 IgG CLIA"
                          }
                      ],
                      "text": "Herpes Simplex Virus 2 IgG CLIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:15:31Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXwlA84pZo3NT8Rb.MSr74L32fx.3jthe8yS01e1BFkVtg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXwlA84pZo3NT8Rb.MSr74L32fx.3jthe8yS01e1BFkVtg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXwlA84pZo3NT8Rb.MSr74L32fx.3jthe8yS01e1BFkVtg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e4pzGl2fGWpXd8jldclC810YXkfTTTY9GXPIODaK9QZY3",
                          "display": "Herpes Simplex (HSV) 1 & 2, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1232701023"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1232701023",
                              "display": "Herpes Simplex Virus Interpretation"
                          }
                      ],
                      "text": "Herpes Simplex Virus Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:15:31Z",
                  "valueString": "Herpes Simplex Virus 1 IgG and Herpes Simplex Virus 2 IgG antibodies not detected.",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXzHWKyWheQ56cjB40B6oE2eMejIGAQviy-SSnf6ROp7ZA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXzHWKyWheQ56cjB40B6oE2eMejIGAQviy-SSnf6ROp7ZA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXzHWKyWheQ56cjB40B6oE2eMejIGAQviy-SSnf6ROp7ZA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e4pzGl2fGWpXd8jldclC810YXkfTTTY9GXPIODaK9QZY3",
                          "display": "Herpes Simplex (HSV) 1 & 2, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1232701024"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON12722-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Comment:Imp:XXX:XXX:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1232701024",
                              "display": "Herpes Simplex Virus Note"
                          }
                      ],
                      "text": "Herpes Simplex Virus Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:15:31Z",
                  "valueString": "Note: Early antiviral therapy following acute HSV infection may result in a blunted or delayed IgG antibody response. The absence of detectable HSV IgG antibodies may not rule out recent HSV infection. If a recent HSV infection is suspected and has not been confirmed by virus detection (e.g. culture), a follow-up blood sample should be submitted 3-6 months post-exposure to detect the late development of HSV antibodies. Diagnosis of HSV infection is best performed by culture of the virus from vesicular fluid or lesion scrapings.",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          }
      ]
  ],
  "sectionsChecked": [],
  "episode_id": "eBoTe.FFtYzhCAhiO-M2TbA3"
}
export {
  mock_recipient_episodes_of_care,
  mock_donor_episodes_of_care,
  mock_donor_and_recipient_EOC,
  mock_patient,
  mock_patient_bundle,
  mock_patient_RAM,
  mock_patient_SMHOne,
  mock_patient_SMHTwo,
  mock_patient_SMHThree,
  mock_patient_SMHFour,
  initialDataMock3
};
